
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire46cb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire46cb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("lEx3p", function(module, exports) {
module.exports = JSON.parse('{"404-title":"Crush - Not found","404-not-found-1":"Not found","404-not-found-2":"Sorry, the page you are looking for is not available.","navbar-mission":"Mission","navbar-download":"Download","footer-follow":"Follow us","footer-follow-1":"Instagram","footer-follow-2":"TikTok","footer-follow-3":"Twitter","footer-follow-4":"LinkdIn","footer-docs":"Docs","footer-docs-1":"Mission","footer-docs-2":"Legal notice","footer-docs-3":"Privacy","footer-docs-4":"Cookies","footer-docs-5":"Guidelines","footer-contact":"Contact us","footer-contact-1":"Support","footer-contact-2":"Jobs","footer-contact-3":"Investors","home-title":"Crush - Where media meets platonic","home-hero-slogan-1":"Where media","home-hero-slogan-2":"meets platonic \u2122","home-concept-1":"Find your people","home-concept-2":"Connect with people like you at the different stages of your life.","home-concept-3":"Cool vibes","home-concept-4":"Embrace cool vibes and real moments. We steer clear of toxicity and pretense.","home-attributes-1":"Aesthetic","home-attributes-2":"We promote the publication of aesthetic and high-quality content; the web is already flooded with cat photos.","home-attributes-3":"Stalker","home-attributes-4":"Your friends are the stars. Take a few bursts of photos when they are off guard and post some GIFs on their accounts.","home-attributes-5":"Threads","home-attributes-6":"Engage in vibrant discussions spanning today\'s most pressing topics to the trends that will shape tomorrow.","home-attributes-7":"Twins","home-attributes-8":"Connect with individuals who share facial features akin to yours, amplifying your social network in an entirely novel and funny way.","home-attributes-9":"Age segmented","home-attributes-10":"By grouping users by age, similar to high school classes, connections are limited to individuals of the same generation for a safer and efficient interaction.","home-attributes-11":"Crush","home-attributes-12":"Not a dating app \u2014 just friends and relaxed relationships. Recapture the nostalgia of high school connections in a digital environment.","home-partners":"Powered By","mission-title":"Crush - Mission","mission-date":"Last updated: December 8, 2023","mission-header":"Mission and values","mission-introduction":"In the heart of Crush beats something more than just a simple social network; it\'s a universe woven with ethical values, a philosophy, and a purpose. This document is the journey through the foundations of our vision, from the birth of the idea to the meticulous outline of the creation we are forging.","mission-origin":"The origin","mission-origin-1":"The origin of Crush dates back to a seed sown long before its concrete development in 2020 and its launch in 2023. Our vision to merge social networks with Crush\'s distinctive touch was conceived in 2016, inspired by \'The Social Network\', the notable cinematic work recognized by Quentin Tarantino as a gem of the past decade. This film, which tells the story of the young founders of Facebook, particularly its most recognized figure, Mark Zuckerberg \u2014 the father of social networks, provided us with an enlightening perspective.","mission-origin-2":"In Crush, we fervently believe that the core of today\'s social networks resides in platonic love. If you\'ve had the chance to watch this movie, you may have picked up on Zuckerberg and Eduardo Saverin\'s criticisms towards dating apps. In a key scene, around the 30:00-minute mark, during the Winklevoss brothers\' lawsuit for alleged idea theft, Saverin mentions:","mission-origin-3":"\\"It really hadn\'t much to do with the Winklevoss\' dating site\\".","mission-origin-4":"It\'s curious because a few minutes later, around the 36:05-minute mark, we see Mark implementing elements like relationship status and interests in his project:","mission-origin-5":"\\"Relationship status, interests... This is what drives life in college. Are you having sex or aren\'t you? That\'s why people take classes, sit where they sit, and do what they do. It\'s the center, you know? That\'s what The Facebook is going to be.\\".","mission-origin-6":"Finally, in the final scene, we witness a lovestruck Zuckerberg sending a friend request to his crush.","mission-origin-7":"This movie poses an intriguing question:","mission-origin-8":"Are social media platforms actually disguised dating apps?","mission-purpose":"Our purpose","mission-purpose-1":"There is no definitive answer to the question raised in the previous section. Perhaps yes, perhaps no... in the end, it depends on the ethical and cultural values, intentions, and education of the end-user. What we do know for sure is that this opens the door to real and very serious problems that, unlike in the real world, can indeed be solved.","mission-purpose-2":"Whether by the standards pre-established by society or the anonymity that leads to inappropriate behavior online, love in the digital realm, whether it\'s platonic and genuine on social media or more romantic on dating apps, has unfortunately been sexualized in recent years. Why is something so beautiful and fundamental in our lives being distorted in this parallel universe?","mission-purpose-3":"Let\'s be clear and completely transparent. In Spain, our home country, according to verifiable data and statistics,","mission-purpose-4":"7 out of 10 minors under the age of 15 have a mobile device.","mission-purpose-5":"This means that around 70% of minors have unrestricted access to a virtual world where interaction with adults has not been regulated or restricted, exposing them to risks such as harassment, bullying, or pedophilia, among others.","mission-purpose-6":"Currently, regardless of the social network you sign up for, it\'s common to find people selling inappropriate content or sharing any type of unsuitable content. The situation is getting worse as time goes by.","mission-purpose-7":"We aim to eliminate the sexualization and toxicity of the network by addressing its origin directly.","mission-purpose-8":"Crush is proposed as a redefinition of social networks from a different perspective, focusing on platonic relationships.","mission-purpose-9":"We don\'t offer a dating system or the creation of romantic/serious relationships, as that contradicts our","mission-purpose-10":"community guidelines.","mission-purpose-11":"Instead, we offer what was envisioned in the movie \'The Social Network\', but with a solution to the problem and a cool approach.","mission-purpose-12":"Our mission goes beyond the typical \\"share real moments\\" or \\"we help you connect\\". In addition to accompanying the user through the various stages of their life, we are dedicated to solving the aforementioned issues. On our platform, as of the drafting of this document, it is already impossible for a minor to interact with an adult (and vice versa), not only to close the doors to these ethical issues but also to encourage the creation of bonds between people of the same generation, with a similar mindset. We plan to introduce more effective solutions in the next decade of development; that\'s our promise.","guidelines-title":"Crush - Guidelines","guidelines-date":"Last updated: April 4, 2024","guidelines-header":"Community guidelines","guidelines-introduction-1":"In Crush, it\'s about establishing platonic connections, sharing authentic life moments with friends, socializing, and creating new friendships that align with your mindset. We strongly believe in freedom of expression, but we also value the ability to distinguish between right and wrong. This document outlines the standards of our social network, essential to fulfilling","guidelines-introduction-2":"our core purpose.","guidelines-introduction-3":"We expect appropriate behavior, careful content, authenticity, humility, and above all, responsibility. Any violation of our principles could result in the permanent suspension of your account, with no possibility of re-registering in our system.","guidelines-introduction-4":"Just as in real life, there are consequences for actions. Please respect our rules and do not use our system in ways contrary to the law. We want to emphasize our seriousness and rigor; a playful tone is not welcome in this context.","guidelines-dating":"Anti-dating","guidelines-dating-1":"Crush is a merge of social networks suitable for all individuals","guidelines-dating-2":"aged 15 and above, ","guidelines-dating-3":"whether or not in a romantic relationship. Don\'t confuse friends and platonic relationships (optional) with romantic relationships or real commitments.","guidelines-dating-4":"Next, we outline a series of behaviors you must adopt and respect to stay on our platform:","guidelines-dating-5":"Do not use our service to seek or request romantic encounters.","guidelines-dating-6":"If love comes into your life, let it not be through a screen.","guidelines-dating-7":"Don\'t post dirty stuff.","guidelines-dating-8":"Don\'t harass or bother any user.","guidelines-dating-9":"Don\'t lie about your age or personal information, let alone impersonate someone else.","guidelines-dating-10":"It\'s a serious crime that could result in legal actions against you.","guidelines-content":"Aesthetic","guidelines-content-1":"For us, any form of software is art, and art must be respected. In a social network, the platform\'s quality is reflected in the content users generate. In our case, we encourage creativity and inspiration. We ask you to publish while maintaining a minimum standard of quality.","guidelines-content-2":"Don\'t post visually poor content.","guidelines-content-3":"Make an effort.","guidelines-content-4":"Spam is an immediate removal.","guidelines-content-5":"If you want to promote your Instagram, use the tools we provide for that.","guidelines-content-6":"Don\'t share content that infringes on others\' intellectual property.","guidelines-content-7":"Please, avoid posting pictures of kittens;","guidelines-content-8":"the internet is already flooded with them.","guidelines-content-9":"Don\'t embarrass yourself by posting unnecessary nudity.","guidelines-content-10":"We\'re tired of shirtless photos.","guidelines-vibes":"Good vibes only","guidelines-vibes-1":"At Crush, we don\'t tolerate inappropriate behavior. Just as you maintain your image in real life, we ask you to be responsible and uphold that integrity online. Show courtesy and respect to both the users of our community and the platform\'s creators.","guidelines-vibes-2":"Child exploitation, sextortion, or any other type of abuse, in any form, is strictly prohibited.","guidelines-vibes-3":"Our commitment against suicide and self-harm is absolute.","guidelines-vibes-4":"Any content that promotes, encourages, or glorifies these actions will result in a permanent suspension.","guidelines-vibes-5":"We take legality seriously.","guidelines-vibes-6":"Avoid sharing content that promotes illegal activities, as well as any content related to weapons or drugs.","guidelines-vibes-7":"Offensive or violent content has no place on our platform and is not allowed.","guidelines-vibes-8":"The Stalker mode is meant for fun among friends.","guidelines-vibes-9":"However, even if the content ultimately requires approval from the user(s) in the GIF, avoid sharing photos of your friends without their prior consent.","legal-title":"Crush - Legal notice","legal-date":"Last updated: April 4, 2024","legal-header":"Legal notice","legal-introduction-1":"Every application is a universe, and all universes are subject to rules. In this document, you will find the legal notice and the general terms of use of our platform, which are complemented by those defined in our","legal-introduction-2":"community guidelines.","legal-owner":"1. Owner identification","legal-owner-1":"The website www.crushsocialnetwork.com (hereinafter, the","legal-owner-2":"\'Website\'","legal-owner-3":") and the mobile application for Smartphones with the name \'Crush\' (hereinafter, the","legal-owner-4":"\'App\'","legal-owner-5":") are owned by CRUSH SOCIAL NETWORK, LTD., provided with NIF: B-72599830 and registered in the Mercantile Registry of Valencia with the following registry data: T. 3606, F.75, I.1, H. MU-108656, and whose contact details are:","legal-owner-6":"Registered Office:","legal-owner-7":"Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Spain)","legal-owner-8":"Contact email:","legal-area":"2. Area of application","legal-area-1":"These General Conditions of Use of the Website (hereinafter, the","legal-area-2":"\'Terms of Use\'","legal-area-3":") include the terms and conditions that regulate access, navigation and use of the Website and the App.","legal-area-4":"In this sense, the access, use and browsing of the Website and the App confers the condition of user(s) (hereinafter, the","legal-area-5":"\'User\'","legal-area-6":"or","legal-area-7":"\'Users\'","legal-area-8":"), and implies the acceptance of each and every one of these Conditions of Use. The User is fully aware that the mere browsing of the Website or the App implies acceptance of these Conditions of Use and, therefore, if the User does not agree with them, they should not use the Website or this App.","legal-area-9":"The Website and the App are mainly aimed at Users residing in Spain. Crush does not ensure that the Website or the App comply with the laws of other countries, either totally or partially. If the User resides or is domiciled elsewhere and decides to access and/or browse the Website or access or use the App, they will do so at their own risk and must ensure that such access, browsing or use complies with their local legislation, Crush not assuming any responsibility that may arise from such access or use.","legal-area-10":"Crush may, at any time and without notice, modify these Terms of Use, which will be published as such modifications occur.","legal-conditions":"3. Conditions of access and use","legal-conditions-1":"Access to the Website or the App by the User, as a general rule, is free. In the event that there are functionalities or services reserved for certain Users or that it is necessary to pay a price, these will be duly identified in the Website or the App.","legal-conditions-2":"Access to the Website or the App is carried out under the sole responsibility of the User, and does not imply any type of commercial relationship between Crush and the User. The User is responsible for ensuring that the information and content included in the Website or in the App meet their specific requirements.","legal-conditions-3":"The User agrees to:","legal-conditions-4":"Access and use both the Website and the App in good faith and in accordance with these Conditions of Use, the Law, morality and public order, with the additional prerequisite of attaining a minimum age of 15 years.","legal-conditions-5":"At Crush, we certify that we comply with applicable legislation on child safety and take child sexual abuse material seriously. We take appropriate measures, such as removing such material upon actual knowledge of its existence, in accordance with our standards and relevant laws.","legal-conditions-6":"Provide truthful, current and lawful information in the forms offered both on the Website and in the App. In any case, the User will immediately notify Crush of any fact that allows the improper use of the information registered in said forms, such as, but not limited to, theft, loss, or unauthorized access to identifiers and/or passwords, in order to proceed with their immediate cancellation.","legal-conditions-7":"Not carry out any action on the Website or the App that may cause damage or alterations in the contents, programs or systems of the Website or the App, including the introduction of computer viruses, the installation of robots, or any harmful software or file, defective, or ultimately that may cause damage to our computer systems.","legal-conditions-8":"The User will respond in any case for damages and losses that may be caused to both Crush and third parties and Crush may adopt the technical, legal and any other measures that it deems appropriate to prevent, mitigate or stop the consequences of the previous prohibited conducts and to demand as many responsibilities as are deemed appropriate.","legal-property":"4. Intellectual and industrial property","legal-property-1":"All the contents of both the Website and the App, including, without limitation, the texts, images, photographs, videos, graphics, distinctive signs of any kind, icons, interfaces, as well as the software, source code, designs, architecture, presentation, arrangement and classification of the contents and any other element present on the Website or the App that may be the subject of intellectual property rights are the exclusive property of Crush or third parties that have licensed, authorized or consented to their use on the Website or in the App.","legal-property-2":"In this sense, when the User accesses, navigates and uses the Website or accesses or uses the App, they are not granted any exploitation rights that exist or may exist over all or part of these, Crush reserving all these rights. The User can only view the elements of the Website and the App and use them to the extent that is strictly necessary for their correct use. In particular, it is prohibited to use or resell for commercial purposes any material or content present on the Website or the App without the prior authorization of Crush.","legal-property-3":"Crush reserves the right to modify, at any time, and without prior notice, the presentation and configuration of the Website or the App and the contents and services that may be incorporated into them. The User acknowledges and accepts that at any time Crush may interrupt, deactivate and/or cancel any of these elements that are integrated into the Website and the App or the access to them.","legal-property-4":"If the User considers that any of the contents of the Website or the App constitutes a violation of the rights of protection of intellectual property, they must immediately notify Crush through the contact information in section 1 (Owner Identification) of these Terms of Use.","legal-disclaimer":"5. Exclusion of guarantees and responsibility","legal-disclaimer-1":"The information published on the Website or in the App may not be exhaustive or not fully updated, so Crush does not assume any responsibility derived from the lack of integrity, updating or precision of the data and information contained in the different pages that are part of the Website or the App.","legal-disclaimer-2":"Crush does not guarantee that access to the App or the Website will be uninterrupted or error free. Likewise, Crush does not guarantee that the content or software present on the Website or the App does not cause damage to the User\'s computer system (software and hardware). Crush will not be responsible for losses, damages or harm of any kind arising from the access, navigation and use of the Website or the App, including, but not limited to, those caused to computer systems or those caused by the introduction of viruses.","legal-disclaimer-3":"Crush, likewise, is exonerated from any liability derived from inappropriate use of the Website or the App by the User.","legal-links":"6. Links","legal-links-1":"It is reported that both the Website and the App can be found, among others, links, banners, buttons, directories and search engines that allow Users to access other websites or apps belonging to and/or managed by third parties and that, therefore, are beyond the control of Crush, who cannot assume responsibility for the content that appears on said pages or apps.","legal-links-2":"In the event that you consider that said content is inappropriate or contrary to the purposes of Crush, we ask that you notify us through the means of contact indicated above, so that we can adopt the appropriate measures.","legal-jurisdiction":"7. Applicable law and jurisdiction","legal-jurisdiction-1":"These Conditions of Use and their execution are subject to Spanish law.","legal-jurisdiction-2":"If any dispute arises over the interpretation or application of these Terms of Use, the Parties will negotiate in good faith to try to resolve such discrepancy or claim. However, in the event that the discrepancy or claim is not resolved, the Parties will submit to the corresponding courts or tribunals according to law.","privacy-title":"Crush - Privacy","privacy-date":"Last updated: December 8, 2023","privacy-header":"Privacy policy","privacy-introduction-1":"At Crush, we are committed to ensuring that your personal data is protected and is not used for purposes other than those indicated in this Privacy Policy. For this reason, in this section we inform users and interested parties of everything related to the processing of their personal data, thus complying with the data protection regulations applicable in our country: General Data Protection Regulation (EU) 2016/679, of April 27 regarding the protection of natural persons with regard to the processing of personal data and the free circulation of these data (hereinafter,","privacy-introduction-2":"\'GDPR\'","privacy-introduction-3":") and Organic Law 3/2018, of December 5, Protection of Personal Data and guarantee of digital rights (hereinafter,","privacy-introduction-4":"\'LOPDGDD\'","privacy-introduction-5":"This Privacy Policy is applicable to the data processing that CRUSH SOCIAL NETWORK, LTD., carried out both through the website: www.crushsocialnetwork.com (hereinafter, the \'Website\'), and through the mobile application for Smartphones with the name \'Crush\' (hereinafter, the \'App\') and/or those that are indicated. We recommend that you read it carefully before using the Website or the App and providing your data through them. Do not hesitate to ask us any questions in this regard via email:","privacy-index":"Index of contents","privacy-index-1":"In this Policy you will find all the information related to the processing of your personal data and the rights you can exercise to maintain control over them. In this sense, you will find information about:","privacy-index-2":"Who is responsible for the processing of your data.","privacy-index-3":"What requirements you must meet to provide us with your personal data.","privacy-index-4":"What data processing we carry out through the website and what are its main characteristics, explaining:","privacy-index-5":"What data we collect and what are the ways of collecting it.","privacy-index-6":"For what purposes we collect the data we request.","privacy-index-7":"What is the legitimacy for its treatment.","privacy-index-8":"How long do we keep them?","privacy-index-9":"To which recipients your data is communicated.","privacy-index-10":"Existence of international transfers of your data.","privacy-index-11":"What are your rights and how can you exercise them?","privacy-index-12":"How we protect your personal information.","privacy-index-13":"Changes to this policy.","privacy-controller":"1. Who is responsible for the processing of your personal data?","privacy-controller-1":"Your personal data will be processed by the company CRUSH SOCIAL NETWORK, LTD. (","privacy-controller-2":"\'CRUSH\'","privacy-controller-3":"), with NIF B-72599830 and whose contact details are as follows:","privacy-controller-4":"Address:","privacy-controller-5":"Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Spain)","privacy-controller-6":"Contact email:","privacy-dpo":"1.1. Our Data Protection Officer","privacy-dpo-1":"From CRUSH, we make available to you the contact details of our Data Protection Officer, to whom you can address any questions you may have in relation to this Privacy Policy or the processing of your personal data.","privacy-dpo-2":"Email:","privacy-requirements":"2. What requirements must you fulfill to provide us with your personal data?","privacy-requirements-1":"2.1. Minimum age. To provide us with your personal data and use our Website and our App, you must be over 15 years of age.","privacy-requirements-2":"2.2. Veracity. When you provide us with your data to use our services, you guarantee that the data and information provided is real, truthful, updated and also belongs to you and not to third parties.","privacy-requirements-3":"In addition, you must notify us of any change that occurs in the data provided, responding in any case to the veracity and accuracy of the your supplied data at all times.","privacy-requirements-4":"2.3. Control of Age and Veracity. From CRUSH we reserve the right to verify your age and identifying information, if necessary, even requiring an official document or equivalent procedure and, in case of detection of fraud that is verified or suspected that you are under the indicated age, to delete, temporarily deactivate and/or cancel your account.","privacy-processing":"3. What data processing do we carry out through the Website and the App and what are its main characteristics?","privacy-processing-1":"Below, we explain how we treat your personal information and provide you, in detail, with all the relevant information regarding your privacy:","privacy-contact":"3.1. When you contact us through our channels (contact form, chat, email)","privacy-contact-1":"What are the ways of collecting the data?","privacy-contact-2":"Contact form.","privacy-contact-3":"Chat.","privacy-contact-4":"Sending emails to","privacy-contact-5":"or other CRUSH email addresses.","privacy-contact-6":"What data do we collect?","privacy-contact-7":"Identification and contact information.","privacy-contact-8":"We collect your identification data (name and surname) and email address, as well as any other information that you voluntarily include in the communications that you send us.","privacy-contact-9":"We may request additional information from you if necessary to comply with your request or requirement.","privacy-contact-10":"What are the purposes of processing your personal data?","privacy-contact-11":"Answer your requests.","privacy-contact-12":"The main purpose of processing this data will be to answer your requests, answer your questions and/or provide you with the required information, as well as, where appropriate, follow up on your requests.","privacy-contact-13":"Improve customer service.","privacy-contact-14":"All the information derived from doubts, queries, and advice offered to interested parties, as well as the way in which requests are resolved, allows us to know how we provide our own customer service, allowing us to improve its quality.","privacy-contact-15":"Likewise, all the information collected, after the conservation period indicated below, is anonymized and used for the purpose of being able to analyze the most frequently asked questions through the chat and to be able to automate the most frequent ones, prepare FAQs or keep it for statistical purposes to develop business strategies.","privacy-contact-16":"What is the legal basis that allows us to process your data? Is the provision of this data mandatory?","privacy-contact-17":"Consent.","privacy-contact-18":"The data provided for the above purposes will be processed based on your consent, granted when you voluntarily contact us through the means made available to you to request information or make a request.","privacy-contact-19":"All the information collected by the customer service department will be processed for statistical purposes that will help us to improve the quality of the customer service provided. This purpose is considered to be compatible with the initial one.","privacy-contact-20":"The information that you must provide will be indicated with an asterisk or similar. Without this information it would not be possible to attend to your queries or requests.","privacy-contact-21":"How long do we keep your information?","privacy-contact-22":"We will process all your personal information during the time your requests are being processed and, if necessary, to follow up on them. Once this period has ended, CRUSH will keep, blocked, said information during the periods provided in the legislation to attend to eventual responsibilities and to demonstrate compliance with our obligations. From this moment on, CRUSH will only treat the information in an anonymous way, so it will not be possible to link the statistical information with the specific users to whom it refers.","privacy-contact-23":"Who do we give your personal information to?","privacy-contact-24":"We do not make any additional transfer to carry out this treatment than those indicated, in general, in point","privacy-contact-25":"4. To whom do we give your personal information?","privacy-contact-26":"In this sense, some channels through which you can contact us are managed by service providers, who act as Treatment Managers. You will find more information about how these service providers act in point 4, mentioned above.","privacy-app-use":"3.2. When you register and use our App \'Crush\'","privacy-app-use-1":"What are the ways of collecting the data?","privacy-app-use-2":"Registration form in our App and use of its different spaces.","privacy-app-use-3":"What data do we collect?","privacy-app-use-4":"Basic data for registration:","privacy-app-use-5":"In order to register in our App and use the services, you will need to register in our App and create a","privacy-app-use-6":"\'profile\'.","privacy-app-use-7":"During the registration process we require you, as a user, the following data:","privacy-app-use-8":"Username.","privacy-app-use-9":"Full name.","privacy-app-use-10":"Email.","privacy-app-use-11":"Date of birth.","privacy-app-use-12":"Additional data:","privacy-app-use-13":"In addition to the above, our App allows you to voluntarily share information related to:","privacy-app-use-14":"Gender.","privacy-app-use-15":"Sexual orientation.","privacy-app-use-16":"Interests.","privacy-app-use-17":"Country, city or region.","privacy-app-use-18":"Description about you.","privacy-app-use-19":"Profession and studies.","privacy-app-use-20":"Musical tastes.","privacy-app-use-21":"Best friend.","privacy-app-use-22":"If you authorize it, your precise geolocation, which, if you have allowed it, is carried out in the background.","privacy-app-use-23":"Usage data: information may be collected about your interactions with other users (chats with other users, users with whom you connect and interact, time, frequency of interaction or other characteristics of your interactions).","privacy-app-use-24":"Some of the data that you can provide voluntarily is considered sensitive, since it is related to your sexual orientation. You should take into account that, if you decide to include such information, CRUSH will process it together with the rest of the information to fulfill the purposes indicated below. Likewise, this information may be shared with the rest of the users (it may be made public), so that unauthorized use of the App by other users could cause the leaking of this data. CRUSH is not responsible for the inappropriate use of data by other users.","privacy-app-use-25":"We also inform you that CRUSH uses the above data for the purpose of creating profiles in order to recommend content which might be of your interest and with the personal characteristics that you include about yourself, as explained below.","privacy-app-use-26":"In addition, if you authorize it, we will have access to:","privacy-app-use-27":"Camera (images): granting camera permission allows the user to upload any image directly to the App.","privacy-app-use-28":"Photo gallery (images): granting access to the photo gallery allows the user to upload any image from their photo gallery.","privacy-app-use-29":"Microphone (audio): granting access to the microphone allows the user to use the device\'s voice recorder directly from the App.","privacy-app-use-30":"Content posted by you:","privacy-app-use-31":"By using our App, you have the possibility of interacting with other users through our community, being able to upload publications with audiovisual content (photos, audios, etc., if you have granted the respective permissions) and add comments with your opinions, ask questions and resolve concerns of other users.","privacy-app-use-32":"We also offer an exciting \'Stalker\' mode, where your friends can capture GIF images of you with your consent. However, the responsibility for capturing and requesting to publish these GIFs on your profile lies with the user who initiates the request. The GIF won\'t be published on your profile until you accept the request. Furthermore, all collaborators can permanently remove their contributions by either rejecting the request or deleting the publication.","privacy-app-use-33":"CRUSH uses Amazon Web Services face recognition technology to process CRUSH\'s users\' biometric data as its service provider (\'Processor\'). Amazon may process and store face templates for the purposes of providing face verification and/or identification services on CRUSH\'s behalf, and only as instructed by CRUSH. Amazon will store this data as long as CRUSH requests, which shall be no longer than a limited grace period after the date when (i) CRUSH ceases to have a relationship with Amazon or (ii) when CRUSH requests deletion.","privacy-app-use-34":"In the event that you publish posts in the App (which is merely optional, we do not force you to do so) Amazon\'s facial recognition technology will be used, which allows to detect faces and find users similar to you (twins) within our system. This is the only use we make of this recognition technology.","privacy-app-use-35":"Our processor, Amazon, is committed to its own compliance with the GDPR, as well as to providing a variety of products, features, documentation, and resources to help its customers meet their compliance obligations under the GDPR.","privacy-app-use-36":"App usage data:","privacy-app-use-37":"We also automatically collect App usage data, specifically technical data and information related to your use of the App, including the type of mobile device, the unique ID of your mobile device, the IP address of your mobile device, the mobile operating system, if any, the type of Internet browsers you use and information about the way you use the App, such as the frequency and time of use, ads you have clicked on, etc.","privacy-app-use-38":"Data about you provided by third parties:","privacy-app-use-39":"Other users of the App may provide us with information about you when they use our services; for example, when they interact with you or if they send us a report involving you.","privacy-app-use-40":"What are the purposes of processing your personal data?","privacy-app-use-41":"Sign up and manage your account","privacy-app-use-42":"so that we can verify your email address and age to sign up for the App, interact with you and give you access to our services.","privacy-app-use-43":"Manage and execute the contractual relationship that unites us:","privacy-app-use-44":"we carry out different steps necessary to execute the contract signed with you, so that, for example, we can provide you with the service, contact you to help you resolve doubts, to verify the information you have provided us. Likewise, we may send you communications of an administrative nature, about updates, changes in our conditions of service, security alerts, as well as respond to any request or requirement that you send us.","privacy-app-use-45":"Publish your content.","privacy-app-use-46":"When you share content or information through the App, it will appear published for the public that you have selected that can see what you share. To add certain content, such as photos and videos, you will need to give us access to your camera or photo gallery.","privacy-app-use-47":"Any user of our App can view your username and public profile on the App, which includes content that you have shared with the general public. Also, keep in mind that your content published in the App may be shared by other users inside or outside the App, take a screenshot of it or download it.","privacy-app-use-48":"Post content about you.","privacy-app-use-49":"Other users of the application can create and share content with your image or data with an audience of your choice. If you do not feel comfortable with the content that others have shared about you, please report it by using the App forms or contact us by email.","privacy-app-use-50":"Offer you content (news, articles, experiences, among others)","privacy-app-use-51":"created directly by CRUSH or in collaboration with external people who may be of interest to you.","privacy-app-use-52":"Sending push notifications and alerts within the App.","privacy-app-use-53":"If you have authorized it, you will receive our push notifications in your web browser or on your mobile device. Push notifications may include reminders, promotional communications, alerts, and updates regarding the App and services.","privacy-app-use-54":"If you activate these notifications, you will receive personalized notices, based on a profile that we develop about you and the use you make of the App. For the personalization of notices, the information obtained through the data entered by you in the App and the data collected regarding the use of the App (visited content) to create a profile in relation to your interests and offer you mainly that content and information that suits you.","privacy-app-use-55":"You can opt out of push notifications at any time by adjusting the settings on your mobile device, although opting out will not affect other communications you may receive from CRUSH, such as email communications.","privacy-app-use-56":"Prevention, detection and prosecution of illegal activities or activities contrary to the conditions of service or that endanger the security of information or the App:","privacy-app-use-57":"CRUSH may process the data to control and prevent any form of abuse of our services, such as fraudulent activities, denial-of-service attacks, sending spam, unauthorized access to our users\' accounts, as well as any other practice that is contrary to the General Conditions and Use of the App or endangers the security of the information or the integrity of the App itself, being able to delete the content or the account that is contrary to the law, our General Conditions or the Community Guidelines.","privacy-app-use-58":"Within this purpose, the processing of complaints that you present against other users or those that are presented against you is also included, with the option of contacting CRUSH to analyze the specific case and guaranteeing that there will be human intervention to correct or rectify the issue that arises to us.","privacy-app-use-59":"We may also use tools to detect inappropriate content (for example, adult or violent content) in the visual content you post.","privacy-app-use-60":"To offer you a better service, your data will also be processed for the purpose of:","privacy-app-use-61":"Help you connect with other users, allowing you to interact with them through chat screens and other mechanisms.","privacy-app-use-62":"Recommend you to other users who are similar to you.","privacy-app-use-63":"To make recommendations, we use the information you provide us, including information about your location if you give your permission, as well as information we obtain from your use of this space (for example, characteristics of the people with whom you actually interact) to develop an automated profile about you and preferably show you those users who match your profile and what you are looking for.","privacy-app-use-64":"In this sense, you will preferably be shown active users in the App, who are close to you, who match the indicated preferences and your profile created from your interactions, also ensuring that your characteristics and profile match the preferences of the recommended users.","privacy-app-use-65":"Statistical purposes and others carried out with anonymous data.","privacy-app-use-66":"We may anonymize all personal information collected from users who use the App for statistical and other purposes, such as algorithm training, to measure the effectiveness of advertising campaigns available on the App, the navigability and usability of the App to to be able to improve the design, presentation and functionalities available or others.","privacy-app-use-67":"To show you advertising:","privacy-app-use-68":"Our App may include advertising that, if you give your consent, will be personalized according to your tastes and preferences.","privacy-app-use-69":"What is the legal basis that allows us to process your data? Is the provision of this data mandatory?","privacy-app-use-70":"Execute and maintain the contractual relationship between the Parties.","privacy-app-use-71":"The reason why we process your information for the purposes mentioned above is to fulfill the contract we have with you.","privacy-app-use-72":"Consent.","privacy-app-use-73":"Some functionalities are based on your express consent: (i) publication of your own content, (ii) access to the camera or photo gallery to publish certain content in the App, (iii) access to the geolocation of the device for user recommendation by proximity (iv) the reception of personalized push notifications (v) display of personalized advertising content. Also, if you decide to provide us with additional voluntary information to complete your profile, such information will be used based on your consent.","privacy-app-use-74":"Remember that you can revoke your consent at any time through the settings of your device, deleting your content or through the options available in the App.","privacy-app-use-75":"Legitimate interest.","privacy-app-use-76":"The data will be processed based on our legitimate interest in relation to the prevention of illegal activities and others related to the security of the App, to guarantee the security of the network and of the information to prevent events that may compromise the availability, authenticity, integrity and confidentiality of personal data or the platform itself, as well as compliance with community standards.","privacy-app-use-77":"We may also show you non-personalized advertising through the App based on our legitimate interest.","privacy-app-use-78":"If you wish to obtain more information about the weighting that we have carried out on the legitimate interests of CRUSH in relation to the above purposes, you can request it by writing to us at","privacy-app-use-79":"Processing of specially protected data.","privacy-app-use-80":"The data related to your interests or aspects related to sexual orientation will be processed based on your explicit consent.","privacy-app-use-81":"How long do we keep your information?","privacy-app-use-82":"We will keep all your personal information for as long as our contractual relationship is in force, that is, until you delete your account. Once the contractual relationship has ended or your account has been cancelled, CRUSH will keep, blocked, all the information during the periods provided by law to investigate illegal or harmful conduct, attend to eventual responsibilities and to demonstrate compliance with our obligations.","privacy-app-use-83":"In relation to the content published by you through our App, you should take into account that any publication or comment that you have published in our community will remain in the App until you delete it or until you delete your account. However, any other content where you appear and that has been published by other users (for example, photos or videos) may remain visible until said user deletes it or closes their account.","privacy-app-use-84":"However, we reserve the right to use your information in aggregate form after closing your account for statistical purposes and to improve our services. The use of such information will not allow you to be personally identified.","privacy-app-use-85":"Who do we give your personal information to?","privacy-app-use-86":"There are no specific transfers of your personal data to fulfill the purpose indicated in this section. However, we can use the services of service providers, who will have limited access to the data and will be bound by a duty of confidentiality (for more information on how our service providers act, see point","privacy-app-use-87":"4. To whom do we give your personal information? > Service Providers","privacy-app-use-88":"However, keep in mind that when you post content on our App, you may be sharing personal information with other users (including your public profile).","privacy-app-use-89":"Also, if someone files a report that implicates you, we may notify the complainant of the actions we have taken as a result of their report, if any.","privacy-cookies":"3.3. Browsing the Website (cookies)","privacy-cookies-1":"On our Website, as well as in our App, we use cookies or other tracking and tracing tools to collect information about the use that users make of the Website and the App.","privacy-cookies-2":"For more information about the treatment we carry out through said tracking tools, visit our","privacy-cookies-3":"Cookies Policy","privacy-social-profiles":"3.4. CRUSH profiles on social networks","privacy-social-profiles-1":"CRUSH has a profile on the main social networks, such as Twitter, Instagram, LinkedIn or TikTok.","privacy-social-profiles-2":"When you become a follower of one of our pages on social networks, the data processing will be governed by the conditions of use, privacy policies and access regulations that belong to the corresponding social network and previously accepted by the user.","privacy-social-profiles-3":"CRUSH, in this sense, will process your data for the purpose of correctly managing its presence on the social network, informing you of activities, products or services, as well as for any other purpose that the regulations of social networks allow.","privacy-social-profiles-4":"Keep in mind that we have no influence on the information that the social network collects or how it processes it, so we recommend that you keep yourself informed of the purpose and scope of the information collection that is carried out through said social networks.","privacy-transfer":"4. To whom do we give your personal information?","privacy-transfer-1":"In general, from CRUSH we will not communicate your data to third parties. However, in addition to the transfers that we specifically indicate in the section in which we explain the characteristics of the different operations (point 3), we inform you of the communications that, in general, we can make, as well as their legitimizing basis, which affect all previous treatments.","privacy-transfer-2":"Essential service providers","privacy-transfer-3":"to execute the service we offer you, (for example, computer hosting companies or platforms for sending commercial communications). Notwithstanding the foregoing, these entities have signed the corresponding confidentiality agreements and will only process your data according to our instructions, not being able to use them for their own purposes or apart from the service they provide us.","privacy-transfer-4":"Public organisms.","privacy-transfer-5":"We may disclose to the competent public authorities the data and any other information that is in our possession or that is accessible through our systems when there is a legal obligation to do so, as well as when required, for example, when the purpose is to prevent or prosecute abuse of services or fraudulent activities through our Website or Application. In these cases, the personal data that you provide us will be kept and made available to the administrative or judicial authorities.","privacy-transfer-6":"In the case of a corporate transaction:","privacy-transfer-7":"In the event of a merger, acquisition, sale of all or part of its assets, or any other type of corporate transaction involving a third party, we may share, disclose, or transfer user data to the successor entity (including during the pre-operative phase).","privacy-transfer-8":"To third parties after aggregation or anonymization:","privacy-transfer-9":"we may disclose or use aggregated or anonymized data (meaning data that is not linkable to an identified or identifiable natural person) for any purpose.","privacy-transfer-10":"To third parties with the user\'s consent or other legitimate basis:","privacy-transfer-11":"In the event that we want to share data with third parties outside the scope of this Privacy Policy, your consent will be requested, in any case, or you will be informed about it and its legitimate basis.","privacy-transfer-12":"Likewise, we inform you that this Privacy Policy only refers to the collection, treatment and use of information (relating to personal data) by us through the interaction you carry out with our Website or Application. Access to third-party web pages that you can access through links from the Website or the App have their own privacy policies over which we have no control. Therefore, before providing them with any personal information, we recommend that you find out about their Privacy Policies.","privacy-eea":"5. Is your personal data transferred to third countries outside the European Economic Area?","privacy-eea-1":"Some of our service providers are located in countries outside the European Economic Area (","privacy-eea-2":"\'EEA\'","privacy-eea-3":"The location of these companies outside the EEA implies the existence of an international transfer of your personal data, which could imply a lower degree of protection than that included in European regulations. However, from CRUSH we have applied measures so that said transfers do not give rise to a lower degree of protection of your personal data.","privacy-eea-4":"In this sense, the service providers that are outside the EEA have signed the corresponding standard contractual clauses approved by the European Commission (","privacy-eea-5":"\'CCT\'","privacy-eea-6":"), an agreement signed between both entities by which the non-EU company guarantees that it applies the European standards of data protection.","privacy-eea-7":"Therefore, the use of these providers does not give rise to a lower degree of protection of your personal data than the use of providers located in the European Union. You can consult the content of the CCT in the following link:","privacy-eea-8":"Next, we indicate which are the international transfers that we make from CRUSH:","privacy-eea-9":"Name","privacy-eea-10":"Affected activities","privacy-eea-11":"Country","privacy-eea-12":"Transfer mechanism","privacy-eea-13":"All","privacy-eea-14":"Face detection and search for similar-looking faces","privacy-eea-15":"Push notifications","privacy-eea-16":"Sending emails","privacy-eea-usa":"USA","privacy-eea-sccs":"Standard Contractual Clauses (SCCs)","privacy-rights":"6. What are the rights that you can exercise as an interested?","privacy-rights-1":"You can exercise the rights that the law guarantees you in relation to the processing of your personal data by contacting our Data Protection Delegate via email","privacy-rights-2":"Any request for rights that we receive will be resolved as soon as possible and, in any case, within the maximum period established by law, from the date of receipt. In some cases, it will be necessary to request a copy of your identity document or other identification document to verify your identity.","privacy-rights-3":"The rights that correspond to you as an interested party are the following:","privacy-rights-4":"Right to withdraw the consent granted","privacy-rights-5":"You can revoke your consent in relation to all processing based on it at any time. However, the withdrawal of consent will not affect the legality of the treatment based on the consent prior to its withdrawal.","privacy-rights-6":"Right of access","privacy-rights-7":"You have the right to know what data is being processed, if applicable and, if so, to obtain a copy of it, as well as to obtain information regarding:","privacy-rights-8":"the origin and recipients of the data;","privacy-rights-9":"the purposes for which they are processed;","privacy-rights-10":"whether there is an automated decision-making process, including profiling;","privacy-rights-11":"the data retention period; and","privacy-rights-12":"the rights provided by the regulations.","privacy-rights-13":"Right to rectification","privacy-rights-14":"You have the right to obtain the rectification of your personal data or to complete it when it is incomplete.","privacy-rights-15":"Right to erasure","privacy-rights-16":"You have the right to request the deletion of your personal data if they are no longer necessary for the purpose for which they were collected or, where appropriate, if we are no longer authorized to process them.","privacy-rights-17":"Right to data portability","privacy-rights-18":"You have the right to request the portability of your data in the case of treatments that are based on your consent or on the execution of a contract, as long as the processing has been carried out by automated means. In the event of exercising this right, you will receive your personal data in a structured format, commonly used and readable by any electronic device. However, you can also request, when possible, that your data be transmitted directly to another company.","privacy-rights-19":"Right to restrict processing","privacy-rights-20":"You have the right to limit the processing of your data in the following cases:","privacy-rights-21":"When you have requested the rectification of your personal data, during the period in which we verify their accuracy.","privacy-rights-22":"When you consider that we are not authorized to process your data. In that case, you can ask us to limit its use instead of requesting its deletion.","privacy-rights-23":"When you consider that it is no longer necessary for us to continue processing your data and you want us to keep them for the purposes of exercising or defending claims.","privacy-rights-24":"In cases where there is processing based on our legitimate interest and you have exercised your right to oppose it, you can ask us to limit the use of your data during the verification of the prevalence of said interests with respect to yours.","privacy-rights-25":"Right to object","privacy-rights-26":"You have the right to object at any time to the processing of your personal data based on our legitimate interest, including profiling.","privacy-rights-27":"Right to lodge a complaint with a Supervisory Authority","privacy-rights-28":"Remember that, at any time, and in the event that you consider that we have violated your right to the protection of your data, you can address your defense to the corresponding Control Authority, in the case of Spain, the Spanish Agency for Data Protection (","privacy-confidence":"7. How do we guarantee the confidentiality of your information?","privacy-confidence-1":"The security of your personal data is a priority for us. For this reason, CRUSH has implemented all the necessary security measures to guarantee effective use and treatment of the personal data provided by the user, safeguarding the intimacy, privacy, confidentiality and integrity of these, and makes use of the technical means necessary to avoid alteration, loss, unauthorized access or treatment of your data, according to the state of technology at all times.","privacy-confidence-2":"Consequently, we comply with recommended security standards to protect them. However, it is impossible to fully guarantee your security due to the very nature of the Internet and because there may be malicious actions by third parties beyond our control.","privacy-confidence-3":"We promise to act quickly and diligently in case the security of the data is in danger or compromised, and to inform you about it in case it is relevant.","privacy-modifications":"8. Modifications to this policy","privacy-modifications-1":"From CRUSH we can modify the content of this Privacy Policy at any time, especially when there are legislative, jurisprudential or interpretation modifications of the Spanish Agency for Data Protection that affect the data processing carried out by CRUSH through the Website or the App. Any new version of this Privacy Policy will be effective on the published effective date.","privacy-modifications-2":"If the revised version includes a substantial change that affects the processing of your data, we will notify you at least 30 days in advance by posting a notice on our Website or our App or by notifying you via email. In any case, we recommend that you periodically review this Privacy Policy to be informed of how your personal data is treated and protected, as well as your rights.","cookies-title":"Crush - Cookies","cookies-date":"Last updated: December 8, 2023","cookies-header":"Cookies policy","cookies-introduction-1":"Both on the website www.crushsocialnetwork.com (hereinafter, the","cookies-introduction-2":"\'Website\'","cookies-introduction-3":") as well as through the mobile application for Smartphones with the name \'Crush\' (hereinafter, the","cookies-introduction-4":"\'App\'","cookies-introduction-5":") we use cookies or other tracking and tracing tools to collect information about the use that users make of the Website and the App.","cookies-introduction-6":"In this document, you will discover which cookies we give to the Cookie Monster, as well as any other type of related information regarding this wonderful bite.","cookies-definition":"1. What is a cookie?","cookies-definition-1":"A cookie is a file that is installed in the browser of your device (computer, mobile, etc.) in order to store and retrieve data. Cookies can have a multitude of purposes, depending on what they have been configured for: for example, saving preferences, collecting usage statistics, enabling technical features, among others.","cookies-responsible":"2. Who is the responsible?","cookies-responsible-1":"The responsible for the treatment of the information collected through cookies is CRUSH SOCIAL NETWORK, LTD. (CRUSH), with NIF B-72599830 and address at Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Spain).","cookies-responsible-2":"If you have any questions related to the use of cookies, please write an email to","cookies-responsible-3":"and we will reply to you as soon as possible.","cookies-data":"3. What data is collected through cookies?","cookies-data-1":"When you access the Website or install and use the App, even if you have not registered, the following information is collected through cookies:","cookies-data-2":"Device information: During the use of the Website or the App, we collect information about the mobile device from which you access the platform. The information we collect is the device model, operating system and version, unique device identifier, and network.","cookies-data-3":"Information about your location: We also obtain the IP address, time zone and what the mobile service provider is, if any, which allows us to obtain a general location.","cookies-data-4":"User navigation information: We collect information about the use you make of the Website and the App. Specifically, the frequency of use, the sections you visit, use of specific functions, etc.","cookies-types":"4. What types of cookies are there?","cookies-types-1":"According to their purpose,","cookies-types-2":"we can classify cookies among the following:","cookies-types-3":"Technical cookies:","cookies-types-4":"These cookies are strictly necessary to navigate the Website or the App and allow basic functions such as browsing from one section to another. They are in charge of technical aspects such as identifying profiles or sessions and managing tool preferences in the use, interaction and location of access to content. Also belonging to this category, due to their technical nature, are those cookies that allow the management, in the most efficient way possible, of the advertising spaces included in the Website and the App, without collecting information from users for different purposes, such as personalizing ads or other types of content.","cookies-types-5":"Statistical cookies:","cookies-types-6":"These cookies measure and collect statistical information regarding the use made by the user of the Website or the App, such as the time spent on the platform, the number of visits or the contents visited. Said information allows us to understand how users interact with the Website and the App, evaluate performance, which sections are the most or least visited, including the quantification of the impact of the advertisements introduced on the Website and the App (if applicable). Having this information can solve errors, and improve the design of the system and the content offered through it.","cookies-types-7":"Preference or personalization cookies:","cookies-types-8":"Preference cookies allow the Website or the App to remember specific user information so that they can access the service with certain characteristics that can differentiate their experience from that of other users. For example, your preferred language or the region from which you access, the number of results to display when the user performs a search, the appearance or content of the service depending on the type of device from which the user accesses it, etc.","cookies-types-9":"Behavioral advertising cookies:","cookies-types-10":"These cookies allow the management of the advertising spaces that, where appropriate, have been included in the Website or the App. However, the management of the advertising spaces is done based on the user\'s browsing profile. These cookies store user browsing information obtained through continuous observation of their browsing habits, developing a specific user profile, so the ads that appear in these spaces will be personalized for the user according to said habits.","cookies-types-11":"Depending on the entity that manages them:","cookies-types-12":"Own cookies:","cookies-types-13":"are those that are sent to the user\'s device from a computer or domain managed by the person responsible for the Website or App, in this case, CRUSH, and from which the service requested by the user is provided.","cookies-types-14":"Third-party cookies:","cookies-types-15":"are those that are sent to the user\'s device from a computer or domain that is not managed by the person responsible for the Website or the App, but by another entity that processes the data obtained through cookies.","cookies-types-16":"Depending on the time they remain active on the device:","cookies-types-17":"Session cookies:","cookies-types-18":"They are designed to collect and store data during the time the user is browsing the Website or the App, and are deactivated at the end of the browsing.","cookies-types-19":"Persistent cookies:","cookies-types-20":"These store data that can be accessed and processed during a period defined by the person responsible for the cookie. Their lifetimes can range from minutes to years.","cookies-used":"5. What cookies do we use specifically on our platform?","cookies-used-1":"On our platform, we use the following cookies:","cookies-used-2":"Name","cookies-used-3":"Purpose","cookies-used-4":"Own/Third-Party Cookies","cookies-used-5":"Expiration","cookies-used-6":"14 months","cookies-used-7":"Indefinite","cookies-used-stats":"Statistics","cookies-used-technical":"Technical","cookies-used-third-party-google":"Third-Party (Google LLC.)","cookies-legitimation":"6. What is the basis of legitimation that allows us to process your data through cookies? If so, are they mandatory?","cookies-legitimation-1":"The information we collect through cookies and other tracking devices is based on your consent, which we request when you access the Website or when you install the App through an informative pop-up or in the manner established by Google (when it comes to Android) or Apple (when it comes to iOS).","cookies-legitimation-2":"In this sense, at any time you can withdraw your consent as explained in the section related to the revocation of consent.","cookies-legitimation-3":"Technical cookies cannot be disabled, as otherwise the proper functioning of the Website or App would be compromised. In general, they are only set in response to actions taken when requesting services from us, such as setting your preferences in relation to the cookies themselves, log in or complete forms. In the event that the deactivation occurs, this could cause the use of some of the services of the Website or the App to be limited due to not being able to access certain functionalities and therefore your experience would be less satisfactory.","cookies-transfer":"7. To whom do we give your personal information? Are there international data transfers?","cookies-transfer-1":"We use some third-party cookies, which are those cookies collected and managed by a third party, so said entities will receive your personal data collected through cookies for the purposes indicated for each cookie. These types of cookies are indicated in the table in section 5, as \'Third-Party Cookies\'. This table identifies the third party that manages each cookie.","cookies-transfer-2":"You can find out about the transfers to third countries that, where appropriate, are made by the third parties identified in this Cookies Policy in their corresponding policies.","cookies-consent":"8. What is the way to accept, deny or revoke the consent for the use of cookies on this website?","cookies-consent-1":"When you access our Website or our App for the first time, you will be shown a window in which you can indicate whether you accept cookies or whether you wish to configure or reject them, except those that are strictly necessary. Likewise, you can withdraw the previously granted consent at any time.","cookies-consent-2":"If you wish to withdraw your consent related to the Cookies Policy at any time, you have two options: (i) withdraw your consent through the buttons enabled for this purpose in this Cookies Policy; or (ii) delete cookies stored on the device through the settings and configurations of your Internet browser.","cookies-consent-3":"Keep in mind that, if you accept third-party cookies, you must eliminate them from the browser options or from the system offered by the third party itself.","cookies-consent-4":"You can expand the information on how to disable cookies, depending on your browser, in the following links:","cookies-consent-5":"; for iOS:","cookies-rights":"9. What are the rights that you can exercise as an interested?","cookies-rights-1":"The rights that you have as an interested party in relation to the protection of your personal data are indicated in the section \'What are the rights that you can exercise as an interested?\' within the","cookies-rights-2":"Privacy Policy","cookies-modifications":"10. Modifications to this policy","cookies-modifications-1":"We may update the Cookie Policy of our platform from time to time. For this reason, we recommend that you review this policy each time you access our Website or App in order to be adequately informed about how and for what we use cookies."}');

});

parcelRegister("gqSMJ", function(module, exports) {
module.exports = JSON.parse('{"404-title":"Crush - No encontrado","404-not-found-1":"No encontrado","404-not-found-2":"Lo sentimos, la p\xe1gina que buscas no est\xe1 disponible.","navbar-mission":"Misi\xf3n","navbar-download":"Descargar","footer-follow":"S\xedguenos","footer-follow-1":"Instagram","footer-follow-2":"TikTok","footer-follow-3":"Twitter","footer-follow-4":"LinkdIn","footer-docs":"Documentaci\xf3n","footer-docs-1":"Misi\xf3n","footer-docs-2":"Aviso legal","footer-docs-3":"Privacidad","footer-docs-4":"Cookies","footer-docs-5":"Directrices","footer-contact":"Cont\xe1ctanos","footer-contact-1":"Soporte","footer-contact-2":"Empleos","footer-contact-3":"Inversores","home-title":"Crush - Donde los medios se encuentran con lo plat\xf3nico","home-hero-slogan-1":"Where media","home-hero-slogan-2":"meets platonic \u2122","home-concept-1":"Encuentra a tu gente","home-concept-2":"Concecta con personas como t\xfa en las diferentes etapas de tu vida.","home-concept-3":"Vibras guays","home-concept-4":"Comparte buenas vibras y momentos reales. Nada de toxicidad o pretensiones.","home-attributes-1":"Aesthetic","home-attributes-2":"Promovemos la publicaci\xf3n de contenido aesthetic y de alta calidad; Internet ya est\xe1 inundado de fotos de gatos.","home-attributes-3":"Stalker","home-attributes-4":"Tus amigos son las estrellas. T\xf3males unas r\xe1fagas de fotos cuando est\xe9n desprevenidos y publica GIFs en sus cuentas.","home-attributes-5":"Hilos","home-attributes-6":"Participa en discusiones vibrantes que abarcan desde los temas m\xe1s actuales hasta las tendencias que dar\xe1n forma al ma\xf1ana.","home-attributes-7":"Gemelos","home-attributes-8":"Conecta con personas que tienen rasgos faciales similares a los tuyos, ampliando tu red social de una manera completamente novedosa y divertida.","home-attributes-9":"Segmentaci\xf3n por edad","home-attributes-10":"Al agrupar a los usuarios por edad, como en las clases de instituto, las conexiones se limitan a individuos de la misma generaci\xf3n para una interacci\xf3n m\xe1s segura y eficiente.","home-attributes-11":"Crush","home-attributes-12":"No es una aplicaci\xf3n de citas \u2014 solo amigos y relaciones relajadas. Recupera la nostalgia de las conexiones de la escuela secundaria en un entorno digital.","home-partners":"Powered By","mission-title":"Crush - Misi\xf3n","mission-date":"\xdaltima modificaci\xf3n: 8 diciembre, 2023","mission-header":"Misi\xf3n y valores","mission-introduction":"En el coraz\xf3n de Crush late algo m\xe1s que una simple red social; es un universo tejido con valores \xe9ticos, una filosof\xeda y un prop\xf3sito. Este documento es el viaje a trav\xe9s de los cimientos de nuestra visi\xf3n, desde el nacimiento de la idea hasta el minucioso esbozo de la creaci\xf3n que estamos forjando.","mission-origin":"El origen","mission-origin-1":"El origen de Crush se remonta a una semilla sembrada mucho antes de su desarrollo concreto en 2020 y su lanzamiento en 2023. Nuestra visi\xf3n de fusionar redes sociales con el toque distintivo de Crush se gest\xf3 en 2016, inspirada por \'La red social\', la notable obra cinematogr\xe1fica reconocida por Quentin Tarantino como una joya de la d\xe9cada pasada. Esta pel\xedcula, que relata la historia de los j\xf3venes fundadores de Facebook, especialmente de su figura m\xe1s reconocida, Mark Zuckerberg \u2014 el padre de las redes sociales, nos brind\xf3 una perspectiva reveladora.","mission-origin-2":"En Crush, creemos fervientemente que el n\xfacleo de las redes sociales actuales reside en el amor plat\xf3nico. Si has tenido la oportunidad de ver esta pel\xedcula, es posible que hayas captado las cr\xedticas de Zuckerberg y Eduardo Saverin hacia las aplicaciones de citas. En una escena clave, aproximadamente en el minuto 30:00, durante el litigio de los hermanos Winklevoss por supuesto robo de idea, Saverin menciona:","mission-origin-3":"\\"It really hadn\'t much to do with the Winklevoss\' dating site\\".","mission-origin-4":"Es curioso, pues unos minutos despu\xe9s, alrededor del minuto 36:05, vemos a Mark implementando elementos como el estado sentimental e intereses en su proyecto:","mission-origin-5":"\\"Relationship status, interests... This is what drives life in college. Are you having sex or aren\'t you? That\'s why people take classes, sit where they sit, and do what they do. It\'s the center, you know? That\'s what The Facebook is going to be.\\".","mission-origin-6":"Por \xfaltimo, en la escena final, presenciamos a un Zuckerberg enamorado enviando una solicitud de amistad a su crush.","mission-origin-7":"Esta pel\xedcula nos plantea una intrigante pregunta:","mission-origin-8":"\xbfSon las redes sociales en realidad aplicaciones de citas disfrazadas?","mission-purpose":"Nuestro prop\xf3sito","mission-purpose-1":"No existe una respuesta definitiva a la pregunta planteada en la secci\xf3n anterior. Tal vez s\xed, tal vez no... al final, depende de los valores \xe9ticos y culturales, las intenciones y la educaci\xf3n del usuario final. Lo que s\xed sabemos con certeza es que esto deja la puerta abierta a problemas reales y muy serios que, a diferencia de en el mundo real, s\xed que pueden ser solucionados.","mission-purpose-2":"Ya sea por las normas preestablecidas por la sociedad o el anonimato que conduce a comportamientos inapropiados en l\xednea, el amor en el \xe1mbito digital, ya sea plat\xf3nico y genuino en las redes sociales o m\xe1s rom\xe1ntico en las aplicaciones de citas, ha sido, desafortunadamente, sexualizado en los \xfaltimos a\xf1os. \xbfPor qu\xe9 algo tan hermoso y fundamental en nuestra vida est\xe1 siendo distorsionado en este universo paralelo?","mission-purpose-3":"Vamos a ser claros y completamente transparentes. En Espa\xf1a, nuestro pa\xeds de origen, seg\xfan datos y estad\xedsticas verificables,","mission-purpose-4":"7 de cada 10 menores de 15 a\xf1os tienen un dispositivo m\xf3vil.","mission-purpose-5":"Esto significa que alrededor del 70% de los menores tiene acceso sin restricciones a un mundo virtual donde la interacci\xf3n con adultos no ha sido regulada ni restringida, exponi\xe9ndolos a riesgos como el acoso, el bullying o la pedofilia, entre otros.","mission-purpose-6":"En la actualidad, independientemente de la red social en la que te registres, es com\xfan encontrar a personas vendiendo contenido inapropiado o compartiendo cualquier tipo de contenido inadecuado. A m\xe1s corre el tiempo, m\xe1s asquerosa es la situaci\xf3n.","mission-purpose-7":"Queremos eliminar la sexualizaci\xf3n y la toxicidad de la red, abordando su origen de manera directa.","mission-purpose-8":"Crush se plantea como una redefinici\xf3n de las redes sociales desde una perspectiva distinta, centrada en las relaciones plat\xf3nicas.","mission-purpose-9":"No ofrecemos un sistema de dating o la creaci\xf3n de relaciones rom\xe1nticas/serias, ya que eso contradice nuestras","mission-purpose-10":"normas comunitarias.","mission-purpose-11":"En cambio, ofrecemos lo mismo que se ideaba en la pel\xedcula de \'La red social\', pero con una soluci\xf3n al problema y un enfoque m\xe1s guay.","mission-purpose-12":"Nuestra misi\xf3n trasciende el t\xedpico \\"comparte momentos reales\\" o \\"te ayudamos a conectar\\". Adem\xe1s de acompa\xf1ar al usuario en las diversas etapas de su vida, nos dedicaremos a resolver los problemas anteriormente mencionados. En nuestra plataforma, al momento de redactar este documento, ya es imposible que un menor interact\xfae con un mayor de edad (y viceversa), no solo para cerrar las puertas a esas cuestiones \xe9ticas, sino tambi\xe9n para fomentar la creaci\xf3n de v\xednculos entre personas de la misma generaci\xf3n, con una mentalidad af\xedn. Planeamos presentar m\xe1s soluciones eficaces en la pr\xf3xima d\xe9cada de desarrollo; es nuestra promesa.","guidelines-title":"Crush - Directrices","guidelines-date":"\xdaltima modificaci\xf3n: 4 abril, 2024","guidelines-header":"Normas comunitarias","guidelines-introduction-1":"En Crush, se trata de establecer conexiones plat\xf3nicas, compartir momentos aut\xe9nticos de la vida con amigos, socializar y crear nuevas amistades afines a tu mentalidad. Creemos firmemente en la libertad de expresi\xf3n, pero tambi\xe9n valoramos la capacidad de distinguir entre el bien y el mal. Este documento detalla los est\xe1ndares de nuestra red social, esenciales para cumplir con","guidelines-introduction-2":"nuestro principal prop\xf3sito.","guidelines-introduction-3":"Esperamos un comportamiento adecuado, cuidado en el contenido, autenticidad, humildad y, sobre todo, responsabilidad. Cualquier violaci\xf3n de nuestros principios fundamentales podr\xeda resultar en la suspensi\xf3n permanente de tu cuenta, sin posibilidad de volver a registrarte en nuestro sistema.","guidelines-introduction-4":"Al igual que en la vida real, hay consecuencias para las acciones. Por favor, respeta nuestras reglas y no utilices nuestro sistema de manera contraria a la ley. Queremos enfatizar nuestra seriedad y rigurosidad; el tono de juego no es bienvenido en este contexto.","guidelines-dating":"Anti-dating","guidelines-dating-1":"Crush es una combinaci\xf3n de redes sociales apta para todas las personas","guidelines-dating-2":"mayores de 15 a\xf1os de edad,","guidelines-dating-3":"est\xe9n o no est\xe9n en una relaci\xf3n sentimental. No confundas los amigos y las relaciones plat\xf3nicas (opcionales) con las relaciones rom\xe1nticas o compromisos reales.","guidelines-dating-4":"A continuaci\xf3n, te detallamos una serie de comportamientos que debes adoptar y respetar para permanecer en nuestra plataforma:","guidelines-dating-5":"No utilices nuestro servicio para buscar ni solicitar encuentros rom\xe1nticos.","guidelines-dating-6":"Si el amor ha llegar a tu vida, que no sea a trav\xe9s de una pantalla.","guidelines-dating-7":"No publiques guarradas.","guidelines-dating-8":"No acoses ni molestes a ning\xfan usuario.","guidelines-dating-9":"No mientas en tu edad o datos personales, y mucho menos suplantes la identidad de otra persona.","guidelines-dating-10":"Es un delito muy grave que podr\xeda conllevar acciones legales en tu contra.","guidelines-content":"Aesthetic","guidelines-content-1":"Para nosotros, cualquier forma de software es arte, y el arte debe ser respetado. En una red social, la calidad de la plataforma se refleja en el contenido que los usuarios generan. En nuestro caso, fomentamos la creatividad y la inspiraci\xf3n. Te pedimos que publiques manteniendo un est\xe1ndar m\xednimo de calidad.","guidelines-content-2":"No publiques contenido de mala calidad visual.","guidelines-content-3":"Haz un esfuerzo.","guidelines-content-4":"El spam es eliminaci\xf3n directa.","guidelines-content-5":"Si quieres promocionar tu Instagram, utiliza las herramientas que te proporcionamos para ello.","guidelines-content-6":"No compartas contenido que infrinja la propiedad intelectual de otros.","guidelines-content-7":"Por favor, evita publicar fotos de gatitos;","guidelines-content-8":"en Internet ya existen muchas.","guidelines-content-9":"No hagas el rid\xedculo publicando desnudez innecesaria.","guidelines-content-10":"Estamos cansados de las fotograf\xedas sin camiseta.","guidelines-vibes":"S\xf3lo buenas vibras","guidelines-vibes-1":"En Crush, no toleramos comportamientos inapropiados. Al igual que cuidas tu imagen en la vida real, te pedimos que seas responsable y mantengas esa integridad en Internet. Demuestra educaci\xf3n y respeto tanto hacia los usuarios de nuestra comunidad como hacia los creadores de la plataforma.","guidelines-vibes-2":"La explotaci\xf3n infantil, la extorsi\xf3n sexual o cualquier otro tipo de abuso, en cualquier forma, est\xe1n estrictamente prohibidos.","guidelines-vibes-3":"Nuestro compromiso contra el suicidio y la autolesi\xf3n es absoluto.","guidelines-vibes-4":"Cualquier contenido que promueva, anime o enaltezca estas acciones resultar\xe1 en una suspensi\xf3n permanente.","guidelines-vibes-5":"Nos tomamos en serio la legalidad.","guidelines-vibes-6":"Evita compartir contenido que promueva actividades ilegales, as\xed como cualquier contenido relacionado con armas o drogas.","guidelines-vibes-7":"El contenido ofensivo o violento no tiene lugar en nuestra plataforma y no est\xe1 permitido.","guidelines-vibes-8":"El modo Stalker tiene como finalidad la diversi\xf3n entre amigos.","guidelines-vibes-9":"Aunque, en \xfaltima instancia, el contenido deba ser aprobado por el usuario o los usuarios que aparecen en el GIF, evita a toda costa compartir fotograf\xedas de tus colegas sin consentimiento previo.","legal-title":"Crush - Aviso legal","legal-date":"\xdaltima modificaci\xf3n: 4 abril, 2024","legal-header":"Aviso legal","legal-introduction-1":"Cada aplicaci\xf3n es un universo y todos los universos est\xe1n sujetos a reglas. En este documento encontrar\xe1s el aviso legal y los t\xe9rminos generales de uso de nuestra plataforma, complementados por los definidos en nuestras","legal-introduction-2":"reglas comunitarias.","legal-owner":"1. Identificaci\xf3n del titular","legal-owner-1":"El sitio web www.crushsocialnetwork.com (en adelante, el","legal-owner-2":"\'Sitio Web\'","legal-owner-3":") y la aplicaci\xf3n m\xf3vil para Smartphone con el nombre \'Crush\' (en adelante, la","legal-owner-4":"\'App\'","legal-owner-5":") son titularidad de CRUSH SOCIAL NETWORK, S.L., provista de NIF: B-72599830 e inscrita en el Registro Mercantil de Valencia con los siguientes datos regristrales: T. 3606, F.75, I.1, H. MU-108656, y cuyos datos de contacto son:","legal-owner-6":"Domicilio Social:","legal-owner-7":"Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Espa\xf1a)","legal-owner-8":"Email de contacto:","legal-area":"2. \xc1mbito de aplicaci\xf3n","legal-area-1":"Las presentes Condiciones Generales de Uso del Sitio Web (en adelante, las","legal-area-2":"\'Condiciones de Uso\'","legal-area-3":") recogen los t\xe9rminos y condiciones que regulan el acceso, navegaci\xf3n y uso del Sitio Web y la App.","legal-area-4":"En este sentido, el acceso, uso y navegaci\xf3n por el Sitio Web y la App confiere la condici\xf3n de usuario(s) (en adelante, el","legal-area-5":"\'Usuario\'","legal-area-6":"o los","legal-area-7":"\'Usuarios\'","legal-area-8":"), e implica la aceptaci\xf3n de todas y cada una de las presentes Condiciones de Uso. El Usuario es plenamente consciente de que la mera navegaci\xf3n por el Sitio web o la App implica la aceptaci\xf3n de las presentes Condiciones de Uso y, por ello, si el Usuario no est\xe1 de acuerdo con las mismas, no deber\xe1 utilizar el Sitio Web o la presente App.","legal-area-9":"El Sitio Web y la App est\xe1n dirigidos principalmente a Usuarios residentes en Espa\xf1a. Crush no asegura que el Sitio Web o la App cumplan cumplan con legislaciones de otros pa\xedses, ya sea total o parcialmente. Si el Usuario reside o tiene su domicilio en otro lugar y decide acceder y/o navegar en el Sitio Web o acceder o usar la App, lo har\xe1 bajo su propia responsabilidad y deber\xe1 asegurarse de que tal acceso, navegaci\xf3n o uso cumple con la legislaci\xf3n local que le es aplicable, no asumiendo Crush responsabilidad alguna que se pueda derivar de dicho acceso o uso.","legal-area-10":"Crush podr\xe1, en cualquier momento, y sin previo aviso, modificar las presentes Condiciones de Uso, las cuales ser\xe1n publicadas a medida que se produzcan dichas modificaciones.","legal-conditions":"3. Condiciones de acceso y uso","legal-conditions-1":"El acceso al Sitio Web o a la App por el Usuario, por regla general, es gratuito. En el supuesto de que existan funcionalidades o servicios reservados a determinados Usuarios o que sea necesario pagar un precio, estos quedar\xe1n debidamente identificados en el Sitio Web o en la App.","legal-conditions-2":"El acceso al Sitio Web o la App se realiza bajo exclusiva responsabilidad del Usuario, y no supone entablar ning\xfan tipo de relaci\xf3n de car\xe1cter comercial entre Crush y el Usuario. El Usuario es responsable de asegurarse que las informaciones y contenidos incluidos en el Sitio Web o en la App cumplen con sus requerimientos espec\xedficos.","legal-conditions-3":"El Usuario se compromete a:","legal-conditions-4":"Acceder y utilizar el Sitio Web como la App conforme a la buena fe y de acuerdo con las presentes Condiciones de Uso, la Ley, la moral y el orden p\xfablico, con el requisito adicional de alcanzar una edad m\xednima de 15 a\xf1os.","legal-conditions-5":"Desde Crush, certificamos que cumplimos con la legislaci\xf3n aplicable sobre seguridad infantil y abordamos de manera seria el material de abuso sexual infantil. Tomamos medidas adecuadas, como la eliminaci\xf3n del mencionado material una vez que tengamos conocimiento real de su existencia, de acuerdo con nuestros est\xe1ndares y las leyes pertinentes.","legal-conditions-6":"Aportar informaci\xf3n veraz, actual y l\xedcita en los formularios ofrecidos tanto en el Sitio Web como en la App. En todo caso, el Usuario notificar\xe1 de forma inmediata a Crush acerca de cualquier hecho que permita el uso indebido de la informaci\xf3n registrada en dichos formularios, tales como, pero no s\xf3lo, el robo, extrav\xedo, o el acceso no autorizado a identificadores y/o contrase\xf1as, con el fin de proceder a su inmediata cancelaci\xf3n.","legal-conditions-7":"No realizar ninguna acci\xf3n sobre el Sitio Web o la App que pueda ocasionar da\xf1os o alteraciones en los contenidos, programas o sistemas del Sitio Web o la App, incluyendo la introducci\xf3n de virus inform\xe1ticos, la instalaci\xf3n de robots, o cualquier software o archivo da\xf1ino, defectuoso, o en definitiva que pueda causar da\xf1os a nuestros sistemas inform\xe1ticos.","legal-conditions-8":"El Usuario responder\xe1 en todo caso de los da\xf1os y perjuicios que pueda causar tanto a Crush como a terceros y Crush podr\xe1 adoptar las medidas t\xe9cnicas, legales y de cualquier \xedndole que estime pertinentes para prevenir, mitigar o detener las consecuencias de las conductas prohibidas anteriores y para exigir cuantas responsabilidades se estimen pertinentes.","legal-property":"4. Propiedad intelectual e industrial","legal-property-1":"Todos los contenidos, tanto del Sitio Web como de la App, incluyendo, sin car\xe1cter limitativo, los textos, im\xe1genes, fotograf\xedas, v\xeddeos, gr\xe1ficos, signos distintivos de cualquier clase, iconos, interfaces, as\xed como el software, c\xf3digo fuente, dise\xf1os, arquitectura, presentaci\xf3n, disposici\xf3n y clasificaci\xf3n de los contenidos y cualquier otro elemento presente en el Sitio Web o la App que pueda ser objeto de derechos de propiedad intelectual son propiedad de Crush o de terceros que han licenciado, autorizado o consentido su utilizaci\xf3n en el Sitio Web o en la App.","legal-property-2":"En este sentido, cuando el Usuario accede, navega y utiliza el Sitio Web o accede o usa la App, no se le confiere ning\xfan derecho de explotaci\xf3n que exista o pueda existir sobre la totalidad o parte de estos, reserv\xe1ndose Crush todos estos derechos. El Usuario \xfanicamente puede visualizar los elementos del Sitio Web y la App y utilizarlos en la medida de lo estrictamente necesario para el correcto uso de estos. En especial, esta prohibido utilizar o revender con fines comerciales cualquier material o contenido presente en el Sitio Web o la App sin contar con la previa autorizaci\xf3n de Crush.","legal-property-3":"Crush se reserva la facultad de modificar, en cualquier momento, y sin aviso previo, la presentaci\xf3n y configuraci\xf3n del Sitio Web o de la App y de los contenidos y servicios que en ellos pudieran estar incorporados. El Usuario reconoce y acepta que en cualquier momento Crush pueda interrumpir, desactivar y/o cancelar cualquiera de estos elementos que se integran en el Sitio Web y la App o el acceso a los mismos.","legal-property-4":"Si el Usuario considera que cualquiera de los contenidos del Sitio Web o de la App supone una violaci\xf3n de los derechos de protecci\xf3n de la propiedad intelectual, deber\xe1 comunicarlo inmediatamente a Crush a trav\xe9s de los datos de contacto del apartado 1 (Identificaci\xf3n del Titular) de estas Condiciones de Uso.","legal-disclaimer":"5. Exclusi\xf3n de garant\xedas y responsabilidad","legal-disclaimer-1":"La informaci\xf3n publicada en el Sitio Web o en la App puede no ser exhaustiva o no estar totalmente actualizada, por lo que Crush no asume ninguna responsabilidad derivada de la falta de integridad, actualizaci\xf3n o precisi\xf3n de los datos e informaciones contenidas en las distintas p\xe1ginas que forman parte del Sitio Web o de la App.","legal-disclaimer-2":"Crush no garantiza el acceso a la App o al Sitio Web sea ininterrumpido o que est\xe9 libre de errores. Asimismo, Crush tampoco garantiza que el contenido o software presente en el Sitio Web o la App no causen un da\xf1o al sistema inform\xe1tico (software y hardware) del Usuario. Crush no ser\xe1 responsable por las p\xe9rdidas, navegaci\xf3n y el uso del Sitio Web o la App, incluy\xe9ndose, pero no limit\xe1ndose, a los ocasionados a los sistemas inform\xe1ticos o los provocados por la introducci\xf3n de virus.","legal-disclaimer-3":"Crush, igualmente, queda exonerada de cualquier responsabilidad derivada de un uso inadecuado del Sitio Web o la App por parte del Usuario.","legal-links":"6. Enlaces","legal-links-1":"Se informa que tanto en el Sitio Web como en la App puedan encontrarse, entre otros, links, banners, botones, directorios y motores de b\xfasqueda que permiten a los Usuarios acceder a otros sitios webs o apps pertenecientes y/o gestionados por terceros y que, por tanto, escapan al control de Crush, quien no pueda asumir responsabilidades por el contenido que aparezca en dichas p\xe1ginas o apps.","legal-links-2":"En caso de que considere que dicho contenido resulta inapropiado o contrario a los fines de Crush, le rogamos que lo ponga en nuestro conocimiento a trav\xe9s de los medios de contacto acteriormente expuestos, a fin de que adoptemos las medidas oportunas.","legal-jurisdiction":"7. Legislaci\xf3n aplicable y jurisdicci\xf3n","legal-jurisdiction-1":"Las presentes Condiciones de Uso y su ejecuci\xf3n quedan sometidas a la legislaci\xf3n espa\xf1ola.","legal-jurisdiction-2":"Si surgiese cualquier controversia sobre la interpretaci\xf3n o aplicaci\xf3n de las presentes Condiciones de Uso, las Partes negociar\xe1n de buena fe para intentar resolver tal discrepancia o reclamaci\xf3n. No obstante, para el supuesto de que la discrepancia o la reclamaci\xf3n no se resolviera las Partes se someter\xe1n a los juzgados o tribunales que correspondan conforme a derecho.","privacy-title":"Crush - Privacidad","privacy-date":"\xdaltima modificaci\xf3n: 8 diciembre, 2023","privacy-header":"Pol\xedtica de privacidad","privacy-introduction-1":"En Crush, nos comprometemos a asegurar que tus datos personales est\xe9n protegidos y no se utilicen para finalidades distintas de las indicadas en la presente Pol\xedtica de Privacidad. Por esta raz\xf3n, en este apartado informamos a los usuarios e interesados de todo lo concerniente al tratamiento de sus datos personales, dando as\xed cumplimiento a la normativa de protecci\xf3n de datos aplicable en nuestro pa\xeds: Reglamento General de Protecci\xf3n de Datos (UE) 2016/679, de 27 de abril relativo a la protecci\xf3n de las personas f\xedsicas en lo que respecta al tratamiento de datos personales y a la libre circulaci\xf3n de estos datos (en adelante,","privacy-introduction-2":"\'RGPD\'","privacy-introduction-3":") y Ley Org\xe1nica 3/2018, de 5 de diciembre, de Protecci\xf3n de Datos Personales y garant\xeda de los derechos digitales (en adelante,","privacy-introduction-4":"\'LOPDGDD\'","privacy-introduction-5":"La presente Pol\xedtica de Privacidad es aplicable a los tratamientos de datos que CRUSH SOCIAL NETWORK, S.L., realiza tanto a trav\xe9s sitio web: www.crushsocialnetwork.com (en adelante, el \'Sitio Web\'), como a trav\xe9s de la aplicaci\xf3n m\xf3vil para Smartphone con el nombre \'Crush\' (en adelante, la \'App\') y/o aquellos que se indiquen. Te recomendamos que la leas con detenimiento antes de utilizar el Sitio Web o la App y suministrar tus datos a trav\xe9s de estos. No dudes en consultarnos cualquier duda al respecto a trav\xe9s del correo electr\xf3nico:","privacy-index":"\xcdndice de contenidos","privacy-index-1":"En esta Pol\xedtica encontrar\xe1s toda la informaci\xf3n relativa al tratamiento de tus datos personales y a los derechos que puedes ejercer para mantener el control sobre los mismos. En este sentido, encontrar\xe1s informaci\xf3n sobre:","privacy-index-2":"Qui\xe9n es el responsable del tratamiento de sus datos.","privacy-index-3":"Qu\xe9 requisitos debes cumplir para suministrarnos tus datos personales.","privacy-index-4":"Qu\xe9 tratamientos de datos realizamos a trav\xe9s de la Aplicaci\xf3n y cu\xe1les son sus principales caracter\xedsticas, explic\xe1ndote:","privacy-index-5":"Qu\xe9 datos recogemos y cu\xe1les son las v\xedas de recogida de estos.","privacy-index-6":"Para qu\xe9 finalidades recabamos los datos que te solicitamos.","privacy-index-7":"Cu\xe1l es la legitimaci\xf3n para su tratamiento.","privacy-index-8":"Durante cu\xe1nto tiempo los conservamos.","privacy-index-9":"A qu\xe9 destinatarios se comunican tus datos.","privacy-index-10":"Existencia de transferencias internacionales de tus datos.","privacy-index-11":"Cu\xe1les son tus derechos y c\xf3mo puedes ejercerlos.","privacy-index-12":"C\xf3mo protegemos tu informaci\xf3n personal.","privacy-index-13":"Modificaciones de esta pol\xedtica.","privacy-controller":"1. \xbfQui\xe9n es el responsable del tratamiento de tus datos personales?","privacy-controller-1":"Tus datos personales ser\xe1n tratados por la empresa CRUSH SOCIAL NETWORK, S.L. (","privacy-controller-2":"\'CRUSH\'","privacy-controller-3":"), con NIF B-72599830 y cuyos datos de contacto son los siguientes:","privacy-controller-4":"Direcci\xf3n:","privacy-controller-5":"Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Espa\xf1a)","privacy-controller-6":"Email de contacto:","privacy-dpo":"1.1. Nuestro Delegado de Protecci\xf3n de Datos","privacy-dpo-1":"Desde CRUSH, ponemos a tu disposici\xf3n los datos de contacto de nuestro Delegado de Protecci\xf3n de Datos, a qui\xe9n puedes dirigir cualquier consulta que tengas en relaci\xf3n con la presente Pol\xedtica de Privacidad o el tratamiento de tus datos personales.","privacy-dpo-2":"E-mail:","privacy-requirements":"2. \xbfQu\xe9 requisitos debes cumplir para suministrarnos tus datos personales?","privacy-requirements-1":"2.1. Edad m\xednima. Para suministrarnos tus datos personales y utilizar nuestro Sitio Web y nuestra App deber\xe1s ser mayor de 15 a\xf1os.","privacy-requirements-2":"2.2. Veracidad. Cuando nos proporcionas tus datos para utilizar nuestros servicios, garantizas que los datos e informaci\xf3n facilitada es real, veraz, actualizada y adem\xe1s te pertenece a ti y no a terceras personas.","privacy-requirements-3":"Adem\xe1s, deber\xe1s notificarnos cualquier modificaci\xf3n que se produzca en los datos facilitados, respondiendo en cualquier caso de la veracidad y exactitud de los datos suministrados en cada momento.","privacy-requirements-4":"2.3. Control de Edad y Veracidad. Desde CRUSH nos reservamos el derecho a verificar tu edad e informaci\xf3n identificativa, si es necesario, incluso requiri\xe9ndote un documento oficial acreditativo o procedimiento equivalente y, en caso de detecci\xf3n de fraude que se compruebe o se sospeche que eres menor de la edad indicada, a eliminar, desactivar temporalmente y/o cancelar tu cuenta.","privacy-processing":"3. \xbfQu\xe9 tratamientos de datos realizamos a trav\xe9s del Sitio Web y la App y cu\xe1les son sus principales caracter\xedsticas?","privacy-processing-1":"A continuaci\xf3n, te explicamos c\xf3mo tratamos tu informaci\xf3n personal y te proporcionamos, en detalle, toda la informaci\xf3n relevante relativa a tu privacidad:","privacy-contact":"3.1. Cuando contactas con nosotros a trav\xe9s de nuestros canales (formulario de contacto, chat, correo electr\xf3nico)","privacy-contact-1":"\xbfCu\xe1les son las v\xedas de recogida de los datos?","privacy-contact-2":"Formulario de contacto.","privacy-contact-3":"Chat.","privacy-contact-4":"Env\xedo de correos electr\xf3nicos a la direcci\xf3n","privacy-contact-5":"u otras direcciones electr\xf3nicas de CRUSH.","privacy-contact-6":"\xbfQu\xe9 datos recogemos?","privacy-contact-7":"Informaci\xf3n identificativa y de contacto.","privacy-contact-8":"Recogemos tus datos identificativos (nombre y apellidos) y la direcci\xf3n de correo electr\xf3nico, as\xed como cualquier otra que incluyas de forma voluntaria en las comunicaciones que nos remitas.","privacy-contact-9":"Podremos solicitarte informaci\xf3n adicional si es necesario para cumplir con tu solicitud o requerimiento.","privacy-contact-10":"\xbfCu\xe1les son las finalidades del tratamiento de tus datos personales?","privacy-contact-11":"Contestar a tus solicitudes.","privacy-contact-12":"La principal finalidad del tratamiento de estos datos ser\xe1 la de contestar tus solicitudes, resolver tus dudas y/o suministrarte la informaci\xf3n requerida, as\xed como, en su caso, hacer el seguimiento de tus peticiones.","privacy-contact-13":"Mejorar el servicio de atenci\xf3n al cliente.","privacy-contact-14":"Toda la informaci\xf3n derivada de las dudas, consultas, y el asesoramiento ofrecido a los interesados, as\xed como la forma en la que se resuelven las peticiones nos permite conocer c\xf3mo prestamos nuestro propio servicio de atenci\xf3n al cliente, permiti\xe9ndonos mejorar la calidad del mismo.","privacy-contact-15":"Asimismo, toda la informaci\xf3n recabada, finalizado el tiempo de conservaci\xf3n indicado m\xe1s adelante, se anonimiza y se utiliza a los efectos de poder analizar las preguntas m\xe1s realizadas a trav\xe9s del chat y poder automatizar las m\xe1s frecuentes, elaborar FAQs o conservarse a efectos estad\xedsticos para desarrollar estrategias comerciales.","privacy-contact-16":"\xbfCu\xe1l es la base de legitimaci\xf3n que nos permite tratar tus datos? \xbfEs obligatorio el suministro de estos datos?","privacy-contact-17":"Consentimiento.","privacy-contact-18":"Los datos suministrados para las finalidades anteriores se tratar\xe1n en base a tu consentimiento, otorgado cuando, de manera voluntaria, te pones en contacto con nosotros a trav\xe9s de los medios puestos a tu disposici\xf3n para solicitarnos informaci\xf3n o realizarnos alguna petici\xf3n.","privacy-contact-19":"Toda la informaci\xf3n recabada por el departamento de atenci\xf3n al cliente la trataremos para fines estad\xedsticos que nos servir\xe1 para mejorar la calidad del servicio de atenci\xf3n al cliente prestado. Esta finalidad se considera que es compatible con la inicial.","privacy-contact-20":"La informaci\xf3n que deber\xe1s suministrar de manera obligatoria estar\xe1 indicada con un asterisco o de forma similar. Sin dicha informaci\xf3n no ser\xeda posible atender tus consultas o solicitudes.","privacy-contact-21":"\xbfCu\xe1nto tiempo conservamos tu informaci\xf3n?","privacy-contact-22":"Toda tu informaci\xf3n personal la trataremos durante el tiempo en el que se est\xe9n tramitando tus solicitudes y, en caso necesario, para hacer el seguimiento de estas. Una vez finalizado este periodo, CRUSH conservar\xe1, bloqueada, dicha informaci\xf3n durante los plazos previstos en la legislaci\xf3n para atender eventuales responsabilidades y para demostrar el cumplimiento de nuestras obligaciones. A partir de este momento, CRUSH solo tratar\xe1 la informaci\xf3n de manera anonimizada, por lo que no ser\xe1 posible vincular la informaci\xf3n estad\xedstica con los/as usuarios/as concretos/as a quien hace referencia.","privacy-contact-23":"\xbfA qui\xe9n cedemos tu informaci\xf3n personal?","privacy-contact-24":"No realizamos ninguna cesi\xf3n adicional para llevar a cabo este tratamiento que aquellas indicadas, con car\xe1cter general, en el punto","privacy-contact-25":"4. \xbfA qui\xe9n cedemos tu informaci\xf3n personal?","privacy-contact-26":"En este sentido, algunos canales a trav\xe9s de los cuales puedes ponerte en contacto con nosotros est\xe1n gestionados por proveedores de servicios, que act\xfaan como Encargados de Tratamiento. Encontrar\xe1s m\xe1s informaci\xf3n sobre c\xf3mo act\xfaan estos proveedores de servicios en el punto 4, mencionado anteriormente.","privacy-app-use":"3.2. Cuando te registras y utilizas nuestra App \'Crush\'","privacy-app-use-1":"\xbfCu\xe1les son las v\xedas de recogida de los datos?","privacy-app-use-2":"Formulario de registro en nuestra App y uso de los diferentes espacios de esta.","privacy-app-use-3":"\xbfQu\xe9 datos recogemos?","privacy-app-use-4":"Datos b\xe1sicos para el registro:","privacy-app-use-5":"Para poder darte de alta en nuestra App y utilizar los servicios ser\xe1 necesario que te registres en nuestra App y crees un","privacy-app-use-6":"\'perfil\'.","privacy-app-use-7":"Durante el proceso de registro te requerimos a ti, como usuario, los siguientes datos:","privacy-app-use-8":"Nombre de usuario.","privacy-app-use-9":"Nombre.","privacy-app-use-10":"Email.","privacy-app-use-11":"Fecha de nacimiento.","privacy-app-use-12":"Datos adicionales:","privacy-app-use-13":"Adem\xe1s de lo anterior, nuestra App te permite compartir de forma voluntaria informaci\xf3n relativa a:","privacy-app-use-14":"G\xe9nero.","privacy-app-use-15":"Orientaci\xf3n sexual.","privacy-app-use-16":"Intereses.","privacy-app-use-17":"Pa\xeds, ciudad o regi\xf3n.","privacy-app-use-18":"Descripci\xf3n sobre ti.","privacy-app-use-19":"Profesi\xf3n y estudios.","privacy-app-use-20":"Gustos musicales.","privacy-app-use-21":"Mejor amigo.","privacy-app-use-22":"Si lo autorizas, tu geolocalizaci\xf3n precisa, la cual, si lo has permitido, se lleva a cabo en segundo plano.","privacy-app-use-23":"Datos de uso: se podr\xe1 recopilar informaci\xf3n sobre tus interacciones con el resto de los usuarios (chats con otros usuarios, usuarios con los que conectas e interact\xfaas, momento, frecuencia de interacci\xf3n u otras caracter\xedsticas de tus interacciones).","privacy-app-use-24":"Algunos de los datos que puedes suministrar voluntariamente se consideran sensibles, ya que est\xe1n relacionados con tu orientaci\xf3n sexual. Debes tener en cuenta que, si decides incluir dicha informaci\xf3n, CRUSH la procesar\xe1 junto con el resto de informaci\xf3n para cumplir con las finalidades indicadas m\xe1s abajo. Asimismo, esta informaci\xf3n podr\xe1 ser compartida con el resto de los usuarios (se podr\xe1 hacer p\xfablica), por lo que un uso no autorizado de la App por parte de otros usuarios podr\xeda provocar la filtraci\xf3n de estos datos. CRUSH no se hace responsable del uso inadecuado de los datos por parte de otros usuarios.","privacy-app-use-25":"Te informamos, adem\xe1s, que CRUSH utiliza los datos anteriores con la finalidad de elaborar perfiles con la finalidad de recomendarte contenido que pueda ser de tu inter\xe9s y con las caracter\xedsticas personales que incluyas sobre ti, como se explica m\xe1s abajo.","privacy-app-use-26":"Adem\xe1s, si lo autorizas tendremos acceso a:","privacy-app-use-27":"C\xe1mara (im\xe1genes): otorgar permiso a la c\xe1mara le permite al usuario cargar cualquier imagen directamente a la App.","privacy-app-use-28":"Galer\xeda de fotos (im\xe1genes): otorgar acceso a la galer\xeda de fotos permite al usuario cargar cualquier imagen de su galer\xeda de fotos.","privacy-app-use-29":"Micr\xf3fono (audio): otorgar acceso al micr\xf3fono le permite al usuario utilizar la grabadora de voz del dispositivo directamente desde la App.","privacy-app-use-30":"Contenido publicado por ti:","privacy-app-use-31":"Al utilizar nuestra App, tienes la posibilidad de interactuar con otros/as usuarios/as a trav\xe9s de nuestra comunidad, pudiendo subir publicaciones con contenido audiovisual (fotos, audios, etc., si has otorgado los respectivos permisos) y a\xf1adir comentarios con tus opiniones, plantear dudas y resolver inquietudes de otros/as usuarios/as.","privacy-app-use-32":"Tambi\xe9n ofrecemos un emocionante modo \'Stalker\', donde tus amigos pueden capturar GIFs de ti con tu consentimiento. Sin embargo, la responsabilidad de capturar y solicitar la publicaci\xf3n de estos GIFs en tu perfil recae en el usuario que inicia la solicitud. El GIF no se publicar\xe1 en tu perfil hasta que aceptes la solicitud. Adem\xe1s, todos los colaboradores pueden eliminar permanentemente la publicaci\xf3n, ya sea elimin\xe1ndola directamente o rechazando la solicitud.","privacy-app-use-33":"CRUSH utiliza la tecnolog\xeda de reconocimiento facial de Amazon Web Services para procesar los datos biom\xe9tricos de los usuarios de CRUSH como su proveedor de servicios (\'Procesador\'). Amazon puede procesar y almacenar plantillas de rostros con el fin de proporcionar servicios de verificaci\xf3n y/o identificaci\xf3n de rostros en nombre de CRUSH, y solo seg\xfan las instrucciones de CRUSH. Amazon almacenar\xe1 estos datos siempre que CRUSH lo solicite, que no superar\xe1 un per\xedodo de gracia limitado despu\xe9s de la fecha en que (i) CRUSH deje de tener una relaci\xf3n con Amazon o (ii) cuando CRUSH solicite la eliminaci\xf3n.","privacy-app-use-34":"En caso de que publiques posts en la App (lo cual es meramente opcional, no te obligamos a ello) se utilizar\xe1 la tecnolog\xeda de reconocimiento facial de Amazon, que permite detectar rostros y encontrar usuarios similares a ti (gemelos) dentro de nuestro sistema. Este es el \xfanico uso que damos a esta tecnolog\xeda de reconocimiento.","privacy-app-use-35":"Nuestro procesador, Amazon, se compromete a su propio cumplimiento con el RGPD, as\xed como a proporcionar una variedad de productos, funciones, documentaci\xf3n y recursos para ayudar a sus clientes a cumplir con sus obligaciones de cumplimiento en virtud del RGPD.","privacy-app-use-36":"Datos de uso de la App:","privacy-app-use-37":"Tambi\xe9n recogemos autom\xe1ticamente datos de uso de la App, en concreto datos t\xe9cnicos e informaci\xf3n relacionada con el uso que haces de la App, incluyendo, el tipo de dispositivo m\xf3vil, la identificaci\xf3n \xfanica de tu dispositivo m\xf3vil, la direcci\xf3n IP de tu dispositivo m\xf3vil, el sistema operativo m\xf3vil, en su caso, el tipo de navegadores de Internet que utilizas e informaci\xf3n sobre la forma en que utiliza la App, como la frecuencia y tiempo de uso, anuncios en los que has hecho \'click\', etc.","privacy-app-use-38":"Datos sobre ti proporcionados por terceros:","privacy-app-use-39":"Otros usuarios/as de la App pueden proporcionarnos informaci\xf3n sobre ti cuando utilizan nuestros servicios; por ejemplo, cuando interact\xfaan contigo o si nos env\xedan una denuncia que te involucra.","privacy-app-use-40":"\xbfCu\xe1les son las finalidades del tratamiento de tus datos personales?","privacy-app-use-41":"Darte de alta y administrar tu cuenta","privacy-app-use-42":"de forma que podamos verificar tu correo electr\xf3nico y edad para darte de alta en la App, interactuar contigo y darte acceso a nuestros servicios.","privacy-app-use-43":"Gestionar y ejecutar la relaci\xf3n contractual que nos une:","privacy-app-use-44":"realizamos distintas gestiones necesarias para ejecutar el contrato suscrito contigo, de forma que, por ejemplo, podamos prestarte el servicio, contactar contigo para ayudarte a resolver dudas, para verificar la informaci\xf3n que nos has proporcionado. Asimismo, podremos enviarte comunicaciones de car\xe1cter administrativo, sobre actualizaciones, cambios en nuestras condiciones de servicio, alertas de seguridad, as\xed como dar respuesta a cualquier solicitud o requerimiento que nos env\xedes.","privacy-app-use-45":"Publicar tu contenido.","privacy-app-use-46":"Cuando compartes contenido o informaci\xf3n a trav\xe9s de la App, el mismo aparecer\xe1 publicado para el p\xfablico que hayas seleccionado que puede ver lo que compartes. Para a\xf1adir cierto contenido, como fotos y v\xeddeos, deber\xe1s darnos acceso a tu c\xe1mara o a tu galer\xeda de fotos.","privacy-app-use-47":"Cualquier usuario de nuestra App puede visualizar tu nombre de usuario y tu perfil p\xfablico en la App, que incluye contenido que has compartido con el p\xfablico en general. Asimismo, ten en cuenta que tu contenido publicado en la App podr\xe1 ser compartido por el resto de los usuarios dentro o fuera de la App, tomar una captura de pantalla de este o descargarlo.","privacy-app-use-48":"Publicar contenido sobre ti.","privacy-app-use-49":"Otros usuarios de la App pueden crear y compartir contenido en el que aparezca tu imagen o datos con el p\xfablico que elijan. Si no te sientes c\xf3modo con el contenido que otras personas han compartido sobre ti, por favor, denuncialo dando uso de los formularios de la App o contacta con nosotros por correo.","privacy-app-use-50":"Ofrecerte contenido (noticias, art\xedculos, experiencias entre otros)","privacy-app-use-51":"creado directamente por CRUSH o en colaboraci\xf3n con personas externas que pueden ser de tu inter\xe9s.","privacy-app-use-52":"Env\xedo de notificaciones push y alertas dentro de la App.","privacy-app-use-53":"Si lo has autorizado, recibir\xe1s nuestras notificaciones push en tu navegador web o en tu dispositivo m\xf3vil. Las notificaciones push pueden incluir recordatorios, comunicaciones promocionales, alertas y actualizaciones relativas a la App y los servicios.","privacy-app-use-54":"Si activas estas notificaciones, recibir\xe1s avisos personalizados, en base a un perfil que elaboramos sobre ti y el uso que haces de la App. Para la personalizaci\xf3n de avisos, se puede combinar la informaci\xf3n obtenida mediante los datos introducidos por ti en la App y los datos captados relativos al uso de la App (contenido visitado) para crear un perfil en relaci\xf3n con tus intereses y ofrecerte principalmente aquel contenido e informaci\xf3n que encajan contigo.","privacy-app-use-55":"Puedes desactivar las notificaciones push en cualquier momento ajustando la configuraci\xf3n de tu dispositivo m\xf3vil, aunque dicha desactivaci\xf3n no afectar\xe1 al resto de comunicaciones que puedas recibir de CRUSH, tales como las comunicaciones enviadas por correo electr\xf3nico.","privacy-app-use-56":"Prevenci\xf3n, detecci\xf3n y enjuiciamiento de actividades il\xedcitas o contrarias a las condiciones del servicio o que pongan en peligro la seguridad de la informaci\xf3n o la App:","privacy-app-use-57":"CRUSH podr\xe1 procesar los datos para controlar y evitar cualquier forma de abuso de nuestros servicios, como por ejemplo actividades fraudulentas, ataques de denegaci\xf3n de servicios, env\xedo de spam, accesos no autorizados a las cuentas de nuestros usuarios, as\xed como cualquier otra pr\xe1ctica que sea contraria a las Condiciones Generales y de Uso de la App o ponga en peligro la seguridad de la informaci\xf3n o la propia integridad de la App, pudiendo eliminar el contenido o la cuenta que sean contrarios a la ley, a nuestras Condiciones Generales o a las Normas de la Comunidad.","privacy-app-use-58":"Dentro de esta finalidad, se incluye tambi\xe9n el procesamiento de denuncias que presentes contra otros usuarios o las que se presenten contra ti, existiendo la opci\xf3n de contactar con CRUSH para analizar el caso concreto y garantizando que existir\xe1 intervenci\xf3n humana para corregir o subsanar la cuesti\xf3n que se nos plantee.","privacy-app-use-59":"Tambi\xe9n podemos usar herramientas para detectar contenido inapropiado (por ejemplo, contenido para adultos o violento) en el contenido visual que publiques.","privacy-app-use-60":"Para ofrecerte un mejor servicio tambi\xe9n se tratar\xe1n tus datos con la finalidad de:","privacy-app-use-61":"Ayudarte a conectar con otros usuarios, permitiendo tu interacci\xf3n con ellos a trav\xe9s de pantallas de chat y otros mecanismos.","privacy-app-use-62":"Recomendarte a otros usuarios que sean afines a ti.","privacy-app-use-63":"Para realizar las recomendaciones, utilizamos la informaci\xf3n que nos proporcionas, incluyendo informaci\xf3n sobre tu ubicaci\xf3n si das tu permiso, as\xed como la informaci\xf3n que obtenemos del uso de este espacio (por ejemplo, caracter\xedsticas de las personas con las que realmente interact\xfaas) para elaborar un perfil automatizado sobre ti y mostrarte preferentemente aquellos usuarios que encajen con tu perfil y con lo que est\xe1s buscando.","privacy-app-use-64":"En este sentido, se te mostrar\xe1n preferentemente usuarios activos en la App, que est\xe9n cerca de ti, que encajen con las preferencias indicadas y tu perfil elaborado a partir de tus interacciones, asegur\xe1ndonos, adem\xe1s, que tus caracter\xedsticas y perfil encajan con las preferencias de los usuarios recomendados.","privacy-app-use-65":"Finalidades estad\xedsticas y otras realizadas con datos an\xf3nimos.","privacy-app-use-66":"Podemos anonimizar toda la informaci\xf3n personal recopilada de los usuarios que utilizan la App para finalidades estad\xedsticas y otras, como, por ejemplo, entrenamiento de algoritmos, para medir la eficacia de las campa\xf1as publicitarias disponibles en la App, la navegabilidad y usabilidad de la App para poder mejorar el dise\xf1o, presentaci\xf3n y funcionalidades disponibles u otros.","privacy-app-use-67":"Para mostrarte publicidad:","privacy-app-use-68":"Nuestra App puede incluir publicidad que, en caso de que prestes tu consentimiento, ser\xe1 personalizada de acuerdo con tus gustos y preferencias.","privacy-app-use-69":"\xbfCu\xe1l es la base de legitimaci\xf3n que nos permite tratar tus datos? \xbfEs obligatorio el suministro de estos datos?","privacy-app-use-70":"Ejecutar y mantener la relaci\xf3n contractual entre las Partes.","privacy-app-use-71":"La raz\xf3n por la que procesamos tu informaci\xf3n para las finalidades citadas anteriormente es para cumplir con el contrato que tenemos contigo.","privacy-app-use-72":"Consentimiento.","privacy-app-use-73":"Algunas funcionalidades se basan en tu consentimiento expreso: (i) publicaci\xf3n de contenido propio, (ii) acceso a la c\xe1mara o galer\xeda de fotos para publicar determinado contenido en la App, (iii) el acceso a la geolocalizaci\xf3n del dispositivo para recomendaci\xf3n de usuarios por proximidad (iv) la recepci\xf3n de notificaciones push personalizadas (v) visualizaci\xf3n de contenido publicitario personalizado. Asimismo, si decides proporcionarnos la informaci\xf3n voluntaria adicional para completar tu perfil, dicha informaci\xf3n ser\xe1 utilizada en base a tu consentimiento.","privacy-app-use-74":"Recuerda que puedes revocar tu consentimiento en cualquier momento a trav\xe9s de la configuraci\xf3n de tu dispositivo, eliminando tu contenido o a trav\xe9s de las opciones disponibles en la App.","privacy-app-use-75":"Inter\xe9s leg\xedtimo.","privacy-app-use-76":"Se tratar\xe1n en base a nuestro inter\xe9s leg\xedtimo los datos en relaci\xf3n con la prevenci\xf3n de actividades il\xedcitas y otras relacionadas con la seguridad de la App, para garantizar la seguridad de la red y de la informaci\xf3n para prevenir sucesos que puedan comprometer la disponibilidad, autenticidad, integridad y confidencialidad de los datos personales o la propia plataforma, as\xed como el cumplimiento de las normas de la comunidad.","privacy-app-use-77":"Tambi\xe9n podremos mostrarte publicidad no personalizada a trav\xe9s de la App en base a nuestro inter\xe9s leg\xedtimo.","privacy-app-use-78":"Si deseas obtener m\xe1s informaci\xf3n sobre la ponderaci\xf3n que hemos realizado sobre los intereses leg\xedtimos de CRUSH en relaci\xf3n con las anteriores finalidades, puedes solicitarla escribi\xe9ndonos a","privacy-app-use-79":"Tratamiento de datos especialmente protegidos:","privacy-app-use-80":"Los datos relacionados con tus intereses o aspectos relacionados con la orientaci\xf3n sexual se tratar\xe1n en base a tu consentimiento expl\xedcito.","privacy-app-use-81":"\xbfCu\xe1nto tiempo conservamos tu informaci\xf3n?","privacy-app-use-82":"Toda tu informaci\xf3n personal la guardaremos durante el tiempo en el que se mantenga vigente nuestra relaci\xf3n contractual, es decir hasta que elimines tu cuenta. Una vez finalizada la relaci\xf3n contractual o cancelada tu cuenta, CRUSH conservar\xe1, bloqueada, toda la informaci\xf3n durante los plazos previstos en la legislaci\xf3n para investigar conductas il\xedcitas o perjudiciales, atender eventuales responsabilidades y para demostrar el cumplimiento de nuestras obligaciones.","privacy-app-use-83":"En relaci\xf3n con el contenido publicado por ti a trav\xe9s de nuestra App, debes tener en cuenta que cualquier publicaci\xf3n o comentario que hayas publicado en nuestra comunidad se mantendr\xe1 en la App mientras no lo elimines o hasta que elimines tu cuenta. No obstante, cualquier otro contenido donde aparezcas y que haya sido publicado por otros usuarios (por ejemplo, fotos o videos) podr\xeda permanecer visible mientras dicho usuario no lo elimine o cierre su cuenta.","privacy-app-use-84":"No obstante, nos reservamos el derecho a usar tu informaci\xf3n de forma agregada despu\xe9s de cerrar tu cuenta con finalidades estad\xedsticas y de mejora de nuestros servicios. El uso de dicha informaci\xf3n no permitir\xe1 que se te pueda identificar personalmente.","privacy-app-use-85":"\xbfA qui\xe9n cedemos tu informaci\xf3n personal?","privacy-app-use-86":"No existen cesiones concretas de tus datos personales para cumplir con la finalidad indicada en este apartado. No obstante, podemos recurrir a los servicios de proveedores de servicios, quienes tendr\xe1n un acceso limitado a los datos y estar\xe1n ligados a un deber de confidencialidad (para m\xe1s informaci\xf3n sobre c\xf3mo act\xfaan nuestros proveedores de servicios, ver el punto","privacy-app-use-87":"4. \xbfA qui\xe9n cedemos tu informaci\xf3n personal? > Proveedores de Servicios","privacy-app-use-88":"No obstante, ten en cuenta que cuando publicas contenido en nuestra App, puedes estar compartiendo informaci\xf3n personal con otros usuarios (incluido tu perfil p\xfablico).","privacy-app-use-89":"Asimismo, si alguien presenta una denuncia que te implica, podremos comunicar al denunciante las medidas que hemos tomado a ra\xedz de su denuncia, en caso de que las haya.","privacy-cookies":"3.3. Navegaci\xf3n por el Sitio Web (cookies)","privacy-cookies-1":"En nuestro Sitio Web, as\xed como en nuestra App utilizamos cookies u otras herramientas de seguimiento y rastreo para recabar informaci\xf3n acerca del uso que los usuarios realizan del Sitio Web y de la App.","privacy-cookies-2":"Para m\xe1s informaci\xf3n sobre el tratamiento que realizamos a trav\xe9s de dichas herramientas de seguimiento, visita nuestra","privacy-cookies-3":"Pol\xedtica de Cookies","privacy-social-profiles":"3.4. Perfiles de CRUSH en redes sociales","privacy-social-profiles-1":"CRUSH cuenta con perfil en las principales redes sociales, tales como Twitter, Instagram, LinkedIn o TikTok.","privacy-social-profiles-2":"Cuando te haces seguidor de alguna de nuestras p\xe1ginas en las redes sociales, el tratamiento de los datos se regir\xe1 por las condiciones de uso, pol\xedticas de privacidad y normativas de acceso que pertenezcan a la red social correspondiente y aceptadas previamente por el usuario.","privacy-social-profiles-3":"CRUSH, en este sentido, tratar\xe1 tus datos con las finalidades de administrar correctamente su presencia en la red social, inform\xe1ndote de actividades, productos o servicios, as\xed como para cualquier otra finalidad que las normativas de las redes sociales permitan.","privacy-social-profiles-4":"Ten en cuenta que nosotros no tenemos influencia sobre la informaci\xf3n que la red social recoge o c\xf3mo la procesa, por lo que te recomendamos que te mantengas informado del prop\xf3sito y alcance de la recogida de informaci\xf3n que se realiza a trav\xe9s de dichas redes sociales.","privacy-transfer":"4. \xbfA qui\xe9n cedemos tu informaci\xf3n personal?","privacy-transfer-1":"Por lo general, desde CRUSH no comunicaremos tus datos a terceros. No obstante, adem\xe1s de las cesiones que te indicamos espec\xedficamente en el apartado en que te explicamos las caracter\xedsticas de las diferentes operaciones (punto 3), te informamos de las comunicaciones que, con car\xe1cter general, podemos realizar, as\xed como su base legitimadora, que afectan a todos los tratamientos anteriores.","privacy-transfer-2":"Proveedores de servicios esenciales","privacy-transfer-3":"para ejecutar el servicio que te ofrecemos (por ejemplo, empresas de alojamiento inform\xe1tico o plataformas de env\xedo de las comunicaciones comerciales). No obstante lo anterior, estas entidades han firmado los correspondientes acuerdos de confidencialidad y solo tratar\xe1n tus datos seg\xfan nuestras instrucciones, no pudiendo utilizarlos para finalidades propias o aparte del servicio que nos prestan.","privacy-transfer-4":"Organismos P\xfablicos.","privacy-transfer-5":"Podremos revelar a las autoridades p\xfablicas competentes los datos y cualquier otra informaci\xf3n que est\xe9 en nuestro poder o que sea accesible a trav\xe9s de nuestros sistemas cuando exista una obligaci\xf3n legal para ello, as\xed como cuando sea requerida, por ejemplo, cuando la finalidad sea la de prevenir o perseguir abusos de los servicios o actividades fraudulentas a trav\xe9s de nuestro Sitio Web o Aplicaci\xf3n. En estos casos, los datos de car\xe1cter personal que nos facilites se conservar\xedan y pondr\xedan a disposici\xf3n de las autoridades administrativas o judiciales.","privacy-transfer-6":"En caso de una operaci\xf3n societaria:","privacy-transfer-7":"En caso de una fusi\xf3n, una adquisici\xf3n, venta de la totalidad o parte de sus activos o cualquier otro tipo de operaci\xf3n societaria en la que intervenga un tercero, podremos compartir, divulgar o transferir los datos de los usuarios a la entidad sucesora (incluso durante la fase previa a la operaci\xf3n).","privacy-transfer-8":"A terceros despu\xe9s de una agregaci\xf3n o anonimizaci\xf3n:","privacy-transfer-9":"podremos divulgar o utilizar datos agregados o anonimizados (es decir, los cuales no sean vinculables a una persona f\xedsica identificada o identificable) para cualquier finalidad.","privacy-transfer-10":"A terceros con el consentimiento del usuario u otra base leg\xedtima:","privacy-transfer-11":"En el caso de que queramos compartir datos con terceros fuera del \xe1mbito de esta Pol\xedtica de privacidad se solicitar\xe1, en todo caso, su consentimiento o se informar\xe1 sobre la misma y su base leg\xedtima.","privacy-transfer-12":"Asimismo, te informamos de que esta Pol\xedtica de Privacidad s\xf3lo se refiere a la recogida, tratamiento y uso de informaci\xf3n (relativa a datos personales) por nuestra parte a trav\xe9s de la interacci\xf3n que realizas con nuestro Sitio Web o Aplicaci\xf3n. El acceso a p\xe1ginas Web de terceros a las que puedas acceder a trav\xe9s de enlaces desde el Sitio Web o la App tienen sus propias pol\xedticas de privacidad sobre las que no tenemos ning\xfan control. Por ello, antes de facilitarles alguna informaci\xf3n personal, te recomendamos que te informes sobre sus Pol\xedticas de Privacidad.","privacy-eea":"5. \xbfSe transfieren tus datos personales a terceros pa\xedses fuera del Espacio Econ\xf3mico Europeo?","privacy-eea-1":"Algunos de nuestros prestadores de servicios est\xe1n ubicados en pa\xedses fuera del Espacio Econ\xf3mico Europeo (","privacy-eea-2":"\'EEE\'","privacy-eea-3":"La ubicaci\xf3n de estas compa\xf1\xedas fuera del EEE implican la existencia de una transferencia internacional de tus datos personales, lo que podr\xeda suponer un menor grado de protecci\xf3n que el recogido en la normativa europea. No obstante, desde CRUSH hemos aplicado medidas para que dichas transferencias no den lugar a un menor grado de protecci\xf3n de tus datos personales.","privacy-eea-4":"En este sentido, los proveedores de servicios que se encuentran fuera del EEE han suscrito las correspondientes cl\xe1usulas contractuales tipo aprobadas por la Comisi\xf3n Europea (","privacy-eea-5":"\'CCT\'","privacy-eea-6":"), acuerdo firmado entre ambas entidades por el cual la empresa extracomunitaria garantiza que aplica los est\xe1ndares europeos de protecci\xf3n de datos.","privacy-eea-7":"Por ello, la utilizaci\xf3n de estos proveedores no da lugar a un menor grado de protecci\xf3n de tus datos personales que el que tendr\xeda la utilizaci\xf3n de proveedores ubicados en la Uni\xf3n Europea. Puedes consultar el contenido de las CCT en el siguiente enlace:","privacy-eea-8":"A continuaci\xf3n, te indicamos cuales son las transferencias internacionales que realizamos desde CRUSH:","privacy-eea-9":"Nombre","privacy-eea-10":"Actividades afectadas","privacy-eea-11":"Pa\xeds","privacy-eea-12":"Mecanismo de transferencia","privacy-eea-13":"Todas","privacy-eea-14":"Detecci\xf3n de rostros y b\xfasqueda de similares","privacy-eea-15":"Notificaciones push","privacy-eea-16":"Env\xedo de correos electr\xf3nicos","privacy-eea-usa":"EE.UU","privacy-eea-sccs":"Cl\xe1usulas Contractuales Tipo (CCS)","privacy-rights":"6. \xbfCu\xe1les son los derechos que puedes ejercer como interesad@?","privacy-rights-1":"Puedes ejercer los derechos que la ley te garantiza en relaci\xf3n con el tratamiento de tus datos personales contactando con nuestro Delegado de Protecci\xf3n de Datos a trav\xe9s del correo electr\xf3nico","privacy-rights-2":"Cualquier petici\xf3n de derechos que recibamos la resolveremos lo antes posible y, en cualquier caso, dentro del plazo m\xe1ximo establecido por la legislaci\xf3n, a partir de la fecha de recepci\xf3n. En algunos casos, ser\xe1 necesario solicitarte una copia de tu documento de identidad u otro documento identificativo para verificar tu identidad.","privacy-rights-3":"Los derechos que te corresponden como interesad@, son los siguientes:","privacy-rights-4":"Derecho a retirar el consentimiento otorgado","privacy-rights-5":"Puedes revocar tu consentimiento en relaci\xf3n con todos los procesamientos basados en \xe9l en cualquier momento. No obstante, la retirada del consentimiento no afectar\xe1 a la licitud del tratamiento basada en el consentimiento previo a su retirada.","privacy-rights-6":"Derecho de acceso","privacy-rights-7":"Tienes derecho a saber qu\xe9 datos est\xe1n siendo objeto de tratamiento, si procede y, si es as\xed, obtener una copia de estos, as\xed como a obtener informaci\xf3n relativa a:","privacy-rights-8":"el origen y los destinatarios de los datos;","privacy-rights-9":"las finalidades para las que se tratan;","privacy-rights-10":"si existe un proceso de toma de decisiones automatizado, incluida la elaboraci\xf3n de perfiles;","privacy-rights-11":"el per\xedodo de retenci\xf3n de los datos; y","privacy-rights-12":"los derechos previstos por la normativa.","privacy-rights-13":"Derecho de rectificaci\xf3n","privacy-rights-14":"Tienes derecho a obtener la rectificaci\xf3n de tus datos personales o a completarlos cuando est\xe1n incompletos.","privacy-rights-15":"Derecho de supresi\xf3n","privacy-rights-16":"Tienes derecho a solicitar la supresi\xf3n de tus datos personales si ya no son necesarios para el prop\xf3sito para el que fueron recopilados o, en su caso, si ya no estamos autorizados para tratarlos.","privacy-rights-17":"Derecho a la portabilidad de datos","privacy-rights-18":"Tienes derecho a solicitar la portabilidad de tus datos en el caso de los tratamientos que est\xe9n basados en tu consentimiento o en la ejecuci\xf3n de un contrato, siempre y cuando el procesamiento se haya realizado por medios automatizados. En caso de ejercicio de este derecho, recibir\xe1s tus datos personales en un formato estructurado, de uso com\xfan y legible por cualquier dispositivo electr\xf3nico. No obstante, tambi\xe9n puedes solicitar, cuando sea posible, que tus datos sean transmitidos directamente a otra empresa.","privacy-rights-19":"Derecho a la limitaci\xf3n del tratamiento de tus datos personales","privacy-rights-20":"Tienes derecho a la limitaci\xf3n del procesamiento de tus datos en los siguientes casos:","privacy-rights-21":"Cuando hayas solicitado la rectificaci\xf3n de tus datos personales, durante el per\xedodo en el que verificamos la exactitud de los mismos.","privacy-rights-22":"Cuando consideres que no estamos autorizados para procesar tus datos. En ese caso, puedes solicitarnos que limitemos su uso en vez de solicitar su supresi\xf3n.","privacy-rights-23":"Cuando consideres que ya no es necesario que sigamos tratando tus datos y quieras que los conservemos a los efectos del ejercicio o la defensa de reclamaciones.","privacy-rights-24":"En los casos en los que exista un procesamiento basado en nuestro inter\xe9s leg\xedtimo y hayas ejercitado tu derecho de oposici\xf3n al mismo, puedes pedirnos que limitemos el uso de tus datos durante la verificaci\xf3n de la prevalencia de dichos intereses con respecto a los tuyos.","privacy-rights-25":"Derecho de oposici\xf3n","privacy-rights-26":"Tienes derecho a oponerte en cualquier momento al procesamiento de tus datos personales en funci\xf3n de nuestro inter\xe9s leg\xedtimo, incluida la elaboraci\xf3n de perfiles.","privacy-rights-27":"Derecho a presentar una reclamaci\xf3n ante la Autoridad de Control","privacy-rights-28":"Recuerda que, en cualquier momento, y en caso de que consideres que hemos vulnerado tu derecho a la protecci\xf3n de tus datos, podr\xe1s dirigirte en su defensa a la Autoridad de Control correspondiente, en caso de Espa\xf1a, la Agencia Espa\xf1ola de Protecci\xf3n de Datos (","privacy-confidence":"7. \xbfC\xf3mo garantizamos la confidencialidad de tu informaci\xf3n?","privacy-confidence-1":"La seguridad de tus datos personales es una prioridad para nosotros. Por ello, CRUSH ha implantado todas las medidas de seguridad necesarias para garantizar un uso y tratamiento de los datos de car\xe1cter personal facilitados por el/la usuario eficaz, salvaguardando la intimidad, privacidad, confidencialidad e integridad de estos, y hace uso de los medios t\xe9cnicos necesarios para evitar la alteraci\xf3n, p\xe9rdida, acceso no autorizado o tratamiento de sus datos, seg\xfan el estado de la tecnolog\xeda en cada momento.","privacy-confidence-2":"Consecuentemente, cumplimos con los est\xe1ndares de seguridad recomendados para protegerlos. Sin embargo, es imposible garantizar de un modo total su seguridad por la propia naturaleza de Internet y porque pueden existir actuaciones dolosas de terceros fuera de nuestro control.","privacy-confidence-3":"Nos comprometemos a actuar con rapidez y diligencia en caso de que la seguridad de los datos se vea en peligro o comprometida, y a informarte sobre ello en caso de que sea relevante.","privacy-modifications":"8. Modificaciones de la presente pol\xedtica","privacy-modifications-1":"Desde CRUSH podemos modificar el contenido de esta Pol\xedtica de Privacidad en cualquier momento, especialmente cuando se produzcan modificaciones legislativas, jurisprudenciales o de interpretaci\xf3n de la Agencia Espa\xf1ola de Protecci\xf3n de Datos que afecten a los tratamientos de datos realizados por CRUSH a trav\xe9s del Sitio Web o la App. Cualquier nueva versi\xf3n de esta Pol\xedtica de Privacidad entrar\xe1 en vigor en la fecha de entrada en vigor publicada.","privacy-modifications-2":"Si la versi\xf3n revisada incluye un cambio sustancial que afecte al tratamiento de tus datos, te lo notificaremos con, al menos, 30 d\xedas de antelaci\xf3n publicando un aviso en nuestro Sitio Web o nuestra App o comunic\xe1ndotelo a trav\xe9s del correo electr\xf3nico. De todas maneras, te recomendamos que revises peri\xf3dicamente esta Pol\xedtica de Privacidad para estar informado de c\xf3mo se tratan y protegen tus datos personales, as\xed como de los derechos que te asisten.","cookies-title":"Crush - Cookies","cookies-date":"\xdaltima modificaci\xf3n: 8 diciembre, 2023","cookies-header":"Pol\xedtica de cookies","cookies-introduction-1":"Tanto en el sitio web www.crushsocialnetwork.com (en adelante, el","cookies-introduction-2":"\'Sitio Web\'","cookies-introduction-3":") como a trav\xe9s de la aplicaci\xf3n m\xf3vil para Smartphone con el nombre \'Crush\' (en adelante, la","cookies-introduction-4":"\'App\'","cookies-introduction-5":") utilizamos cookies u otras herramientas de seguimiento y rastreo para recabar informaci\xf3n acerca del uso que los/as usuarios/as realizan del Sitio Web y la App.","cookies-introduction-6":"En este documento descubrir\xe1s qu\xe9 cookies le damos al Monstruo de las Galletas, as\xed como cualquier otro tipo de informaci\xf3n relacionada con este maravilloso bocado.","cookies-definition":"1. \xbfQu\xe9 es una cookie?","cookies-definition-1":"Una cookie es un archivo que se instala en el navegador de tu dispositivo (ordenador, m\xf3vil, etc.) con la finalidad de almacenar y recuperar datos. Las cookies pueden tener multitud de finalidades, seg\xfan para que se hayan configurado: por ejemplo, guardar preferencias, recoger estad\xedsticas de uso, permitir funcionalidades t\xe9cnicas, entre otras.","cookies-responsible":"2. \xbfQui\xe9n es el responsable?","cookies-responsible-1":"El responsable del tratamiento de la informaci\xf3n recopilada mediante cookies es CRUSH SOCIAL NETWORK, S.L. (CRUSH), con NIF B-72599830 y direcci\xf3n en Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Espa\xf1a).","cookies-responsible-2":"Si tuvieras cualquier duda relacionada con el uso de cookies, por favor, escribe un email a","cookies-responsible-3":"y te responderemos tan pronto como sea posible.","cookies-data":"3. \xbfQu\xe9 datos se recogen a trav\xe9s de las cookies?","cookies-data-1":"Cuando accedes al Sitio Web o instalas y usas la App, aunque no te hayas registrado, se recopila la siguiente informaci\xf3n mediante las cookies:","cookies-data-2":"Informaci\xf3n del dispositivo: Durante la utilizaci\xf3n del Sitio Web o de la App, recopilamos informaci\xf3n sobre el dispositivo m\xf3vil desde el que accedes a la plataforma. La informaci\xf3n que obtenemos es el modelo del dispositivo, el sistema operativo y la versi\xf3n, el identificador \xfanico del dispositivo y la red.","cookies-data-3":"Informaci\xf3n sobre tu ubicaci\xf3n: Tambi\xe9n obtenemos la direcci\xf3n IP, zona horaria y cu\xe1l es el proveedor de servicio m\xf3vil, en su caso, lo que nos permite obtener una ubicaci\xf3n general.","cookies-data-4":"Informaci\xf3n de la navegaci\xf3n del usuario: Recopilamos informaci\xf3n sobre el uso que haces del Sitio Web y de la App. En concreto, la frecuencia de uso, los apartados que visitas, uso de funciones espec\xedficas, etc.","cookies-types":"4. \xbfQu\xe9 tipo de cookies existen?","cookies-types-1":"Seg\xfan su finalidad,","cookies-types-2":"podemos clasificar las cookies entre las siguientes:","cookies-types-3":"Cookies t\xe9cnicas:","cookies-types-4":"Estas cookies son las estrictamente necesarias para navegar por el Sitio Web o la App y permiten funciones b\xe1sicas como la navegaci\xf3n de una secci\xf3n a otra. Se encargan de aspectos t\xe9cnicos como identificar perfiles o sesiones y gestionar preferencias de herramientas en el uso, interacci\xf3n y localizaci\xf3n del acceso a los contenidos. Tambi\xe9n pertenecen a esta categor\xeda, por su naturaleza t\xe9cnica, aquellas cookies que permiten la gesti\xf3n, de la forma m\xe1s eficaz posible, de los espacios publicitarios incluidos en el Sitio Web y la App, sin que se recopile informaci\xf3n de los usuarios con fines distintos, como puede ser personalizar anuncios u otros tipos de contenido.","cookies-types-5":"Cookies estad\xedsticas:","cookies-types-6":"Estas cookies miden y recogen informaci\xf3n estad\xedstica relativa al uso que realiza el usuario del Sitio Web o la App, como el tiempo de permanencia en la plataforma, el n\xfamero de visitas o los contenidos visitados. Dicha informaci\xf3n permite comprender c\xf3mo interact\xfaan los usuarios con el Sitio Web y la App, evaluar el rendimiento, qu\xe9 secciones son las m\xe1s o menos visitadas, incluida la cuantificaci\xf3n de los impactos de los anuncios introducidos en el Sitio Web y la App (en su caso). Teniendo esta informaci\xf3n se pueden solucionar errores, y mejorar el dise\xf1o del sistema y el contenido que se ofrece a trav\xe9s del mismo.","cookies-types-7":"Cookies de preferencias o de personalizaci\xf3n:","cookies-types-8":"Las cookies de preferencias permiten que el Sitio Web o la App recuerden informaci\xf3n del usuario para que este acceda al servicio con determinadas caracter\xedsticas que pueden diferenciar su experiencia de la de otros usuarios. Por ejemplo, su idioma preferido o la regi\xf3n desde la que accede, el n\xfamero de resultados a mostrar cuando el usuario realiza una b\xfasqueda, el aspecto o contenido del servicio en funci\xf3n del tipo de dispositivo desde el cual el usuario accede a \xe9l, etc.","cookies-types-9":"Cookies de publicidad comportamental:","cookies-types-10":"Estas cookies permiten la gesti\xf3n de los espacios publicitarios que, en su caso, haya incluidos en el Sitio Web o la App. No obstante, la gesti\xf3n de los espacios publicitarios se hace en base al perfil de navegaci\xf3n del usuario. Estas cookies almacenan informaci\xf3n de la navegaci\xf3n de los usuarios obtenida a trav\xe9s de la observaci\xf3n continuada de sus h\xe1bitos de navegaci\xf3n, desarrollando un perfil espec\xedfico del usuario, por lo que los anuncios que aparecen en estos espacios ser\xe1n personalizados para el usuario seg\xfan dichos h\xe1bitos.","cookies-types-11":"En funci\xf3n de la entidad que las gestione:","cookies-types-12":"Cookies propias:","cookies-types-13":"son aquellas que se env\xedan al dispositivo del usuario desde un equipo o dominio gestionado por el responsable del Sitio Web o la App, en este caso, CRUSH, y desde el que se presta el servicio solicitado por el/la usuario/a.","cookies-types-14":"Cookies de terceros:","cookies-types-15":"son aquellas que se env\xedan al dispositivo del usuario desde un equipo o dominio que no es gestionado por el responsable del Sitio Web o la App, sino por otra entidad que trata los datos obtenidos a trav\xe9s de las cookies.","cookies-types-16":"En funci\xf3n del tiempo que permanecen activas en el dispositivo:","cookies-types-17":"Cookies de sesi\xf3n:","cookies-types-18":"Est\xe1n dise\xf1adas para recabar y almacenar datos durante el tiempo en el que el/la usuario/a est\xe1 navegando por el Sitio Web o la App, y se desactivan al finalizar la navegaci\xf3n.","cookies-types-19":"Cookies persistentes:","cookies-types-20":"Estas almacenan los datos que pueden ser accedidos y tratados durante un periodo definido por el responsable de la cookie. Sus tiempos de vida pueden comprender minutos o a\xf1os.","cookies-used":"5. \xbfQu\xe9 cookies utilizamos concretamente en nuestra plataforma?","cookies-used-1":"En nuestra plataforma, utilizamos las siguientes cookies:","cookies-used-2":"Nombre","cookies-used-3":"Finalidad","cookies-used-4":"Cookies Propias/Terceros","cookies-used-5":"Caducidad","cookies-used-6":"14 meses","cookies-used-7":"Indefinida","cookies-used-stats":"Estad\xedstica","cookies-used-technical":"T\xe9cnica","cookies-used-third-party-google":"Terceros (Google LLC.)","cookies-legitimation":"6. \xbfCu\xe1l es la base de legitimaci\xf3n que nos permite tratar sus datos a trav\xe9s de las cookies? En su caso, \xbfson obligatorias?","cookies-legitimation-1":"La informaci\xf3n que recogemos a trav\xe9s de las cookies y dem\xe1s dispositivos de rastreo se basa en tu consentimiento, el cual te solicitamos cuando accedes al Sitio Web o cuando instalas la App a trav\xe9s de un pop-up informativo o de la forma que establece Google (cuando se trata de Android) o Apple (cuando se trata de iOS).","cookies-legitimation-2":"En este sentido, en cualquier momento puedes retirar tu consentimiento como te explicamos en el apartado relativo a la revocaci\xf3n del consentimiento.","cookies-legitimation-3":"Las cookies t\xe9cnicas no pueden desactivarse, ya que, de lo contrario, se ver\xeda comprometido el funcionamiento correcto del Sitio Web o la App. Por lo general, solo se configuran en respuesta a acciones realizadas al solicitarnos servicios, como establecer tus preferencias en relaci\xf3n con las propias cookies, iniciar sesi\xf3n o completar formularios. En el caso de que se produjera la desactivaci\xf3n, esta podr\xeda provocar que el uso de algunos de los servicios del Sitio Web o de la App sea limitado por no poder acceder a determinadas funcionalidades y por tanto tu experiencia ser\xeda menos satisfactoria.","cookies-transfer":"7. \xbfA qui\xe9n cedemos tu informaci\xf3n personal? \xbfExisten transferencias internacionales de datos?","cookies-transfer-1":"Utilizamos algunas cookies de terceros, que son aquellas cookies recabadas y gestionadas por un tercero, por lo que dichas entidades recibir\xe1n tus datos personales recabados a trav\xe9s de las cookies para las finalidades que se indiquen para cada cookie. Este tipo de cookies est\xe1n indicadas en la tabla del apartado 5, como \'Cookies de Terceros\'. En dicha tabla se identifica el tercero que gestiona cada cookie.","cookies-transfer-2":"Puedes informarte de las transferencias a terceros pa\xedses que, en su caso, realizan los terceros identificados en esta Pol\xedtica de Cookies en sus correspondientes pol\xedticas.","cookies-consent":"8. \xbfCu\xe1l es la forma de aceptar, denegar o revocar el consentimiento para el uso de cookies en este sitio web?","cookies-consent-1":"Cuando accedes por primera vez a nuestro Sitio Web o a nuestra App, se te muestra una ventana en la que puedes indicar si aceptas las cookies o si deseas configurarlas o rechazarlas, salvo aquellas estrictamente necesarias. Asimismo, puedes retirar el consentimiento otorgado previamente en cualquier momento.","cookies-consent-2":"Si quisieses retirar en cualquier momento tu consentimiento relacionado con la Pol\xedtica de Cookies, tienes dos opciones: (i) retirar tu consentimiento a trav\xe9s de los botones habilitados al efecto en esta Pol\xedtica de cookies; o (ii) eliminar las cookies almacenadas en el dispositivo a trav\xe9s de los ajustes y configuraciones de tu navegador de Internet.","cookies-consent-3":"Ten en cuenta que, si aceptas las cookies de terceros, deber\xe1s eliminarlas desde las opciones del navegador o desde el sistema ofrecido por el propio tercero.","cookies-consent-4":"Puedes ampliar la informaci\xf3n sobre c\xf3mo deshabilitar las cookies, dependiendo de tu navegador, en los siguientes enlaces:","cookies-consent-5":"; para iOS","cookies-rights":"9. \xbfCu\xe1les son los derechos que puedes ejercer como interesado?","cookies-rights-1":"Los derechos que dispones como interesado/a en relaci\xf3n con la protecci\xf3n de sus datos personales est\xe1n indicados en el apartado \'\xbfCu\xe1les son los derechos que puedes ejercer como interesado?\' dentro de la","cookies-rights-2":"Pol\xedtica de Privacidad","cookies-modifications":"10. Modificaciones en esta pol\xedtica","cookies-modifications-1":"Es posible que actualicemos la Pol\xedtica de Cookies de nuestra plataforma peri\xf3dicamente. Por ello, te recomendamos revisar esta pol\xedtica cada vez que accedas a nuestro Sitio Web o App con el objetivo de estar adecuadamente informado sobre c\xf3mo y para qu\xe9 utilizamos las cookies."}');

});

parcelRegister("g9BDX", function(module, exports) {
module.exports = JSON.parse('{"404-title":"Crush - Non trouv\xe9","404-not-found-1":"Non trouv\xe9","404-not-found-2":"D\xe9sol\xe9, la page que vous recherchez n\'est pas disponible.","navbar-mission":"Mission","navbar-download":"T\xe9l\xe9charger","footer-follow":"Suivez-nous","footer-follow-1":"Instagram","footer-follow-2":"TikTok","footer-follow-3":"Twitter","footer-follow-4":"LinkdIn","footer-docs":"Documents","footer-docs-1":"Mission","footer-docs-2":"Mentions l\xe9gales","footer-docs-3":"Confidentialit\xe9","footer-docs-4":"Cookies","footer-docs-5":"Directives","footer-contact":"Contactez-nous","footer-contact-1":"Support","footer-contact-2":"Emplois","footer-contact-3":"Investisseurs","home-title":"Crush - O\xf9 les m\xe9dias rencontrent le platonique","home-hero-slogan-1":"Where media","home-hero-slogan-2":"meets platonic \u2122","home-concept-1":"Trouve tes personnes","home-concept-2":"Connecte-toi avec des personnes comme toi \xe0 diff\xe9rentes \xe9tapes de ta vie.","home-concept-3":"Vibes cool","home-concept-4":"Partage de bonnes vibes et de vrais moments. Pas de toxicit\xe9 ni de pr\xe9tention.","home-attributes-1":"Aesthetic","home-attributes-2":"Nous encourageons la publication de contenu aesthetic et de haute qualit\xe9; le web est d\xe9j\xe0 inond\xe9 de photos de chats.","home-attributes-3":"Stalker","home-attributes-4":"Tes amis sont les stars. Prends quelques rafales de photos quand ils ne s\'y attendent pas et poste des GIFs sur leurs comptes.","home-attributes-5":"Fils","home-attributes-6":"Participe \xe0 des discussions vibrantes couvrant les sujets les plus actuels aux tendances qui fa\xe7onneront demain.","home-attributes-7":"Jumeaux","home-attributes-8":"Connecte-toi avec des individus qui ont des traits similaires aux tiens, amplifiant ton r\xe9seau social d\'une mani\xe8re compl\xe8tement nouvelle et amusante.","home-attributes-9":"Segmentation par \xe2ge","home-attributes-10":"En regroupant les utilisateurs par \xe2ge, similaire aux classes de lyc\xe9e, les connexions sont limit\xe9es aux individus de la m\xeame g\xe9n\xe9ration pour une interaction plus s\xfbre et efficace.","home-attributes-11":"Crush","home-attributes-12":"Pas une application de rencontres \u2014 juste des amis et des relations d\xe9tendues. Revivez la nostalgie des liens du lyc\xe9e dans un environnement num\xe9rique.","home-partners":"Powered By","mission-title":"Crush - Mission","mission-date":"Derni\xe8re modification: 8 d\xe9cembre, 2023","mission-header":"Mission et valeurs","mission-introduction":"Au c\u0153ur de Crush bat quelque chose de plus qu\'un simple r\xe9seau social; c\'est un univers tiss\xe9 de valeurs \xe9thiques, d\'une philosophie et d\'un objectif. Ce document est le voyage \xe0 travers les fondements de notre vision, depuis la naissance de l\'id\xe9e jusqu\'\xe0 l\'esquisse minutieuse de la cr\xe9ation que nous forgeons.","mission-origin":"L\'origine","mission-origin-1":"L\'origine de Crush remonte \xe0 une graine sem\xe9e bien avant son d\xe9veloppement concret en 2020 et son lancement en 2023. Notre vision de fusionner les r\xe9seaux sociaux avec la touche distinctive de Crush a \xe9t\xe9 con\xe7ue en 2016, inspir\xe9e par \'The Social Network\', l\'\u0153uvre cin\xe9matographique notable reconnue par Quentin Tarantino comme un bijou de la d\xe9cennie pr\xe9c\xe9dente. Ce film, qui raconte l\'histoire des jeunes fondateurs de Facebook, en particulier sa figure la plus reconnue, Mark Zuckerberg \u2014 le p\xe8re des r\xe9seaux sociaux, nous a offert une perspective \xe9clairante.","mission-origin-2":"Chez Crush, nous croyons fermement que le c\u0153ur des r\xe9seaux sociaux d\'aujourd\'hui r\xe9side dans l\'amour platonique. Si vous avez eu la chance de regarder ce film, vous avez peut-\xeatre remarqu\xe9 les critiques de Zuckerberg et d\'Eduardo Saverin \xe0 l\'\xe9gard des applications de rencontres. Dans une sc\xe8ne cl\xe9, vers la 30e minute, pendant le proc\xe8s des fr\xe8res Winklevoss pour pr\xe9tendu vol d\'id\xe9e, Saverin mentionne:","mission-origin-3":"\\"It really hadn\'t much to do with the Winklevoss\' dating site\\".","mission-origin-4":"C\'est curieux, car quelques minutes plus tard, vers la minute 36:05, nous voyons Mark impl\xe9menter des \xe9l\xe9ments tels que le statut relationnel et les centres d\'int\xe9r\xeat dans son projet:","mission-origin-5":"\\"Relationship status, interests... This is what drives life in college. Are you having sex or aren\'t you? That\'s why people take classes, sit where they sit, and do what they do. It\'s the center, you know? That\'s what The Facebook is going to be.\\".","mission-origin-6":"Enfin, dans la sc\xe8ne finale, nous voyons un Zuckerberg \xe9pris d\'amour envoyer une demande d\'ami \xe0 son crush.","mission-origin-7":"Ce film pose une question intrigante:","mission-origin-8":"Les r\xe9seaux sociaux sont-ils r\xe9ellement des applications de rencontre d\xe9guis\xe9es?","mission-purpose":"Notre but","mission-purpose-1":"Il n\'y a pas de r\xe9ponse d\xe9finitive \xe0 la question pos\xe9e dans la section pr\xe9c\xe9dente. Peut-\xeatre que oui, peut-\xeatre que non... en fin de compte, cela d\xe9pend des valeurs \xe9thiques et culturelles, des intentions et de l\'\xe9ducation de l\'utilisateur final. Ce que nous savons avec certitude, c\'est que cela ouvre la porte \xe0 des probl\xe8mes r\xe9els et tr\xe8s s\xe9rieux qui, contrairement au monde r\xe9el, peuvent en effet \xeatre r\xe9solus.","mission-purpose-2":"Que ce soit par les normes pr\xe9\xe9tablies par la soci\xe9t\xe9 ou l\'anonymat qui conduit \xe0 des comportements inappropri\xe9s en ligne, l\'amour dans le monde num\xe9rique, qu\'il soit platonique et authentique sur les r\xe9seaux sociaux ou plus romantique sur les applications de rencontres, a malheureusement \xe9t\xe9 sexualis\xe9 ces derni\xe8res ann\xe9es. Pourquoi quelque chose d\'aussi beau et fondamental dans nos vies est-il d\xe9form\xe9 dans cet univers parall\xe8le?","mission-purpose-3":"Soyons clairs et compl\xe8tement transparents. En Espagne, notre pays d\'origine, selon des donn\xe9es et des statistiques v\xe9rifiables,","mission-purpose-4":"7 enfants sur 10 \xe2g\xe9s de moins de 15 ans poss\xe8dent un appareil mobile.","mission-purpose-5":"Cela signifie qu\'environ 70% des mineurs ont un acc\xe8s non restreint \xe0 un monde virtuel o\xf9 l\'interaction avec les adultes n\'a pas \xe9t\xe9 r\xe9glement\xe9e ni restreinte, les exposant \xe0 des risques tels que le harc\xe8lement, la cyberintimidation ou la p\xe9dophilie, entre autres.","mission-purpose-6":"Actuellement, peu importe le r\xe9seau social sur lequel vous vous inscrivez, il est courant de trouver des personnes vendant du contenu inappropri\xe9 ou partageant tout type de contenu inad\xe9quat. La situation devient de plus en plus d\xe9plorable \xe0 mesure que le temps passe.","mission-purpose-7":"Nous visons \xe0 \xe9liminer la sexualisation et la toxicit\xe9 du r\xe9seau en abordant directement leur origine.","mission-purpose-8":"Crush est propos\xe9 comme une red\xe9finition des r\xe9seaux sociaux d\'un point de vue diff\xe9rent, mettant l\'accent sur les relations platoniques.","mission-purpose-9":"Nous ne proposons pas de syst\xe8me de rencontres ni la cr\xe9ation de relations romantiques/s\xe9rieuses, car cela contredit nos","mission-purpose-10":"directives communautaires.","mission-purpose-11":"Au lieu de cela, nous offrons ce qui \xe9tait imagin\xe9 dans le film \'The Social Network\', mais avec une solution au probl\xe8me et une approche plus cool.","mission-purpose-12":"Notre mission va au-del\xe0 du typique \\"partagez des moments r\xe9els\\" ou \\"nous vous aidons \xe0 vous connecter\\". En plus d\'accompagner l\'utilisateur \xe0 travers les diff\xe9rentes \xe9tapes de sa vie, nous nous engageons \xe0 r\xe9soudre les probl\xe8mes mentionn\xe9s pr\xe9c\xe9demment. Sur notre plateforme, au moment de la r\xe9daction de ce document, il est d\xe9j\xe0 impossible pour un mineur d\'interagir avec un adulte (et vice versa), non seulement pour fermer la porte \xe0 ces probl\xe8mes \xe9thiques, mais aussi pour encourager la cr\xe9ation de liens entre des personnes de la m\xeame g\xe9n\xe9ration, avec une mentalit\xe9 similaire. Nous pr\xe9voyons d\'introduire des solutions plus efficaces dans la prochaine d\xe9cennie de d\xe9veloppement; c\'est notre promesse.","guidelines-title":"Crush - Directives","guidelines-date":"Derni\xe8re modification: 4 avril, 2024","guidelines-header":"Directives communautaires","guidelines-introduction-1":"Chez Crush, il s\'agit d\'\xe9tablir des connexions platoniques, de partager des moments authentiques de la vie avec des amis, de socialiser et de cr\xe9er de nouvelles amiti\xe9s qui correspondent \xe0 votre \xe9tat d\'esprit. Nous croyons fermement en la libert\xe9 d\'expression, mais nous appr\xe9cions \xe9galement la capacit\xe9 de distinguer le bien du mal. Ce document d\xe9taille les normes de notre r\xe9seau social, essentielles pour remplir","guidelines-introduction-2":"notre objectif principal.","guidelines-introduction-3":"Nous attendons un comportement appropri\xe9, un contenu soigneux, de l\'authenticit\xe9, de l\'humilit\xe9 et surtout, de la responsabilit\xe9. Toute violation de nos principes fondamentaux pourrait entra\xeener la suspension permanente de votre compte, sans possibilit\xe9 de vous r\xe9inscrire dans notre syst\xe8me.","guidelines-introduction-4":"Tout comme dans la vie r\xe9elle, il y a des cons\xe9quences pour les actions. Veuillez respecter nos r\xe8gles et ne pas utiliser notre syst\xe8me de mani\xe8re contraire \xe0 la loi. Nous tenons \xe0 souligner notre s\xe9rieux et notre rigueur; un ton ludique n\'est pas le bienvenu dans ce contexte.","guidelines-dating":"Anti-rencontres","guidelines-dating-1":"Crush est une combinaison de m\xe9dias sociaux adapt\xe9e \xe0 toutes les personnes","guidelines-dating-2":"\xe2g\xe9es de 15 ans et plus,","guidelines-dating-3":"qu\'elles soient en couple ou non. Ne confondez pas les amis et les relations platoniques (optionnelles) avec les relations romantiques ou les v\xe9ritables engagements.","guidelines-dating-4":"Ensuite, nous d\xe9taillons une s\xe9rie de comportements que tu dois adopter et respecter pour rester sur notre plateforme:","guidelines-dating-5":"Ne pas utiliser notre service pour chercher ou demander des rencontres romantiques.","guidelines-dating-6":"Si l\'amour doit entrer dans ta vie, qu\'il ne vienne pas \xe0 travers un \xe9cran.","guidelines-dating-7":"Ne publie pas de choses sales.","guidelines-dating-8":"Ne harc\xe8le ou ne d\xe9range aucun utilisateur.","guidelines-dating-9":"Ne mens pas sur ton \xe2ge ou tes informations personnelles, et encore moins n\'usurpe l\'identit\xe9 d\'une autre personne.","guidelines-dating-10":"C\'est un crime grave qui pourrait entra\xeener des poursuites judiciaires contre toi.","guidelines-content":"Aesthetic","guidelines-content-1":"Pour nous, toute forme de logiciel est de l\'art et l\'art doit \xeatre respect\xe9. Sur un r\xe9seau social, la qualit\xe9 de la plateforme se refl\xe8te dans le contenu que les utilisateurs g\xe9n\xe8rent. Dans notre cas, nous encourageons la cr\xe9ativit\xe9 et l\'inspiration. Nous te demandons de publier en maintenant un standard minimum de qualit\xe9.","guidelines-content-2":"Ne publie pas de contenu visuellement m\xe9diocre.","guidelines-content-3":"Fais un effort.","guidelines-content-4":"Le spam, c\'est suppression directe.","guidelines-content-5":"Si tu veux promouvoir ton Instagram, utilise les outils qu\'on te fournit pour \xe7a.","guidelines-content-6":"Ne partage pas de contenu qui viole la propri\xe9t\xe9 intellectuelle d\'autrui.","guidelines-content-7":"Merci d\'\xe9viter de publier des photos de chatons;","guidelines-content-8":"Internet en est d\xe9j\xe0 plein.","guidelines-content-9":"Ne te ridiculise pas en publiant des nudit\xe9s inutiles.","guidelines-content-10":"Nous en avons assez des photos torse nu.","guidelines-vibes":"Que des bonnes vibes","guidelines-vibes-1":"Chez Crush, nous ne tol\xe9rons pas les comportements inappropri\xe9s. Tout comme vous soignez votre image dans la vie r\xe9elle, nous vous demandons d\'\xeatre responsable et de maintenir cette int\xe9grit\xe9 en ligne. Faites preuve de courtoisie et de respect envers les utilisateurs de notre communaut\xe9 ainsi que les cr\xe9ateurs de la plateforme.","guidelines-vibes-2":"L\'exploitation des enfants, la sextorsion ou tout autre type d\'abus, sous quelque forme que ce soit, sont strictement interdits.","guidelines-vibes-3":"Notre engagement contre le suicide et l\'automutilation est absolu.","guidelines-vibes-4":"Tout contenu encourageant, promouvant ou glorifiant ces actions entra\xeenera une suspension permanente.","guidelines-vibes-5":"Nous prenons la l\xe9galit\xe9 au s\xe9rieux.","guidelines-vibes-6":"\xc9vite de partager du contenu qui encourage des activit\xe9s ill\xe9gales, ainsi que tout contenu li\xe9 aux armes ou aux drogues.","guidelines-vibes-7":"Le contenu offensant ou violent n\'a pas sa place sur notre plateforme et n\'est pas autoris\xe9.","guidelines-vibes-8":"Le mode Stalker est destin\xe9 \xe0 s\'amuser entre amis.","guidelines-vibes-9":"Cependant, m\xeame si le contenu n\xe9cessite finalement l\'approbation de l\'utilisateur (ou des utilisateurs) dans le GIF, \xe9vite de partager des photos de tes amis sans leur consentement pr\xe9alable.","legal-title":"Crush - Mentions l\xe9gales","legal-date":"Derni\xe8re modification: 4 avril, 2024","legal-header":"Mentions l\xe9gales","legal-introduction-1":"Chaque application est un univers et tous les univers sont soumis \xe0 des r\xe8gles. Dans ce document, vous trouverez l\'avis l\xe9gal et les conditions g\xe9n\xe9rales d\'utilisation de notre plateforme, compl\xe9t\xe9s par ceux d\xe9finis dans nos","legal-introduction-2":"directives communautaires.","legal-owner":"1. Identification du titulaire","legal-owner-1":"Le site web www.crushsocialnetwork.com (ci apr\xe8s, le","legal-owner-2":"\'Site Web\'","legal-owner-3":") et l\'application mobile pour Smartphones avec le nom \'Crush\' (ci apr\xe8s, la","legal-owner-4":"\'App\'","legal-owner-5":") sont la propri\xe9t\xe9 de CRUSH SOCIAL NETWORK, SARL., avec NIF: B-72599830 et inscrit au registre du commerce de Valence avec les donn\xe9es de registre suivantes: T. 3606, F.75, I.1, H. MU-108656, dont les coordonn\xe9es sont:","legal-owner-6":"Domicile Social:","legal-owner-7":"Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Espagne)","legal-owner-8":"\xc9-mail de contact:","legal-area":"2. Champ d\'application","legal-area-1":"Les pr\xe9sentes Conditions G\xe9n\xe9rales d\'Utilisation du Site (ci apr\xe8s, les","legal-area-2":"\'Conditions d\'utilisation\'","legal-area-3":") recueillir les termes et conditions r\xe9gissant l\'acc\xe8s, la navigation et l\'utilisation du Site Web et de l\'App.","legal-area-4":"En ce sens, l\'acc\xe8s, l\'utilisation et la navigation sur le Site Web et l\'App conf\xe8rent la qualit\xe9 d\'utilisateur(s) (ci apr\xe8s, le","legal-area-5":"\'Utilisateur\'","legal-area-6":"ou les","legal-area-7":"\'Utilisateurs\'","legal-area-8":"), et implique l\'acceptation de chacune de ces conditions d\'utilisation. L\'Utilisateur est pleinement conscient que la simple navigation sur le Site Web ou l\'App implique l\'acceptation des pr\xe9sentes conditions d\'utilisation et, par cons\xe9quent, si l\'Utilisateur n\'est pas d\'accord avec celles-ci, il ne doit pas utiliser le Site Web ou cette App.","legal-area-9":"Le Site Web et l\'App sont principalement destin\xe9s aux utilisateurs r\xe9sidant en Espagne. Crush ne fait aucune d\xe9claration selon laquelle le Site Web ou l\'App est conforme aux lois d\'autres pays, en tout ou en partie. Si vous r\xe9sidez ou \xeates domicili\xe9 ailleurs et choisissez d\'acc\xe9der et/ou de naviguer sur le Site Web ou d\'acc\xe9der ou d\'utiliser l\'App, vous le faites \xe0 vos propres risques et vous devez vous assurer que cet acc\xe8s, cette navigation ou cette utilisation est conforme aux lois locales applicables, et Crush n\'assume aucune responsabilit\xe9 quelle qu\'elle soit d\xe9coulant de cet acc\xe8s ou de cette utilisation.","legal-area-10":"Crush peut, \xe0 tout moment et sans pr\xe9avis, modifier les pr\xe9sentes conditions d\'utilisation, qui seront affich\xe9es au fur et \xe0 mesure de ces modifications.","legal-conditions":"3. Conditions d\'acc\xe8s et d\'utilisation","legal-conditions-1":"L\'acc\xe8s au Site Web ou \xe0 l\'App par l\'Utilisateur, en r\xe8gle g\xe9n\xe9rale, est gratuit. Dans le cas o\xf9 il existe des fonctionnalit\xe9s ou des services r\xe9serv\xe9s \xe0 certains Utilisateurs ou qu\'un prix doit \xeatre pay\xe9, ceux-ci seront d\xfbment identifi\xe9s sur le Site Web ou l\'App.","legal-conditions-2":"L\'acc\xe8s au Site Web ou \xe0 l\'App s\'effectue sous la seule responsabilit\xe9 de l\'Utilisateur et n\'implique aucune relation commerciale entre Crush et l\'Utilisateur. L\'utilisateur est tenu de s\'assurer que les informations et le contenu inclus sur le Site Web ou dans l\'App r\xe9pondent \xe0 ses besoins sp\xe9cifiques.","legal-conditions-3":"L\'Utilisateur s\'engage \xe0:","legal-conditions-4":"Acc\xe9der et utiliser le Site Web et l\'App de bonne foi et conform\xe9ment aux pr\xe9sentes conditions d\'utilisation, \xe0 la loi, \xe0 la morale et \xe0 l\'ordre public, avec la condition suppl\xe9mentaire d\'atteindre l\'\xe2ge minimum de 15 ans.","legal-conditions-5":"Chez Crush, nous certifions que nous respectons la l\xe9gislation applicable en mati\xe8re de s\xe9curit\xe9 des enfants et prenons au s\xe9rieux le mat\xe9riel d\'abus sexuel sur les enfants. Nous prenons des mesures appropri\xe9es, telles que la suppression de ce mat\xe9riel d\xe8s que nous avons connaissance r\xe9elle de son existence, conform\xe9ment \xe0 nos normes et aux lois pertinentes.","legal-conditions-6":"Fournir des informations v\xe9ridiques, actuelles et l\xe9gales dans les formulaires propos\xe9s tant sur le Site Web que dans l\'App. En tout \xe9tat de cause, l\'utilisateur notifiera imm\xe9diatement \xe0 Crush tout \xe9v\xe9nement permettant l\'utilisation abusive des informations enregistr\xe9es dans lesdits formulaires, tel que, mais sans s\'y limiter, le vol, la perte ou l\'acc\xe8s non autoris\xe9 aux identifiants et/ou mots de passe, afin de proc\xe9der \xe0 leur annulation imm\xe9diate.","legal-conditions-7":"N\'effectuer aucune action sur le Site Web ou l\'App susceptible de causer des dommages ou des alt\xe9rations aux contenus, aux programmes ou aux syst\xe8mes du Site Web ou de l\'App, y compris l\'introduction de virus informatiques, l\'installation de robots ou de tout logiciel ou fichier nuisible, d\xe9fectueux ou susceptible de causer des dommages \xe0 nos syst\xe8mes informatiques.","legal-conditions-8":"L\'utilisateur sera responsable dans tous les cas des dommages qu\'il pourrait causer \xe0 Crush ou \xe0 des tiers, et Crush pourra adopter toutes les mesures techniques, juridiques ou autres qu\'elle jugera appropri\xe9es pour pr\xe9venir, att\xe9nuer ou arr\xeater les cons\xe9quences de la conduite interdite ci-dessus et exiger les responsabilit\xe9s qu\'elle jugera appropri\xe9es.","legal-property":"4. Propri\xe9t\xe9 intellectuelle et industrielle","legal-property-1":"Tout le contenu du Site Web et de l\'App, y compris, mais sans s\'y limiter, les textes, les images, les photographies, les vid\xe9os, les graphiques, les signes distinctifs de toute nature, les ic\xf4nes, les interfaces, ainsi que les logiciels, le code source, les designs, l\'architecture, la pr\xe9sentation, la mise en page et la classification du contenu et tout autre \xe9l\xe9ment pr\xe9sent sur le Site Web ou l\'App pouvant faire l\'objet de droits de propri\xe9t\xe9 intellectuelle sont la propri\xe9t\xe9 exclusive de Crush ou de tiers qui ont conc\xe9d\xe9 une licence, autoris\xe9 ou consenti \xe0 leur utilisation sur le Site Web ou l\'App.","legal-property-2":"En ce sens, lorsque l\'Utilisateur acc\xe8de, navigue et utilise le Site Web ou acc\xe8de ou utilise l\'App, aucun droit d\'exploitation existant ou pouvant exister sur tout ou partie de ceux-ci ne lui est conf\xe9r\xe9, et Crush se r\xe9serve tous ces droits. L\'Utilisateur ne peut visualiser les \xe9l\xe9ments du Site Web et de l\'App et les utiliser que dans la mesure strictement n\xe9cessaire \xe0 leur bon usage. En particulier, vous ne pouvez pas utiliser ou revendre \xe0 des fins commerciales tout mat\xe9riel ou contenu du Site Web ou de l\'App sans l\'autorisation pr\xe9alable de Crush.","legal-property-3":"Crush se r\xe9serve le droit de modifier, \xe0 tout moment et sans pr\xe9avis, la pr\xe9sentation et la configuration du Site Web ou de l\'App ainsi que les contenus et services qui peuvent y \xeatre int\xe9gr\xe9s. Vous reconnaissez et acceptez que Crush puisse \xe0 tout moment interrompre, d\xe9sactiver et/ou mettre fin \xe0 l\'une de ces fonctionnalit\xe9s int\xe9gr\xe9es au Site Web et \xe0 l\'App ou \xe0 l\'acc\xe8s \xe0 ceux-ci.","legal-property-4":"Si l\'utilisateur consid\xe8re que l\'un des contenus du Site Web ou de l\'App constitue une violation des droits de protection de la propri\xe9t\xe9 intellectuelle, il doit imm\xe9diatement en informer Crush via les coordonn\xe9es de la section 1 (Identification du titulaire) des pr\xe9sentes Conditions d\'Utilisation.","legal-disclaimer":"5. Exclusion des garanties et de la responsabilit\xe9","legal-disclaimer-1":"Les informations publi\xe9es sur le Site Web ou l\'App peuvent ne pas \xeatre exhaustives ou enti\xe8rement mises \xe0 jour, et Crush n\'assume aucune responsabilit\xe9 quant au manque d\'exhaustivit\xe9, de mise \xe0 jour ou d\'exactitude des donn\xe9es et informations contenues dans les diff\xe9rentes pages faisant partie du Site Web ou de l\'App.","legal-disclaimer-2":"Crush ne garantit pas que l\'acc\xe8s \xe0 l\'App ou au Site Web sera ininterrompu ou sans erreur. En outre, Crush ne garantit pas que le contenu ou le logiciel du Site Web ou de l\'App ne causera pas de dommages au syst\xe8me informatique (logiciel et mat\xe9riel) de l\'utilisateur. Crush ne sera pas responsable des pertes, dommages ou pr\xe9judices de toute nature r\xe9sultant de l\'acc\xe8s, de la navigation et de l\'utilisation du Site Web ou de l\'App, y compris, mais sans s\'y limiter, les pertes, dommages ou pr\xe9judices caus\xe9s aux syst\xe8mes informatiques ou caus\xe9s par l\'introduction de virus.","legal-disclaimer-3":"Crush est \xe9galement exon\xe9r\xe9 de toute responsabilit\xe9 d\xe9coulant de toute utilisation abusive du Site Web ou de l\'App par l\'utilisateur.","legal-links":"6. Liens","legal-links-1":"Vous \xeates inform\xe9 que tant le Site Web que l\'App peuvent contenir, entre autres, des liens, des banni\xe8res, des boutons, des r\xe9pertoires et des moteurs de recherche qui permettent aux Utilisateurs d\'acc\xe9der \xe0 d\'autres sites web ou apps appartenant et/ou g\xe9r\xe9s par des tiers et qui, par cons\xe9quent, \xe9chappent au contr\xf4le de Crush, qui ne peut assumer la responsabilit\xe9 du contenu qui appara\xeet sur ces pages ou apps.","legal-links-2":"Si vous estimez qu\'un tel contenu est inappropri\xe9 ou contraire aux objectifs de Crush, veuillez nous le faire savoir via les coordonn\xe9es ci-dessus afin que nous puissions prendre les mesures appropri\xe9es.","legal-jurisdiction":"7. Droit applicable et juridiction","legal-jurisdiction-1":"Les pr\xe9sentes conditions d\'utilisation et leur ex\xe9cution sont soumises au droit espagnol.","legal-jurisdiction-2":"En cas de litige sur l\'interpr\xe9tation et l\'application des pr\xe9sentes conditions d\'utilisation, les Parties n\xe9gocieront de bonne foi pour tenter de r\xe9soudre ce litige ou cette r\xe9clamation. Toutefois, si le diff\xe9rend ou la r\xe9clamation n\'est pas r\xe9solu, les Parties se soumettent aux cours ou tribunaux appropri\xe9s conform\xe9ment \xe0 la loi.","privacy-title":"Crush - Confidentialit\xe9","privacy-date":"Derni\xe8re modification: 8 d\xe9cembre, 2023","privacy-header":"Politique de confidentialit\xe9","privacy-introduction-1":"Chez Crush, nous nous engageons \xe0 faire en sorte que vos donn\xe9es personnelles soient prot\xe9g\xe9es et ne soient pas utilis\xe9es \xe0 d\'autres fins que celles indiqu\xe9es dans la pr\xe9sente politique de confidentialit\xe9. Pour cette raison, dans cette section, nous informons les utilisateurs et les parties int\xe9ress\xe9es de tout ce qui concerne le traitement de leurs donn\xe9es personnelles, respectant ainsi la r\xe9glementation sur la protection des donn\xe9es applicable dans notre pays: R\xe8glement G\xe9n\xe9ral sur la Protection des Donn\xe9es (UE) 2016/679, du 27 avril relatives \xe0 la protection des personnes physiques \xe0 l\'\xe9gard du traitement des donn\xe9es \xe0 caract\xe8re personnel et \xe0 la libre circulation de ces donn\xe9es (ci-apr\xe8s,","privacy-introduction-2":"\'GDPR\'","privacy-introduction-3":") et la Loi Organique 3/2018, du 5 d\xe9cembre, sur la Protection des Donn\xe9es Personnelles et la garantie des droits num\xe9riques (ci-apr\xe8s","privacy-introduction-4":"\'LOPDGDD\'","privacy-introduction-5":"Cette Politique de Confidentialit\xe9 s\'applique au traitement des donn\xe9es que CRUSH SOCIAL NETWORK, SARL., effectu\xe9s \xe0 la fois via le site web: www.crushsocialnetwork.com (ci-apr\xe8s, le \'Site Web\') et via l\'application mobile pour Smartphones portant le nom de \'Crush\' (ci-apr\xe8s, la \'App\') et/ou ceux qui sont indiqu\xe9s. Nous vous recommandons de le lire attentivement avant d\'utiliser le Site Web ou l\'App et de fournir vos donn\xe9es par leur interm\xe9diaire. N\'h\xe9sitez pas \xe0 nous poser des questions \xe0 ce sujet par e-mail:","privacy-index":"Index du contenu","privacy-index-1":"Dans cette Politique, vous trouverez toutes les informations relatives au traitement de vos donn\xe9es personnelles et les droits que vous pouvez exercer pour en garder le contr\xf4le. En ce sens, vous trouverez des informations sur:","privacy-index-2":"Qui est responsable du traitement de vos donn\xe9es.","privacy-index-3":"Quelles exigences vous devez remplir pour nous fournir vos donn\xe9es personnelles.","privacy-index-4":"Quels traitements de donn\xe9es nous effectuons via l\'App et quelles sont ses principales caract\xe9ristiques, en expliquant:","privacy-index-5":"Quelles sont les donn\xe9es que nous collectons et quelles sont les mani\xe8res de les collecter.","privacy-index-6":"\xc0 quelles fins nous recueillons les donn\xe9es que nous demandons.","privacy-index-7":"Quelle est la l\xe9gitimit\xe9 de son traitement.","privacy-index-8":"Combien de temps les gardons-nous?","privacy-index-9":"A quels destinataires vos donn\xe9es sont communiqu\xe9es.","privacy-index-10":"Existence de transferts internationaux de vos donn\xe9es.","privacy-index-11":"Quels sont vos droits et comment pouvez-vous les exercer?","privacy-index-12":"Comment nous prot\xe9geons vos informations personnelles.","privacy-index-13":"Modifications de cette politique.","privacy-controller":"1. Qui est responsable du traitement de vos donn\xe9es personnelles?","privacy-controller-1":"Vos donn\xe9es personnelles seront trait\xe9es par la soci\xe9t\xe9 CRUSH SOCIAL NETWORK, SARL. (","privacy-controller-2":"\'CRUSH\'","privacy-controller-3":"), avec NIF B-72599830 et dont les coordonn\xe9es sont les suivantes:","privacy-controller-4":"Adresse:","privacy-controller-5":"Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Espagne)","privacy-controller-6":"Email du contact:","privacy-dpo":"1.1. Notre d\xe9l\xe9gu\xe9 \xe0 la protection des donn\xe9es","privacy-dpo-1":"De CRUSH, nous mettons \xe0 votre disposition les coordonn\xe9es de notre d\xe9l\xe9gu\xe9 \xe0 la protection des donn\xe9es, \xe0 qui vous pouvez adresser toutes les questions que vous pourriez avoir concernant la pr\xe9sente politique de confidentialit\xe9 ou le traitement de vos donn\xe9es personnelles.","privacy-dpo-2":"E-mail:","privacy-requirements":"2. Quelles conditions devez-vous remplir pour nous fournir vos donn\xe9es personnelles?","privacy-requirements-1":"2.1. \xc2ge minimum. Pour nous fournir vos donn\xe9es personnelles et utiliser notre Site Web et notre App, vous devez avoir plus de 15 ans.","privacy-requirements-2":"2.2. V\xe9racit\xe9. Lorsque vous nous fournissez vos donn\xe9es pour utiliser nos services, vous garantissez que les donn\xe9es et informations fournies sont r\xe9elles, v\xe9ridiques, mises \xe0 jour et vous appartiennent \xe9galement et non \xe0 des tiers.","privacy-requirements-3":"De plus, vous devez nous informer de tout changement qui se produit dans les donn\xe9es fournies, en r\xe9pondant en tout cas \xe0 la v\xe9racit\xe9 et \xe0 l\'exactitude des donn\xe9es fournies \xe0 tout moment.","privacy-requirements-4":"2.3. Contr\xf4le de l\'\xe2ge et de la v\xe9racit\xe9. De CRUSH, nous nous r\xe9servons le droit de v\xe9rifier votre \xe2ge et vos informations d\'identification, si n\xe9cessaire, m\xeame en exigeant un document officiel ou une proc\xe9dure \xe9quivalente et, en cas de d\xe9tection de fraude v\xe9rifi\xe9e ou suspect\xe9e que vous avez moins de l\'\xe2ge indiqu\xe9, de supprimer, temporairement d\xe9sactiver et/ou annuler votre compte.","privacy-processing":"3. Quel traitement de donn\xe9es effectuons-nous via le Site Web et l\'App et quelles en sont les principales caract\xe9ristiques?","privacy-processing-1":"Ci-dessous, nous expliquons comment nous traitons vos informations personnelles et vous fournissons, en d\xe9tail, toutes les informations pertinentes concernant votre vie priv\xe9e:","privacy-contact":"3.1 Lorsque vous nous contactez via nos canaux (formulaire de contact, chat, e-mail)","privacy-contact-1":"Quels sont les modes de collecte des donn\xe9es?","privacy-contact-2":"Formulaire de contact.","privacy-contact-3":"Chat.","privacy-contact-4":"Envoi d\'e-mails \xe0","privacy-contact-5":"ou d\'autres adresses e-mail CRUSH.","privacy-contact-6":"Quelles donn\xe9es collectons-nous?","privacy-contact-7":"Identification et coordonn\xe9es.","privacy-contact-8":"Nous collectons vos donn\xe9es d\'identification (nom et pr\xe9nom) et votre adresse e-mail, ainsi que toute autre information que vous incluez volontairement dans les communications que vous nous envoyez.","privacy-contact-9":"Nous pouvons vous demander des informations suppl\xe9mentaires si n\xe9cessaire pour r\xe9pondre \xe0 votre demande ou exigence.","privacy-contact-10":"Quelles sont les finalit\xe9s du traitement de vos donn\xe9es personnelles?","privacy-contact-11":"R\xe9pondez \xe0 vos demandes.","privacy-contact-12":"Le traitement de ces donn\xe9es aura pour finalit\xe9 principale de r\xe9pondre \xe0 vos demandes, de r\xe9pondre \xe0 vos questions et/ou de vous fournir les informations requises, ainsi que, le cas \xe9ch\xe9ant, de donner suite \xe0 vos demandes.","privacy-contact-13":"Am\xe9liorer le service client.","privacy-contact-14":"Toutes les informations d\xe9riv\xe9es des doutes, des requ\xeates et des conseils offerts aux parties int\xe9ress\xe9es, ainsi que la mani\xe8re dont les demandes sont r\xe9solues, nous permettent de savoir comment nous fournissons notre propre service client, ce qui nous permet d\'am\xe9liorer sa qualit\xe9.","privacy-contact-15":"De m\xeame, toutes les informations collect\xe9es, une fois la p\xe9riode de conservation indiqu\xe9e ci-dessous termin\xe9e, sont anonymis\xe9es et utilis\xe9es dans le but de pouvoir analyser les questions les plus fr\xe9quemment pos\xe9es via le chat et de pouvoir automatiser les plus fr\xe9quentes, pr\xe9parer des FAQ ou les conserver \xe0 des fins statistiques pour d\xe9velopper des strat\xe9gies commerciales.","privacy-contact-16":"Quelle est la base l\xe9gale qui nous permet de traiter vos donn\xe9es? La fourniture de ces donn\xe9es est-elle obligatoire?","privacy-contact-17":"Consentement.","privacy-contact-18":"Les donn\xe9es fournies aux fins ci-dessus seront trait\xe9es sur la base de votre consentement, accord\xe9 lorsque vous nous contactez volontairement par les moyens mis \xe0 votre disposition pour demander des informations ou faire une demande.","privacy-contact-19":"Toutes les informations recueillies par le service client seront trait\xe9es \xe0 des fins statistiques qui nous aideront \xe0 am\xe9liorer la qualit\xe9 du service client fourni. Cette finalit\xe9 est consid\xe9r\xe9e comme compatible avec la finalit\xe9 initiale.","privacy-contact-20":"Les informations que vous devez fournir seront indiqu\xe9es par un ast\xe9risque ou similaire. Sans ces informations, il ne serait pas possible de r\xe9pondre \xe0 vos questions ou demandes.","privacy-contact-21":"Combien de temps conservons-nous vos informations?","privacy-contact-22":"Nous traiterons toutes vos informations personnelles pendant le temps de traitement de vos demandes et, si n\xe9cessaire, pour y donner suite. Une fois cette p\xe9riode termin\xe9e, CRUSH conservera, bloqu\xe9es, lesdites informations pendant les p\xe9riodes pr\xe9vues par la l\xe9gislation pour faire face \xe0 d\'\xe9ventuelles responsabilit\xe9s et pour d\xe9montrer le respect de nos obligations. \xc0 partir de ce moment, CRUSH ne traitera les informations que de mani\xe8re anonyme, il ne sera donc pas possible de lier les informations statistiques aux utilisateurs sp\xe9cifiques auxquels elles se r\xe9f\xe8rent.","privacy-contact-23":"\xc0 qui transmettons-nous vos informations personnelles?","privacy-contact-24":"Nous ne faisons aucune mission suppl\xe9mentaire pour effectuer ce traitement que celles indiqu\xe9es, en g\xe9n\xe9ral, au point","privacy-contact-25":"4. A qui donnons-nous vos informations personnelles?","privacy-contact-26":"En ce sens, certains canaux par lesquels vous pouvez nous contacter sont g\xe9r\xe9s par des prestataires de services, qui agissent en tant que Responsables de Traitement. Vous trouverez plus d\'informations sur la fa\xe7on dont ces prestataires de services agissent au point 4, mentionn\xe9 ci-dessus.","privacy-app-use":"3.2 Lorsque vous vous inscrivez et utilisez notre App \'Crush\'","privacy-app-use-1":"Quels sont les modes de collecte des donn\xe9es?","privacy-app-use-2":"Formulaire d\'inscription dans notre App et utilisation de ses diff\xe9rents espaces.","privacy-app-use-3":"Quelles donn\xe9es collectons-nous?","privacy-app-use-4":"Donn\xe9es de base pour l\'inscription:","privacy-app-use-5":"Afin de vous inscrire dans notre App et d\'utiliser les services, vous devrez vous inscrire dans notre App et cr\xe9er un","privacy-app-use-6":"\'profil\'.","privacy-app-use-7":"Au cours du processus d\'inscription, nous vous demandons, en tant qu\'utilisateur, les donn\xe9es suivantes:","privacy-app-use-8":"Nom d\'utilisateur.","privacy-app-use-9":"Nom et pr\xe9nom.","privacy-app-use-10":"E-mail.","privacy-app-use-11":"Date de naissance.","privacy-app-use-12":"Donn\xe9e suppl\xe9mentaire:","privacy-app-use-13":"En plus de ce qui pr\xe9c\xe8de, notre App vous permet de partager volontairement des informations relatives \xe0:","privacy-app-use-14":"Genre.","privacy-app-use-15":"Orientation sexuelle.","privacy-app-use-16":"Int\xe9r\xeats.","privacy-app-use-17":"Pays, ville ou r\xe9gion.","privacy-app-use-18":"Description de vous.","privacy-app-use-19":"M\xe9tier et \xe9tudes.","privacy-app-use-20":"Go\xfbts musicaux.","privacy-app-use-21":"Meilleur ami.","privacy-app-use-22":"Si vous l\'autorisez, votre g\xe9olocalisation pr\xe9cise, qui, si vous l\'avez autoris\xe9, s\'effectue en arri\xe8re-plan.","privacy-app-use-23":"Donn\xe9es d\'utilisation: des informations peuvent \xeatre collect\xe9es sur vos interactions avec d\'autres utilisateurs (chats avec d\'autres utilisateurs, utilisateurs avec lesquels vous vous connectez et interagissez, heure, fr\xe9quence d\'interaction ou autres caract\xe9ristiques de vos interactions).","privacy-app-use-24":"Certaines des donn\xe9es que vous pouvez fournir volontairement sont consid\xe9r\xe9es comme sensibles, car elles sont li\xe9es \xe0 votre orientation sexuelle. Vous devez tenir compte du fait que, si vous d\xe9cidez d\'inclure de telles informations, CRUSH les traitera avec le reste des informations pour remplir les objectifs indiqu\xe9s ci-dessous. De m\xeame, ces informations peuvent \xeatre partag\xe9es avec le reste des utilisateurs (elles peuvent \xeatre rendues publiques), de sorte qu\'une utilisation non autoris\xe9e de l\'App par d\'autres utilisateurs pourrait entra\xeener la fuite de ces donn\xe9es. CRUSH n\'est pas responsable de l\'utilisation inappropri\xe9e des donn\xe9es par d\'autres utilisateurs.","privacy-app-use-25":"Nous vous informons \xe9galement que CRUSH utilise les donn\xe9es ci-dessus dans le but de cr\xe9er des profils afin de vous recommander du contenu qui pourrait vous int\xe9resser, en tenant compte des caract\xe9ristiques personnelles que vous mentionnez \xe0 votre sujet, comme expliqu\xe9 ci-dessous.","privacy-app-use-26":"De plus, si vous l\'autorisez, nous aurons acc\xe8s \xe0:","privacy-app-use-27":"Appareil photo (images): l\'autorisation de l\'appareil photo permet \xe0 l\'utilisateur de t\xe9l\xe9charger n\'importe quelle image directement sur l\'App.","privacy-app-use-28":"Galerie de photos (images): accorder l\'acc\xe8s \xe0 la galerie de photos permet \xe0 l\'utilisateur de t\xe9l\xe9charger n\'importe quelle image de sa galerie de photos.","privacy-app-use-29":"Microphone (audio): accorder l\'acc\xe8s au microphone permet \xe0 l\'utilisateur d\'utiliser l\'enregistreur vocal de l\'appareil directement depuis l\'App.","privacy-app-use-30":"Contenu publi\xe9 par vous:","privacy-app-use-31":"En utilisant notre App, vous avez la possibilit\xe9 d\'interagir avec d\'autres utilisateurs via notre communaut\xe9, de pouvoir t\xe9l\xe9charger des publications avec du contenu audiovisuel (photos, audios, etc., si vous avez accord\xe9 les autorisations respectives) et d\'ajouter des commentaires avec vos opinions, soulever des doutes et r\xe9soudre les pr\xe9occupations des autres utilisateurs.","privacy-app-use-32":"Nous proposons \xe9galement un excitant mode \'Stalker\', o\xf9 vos amis peuvent capturer des GIFs de vous avec votre consentement. Cependant, la responsabilit\xe9 de la capture et de la demande de publication de ces GIFs sur votre profil incombe \xe0 l\'utilisateur qui initie la demande. Le GIF ne sera pas publi\xe9 sur votre profil tant que vous n\'aurez pas accept\xe9 la demande. De plus, tous les collaborateurs peuvent supprimer d\xe9finitivement la publication, soit en la supprimant directement, soit en refusant la demande.","privacy-app-use-33":"CRUSH utilise la technologie de reconnaissance faciale de Amazon Web Services pour traiter les donn\xe9es biom\xe9triques des utilisateurs de CRUSH en tant que fournisseur de services (\'Processeur\'). Amazon peut traiter et stocker des mod\xe8les de visage dans le but de fournir des services de v\xe9rification faciale et/ou d\'identification au nom de CRUSH, et uniquement sur les instructions de CRUSH. Amazon conservera ces donn\xe9es aussi longtemps que CRUSH en fera la demande, qui ne d\xe9passera pas une p\xe9riode de gr\xe2ce limit\xe9e apr\xe8s la date \xe0 laquelle (i) CRUSH cesse d\'avoir une relation avec Amazon ou (ii) lorsque CRUSH demande la suppression.","privacy-app-use-34":"Dans le cas o\xf9 vous publiez des messages dans l\'App (ce qui est simplement facultatif, nous ne vous obligeons pas \xe0 le faire), la technologie de reconnaissance faciale de Amazon sera utilis\xe9e, ce qui nous permet de d\xe9tecter les visages et de trouver des utilisateurs similaires \xe0 vous (jumeaux) dans notre syst\xe8me. C\'est la seule utilisation que nous faisons de cette technologie de reconnaissance.","privacy-app-use-35":"Notre sous-traitant, Amazon, s\'engage \xe0 respecter sa propre conformit\xe9 au GDPR, ainsi qu\'\xe0 fournir une vari\xe9t\xe9 de produits, de fonctionnalit\xe9s, de documentation et de ressources pour aider ses clients \xe0 respecter leurs obligations de conformit\xe9 en vertu du GDPR.","privacy-app-use-36":"Donn\xe9es d\'utilisation de l\'App:","privacy-app-use-37":"Nous recueillons \xe9galement automatiquement des donn\xe9es d\'utilisation de l\'App, en particulier des donn\xe9es techniques et des informations li\xe9es \xe0 votre utilisation de l\'App, y compris le type d\'appareil mobile, l\'identifiant unique de votre appareil mobile, l\'adresse IP de votre appareil mobile, le syst\xe8me d\'exploitation mobile, si tout, le type de navigateurs Internet que vous utilisez et des informations sur la fa\xe7on dont vous utilisez l\'App, telles que la fr\xe9quence et l\'heure d\'utilisation, les publicit\xe9s sur lesquelles vous avez cliqu\xe9, etc.","privacy-app-use-38":"Donn\xe9es vous concernant fournies par des tiers:","privacy-app-use-39":"D\'autres utilisateurs de l\'App peuvent nous fournir des informations vous concernant lorsqu\'ils utilisent nos services; par exemple, lorsqu\'ils interagissent avec vous ou s\'ils nous envoient un rapport vous concernant.","privacy-app-use-40":"Quelles sont les finalit\xe9s du traitement de vos donn\xe9es personnelles?","privacy-app-use-41":"Inscrivez-vous et g\xe9rez votre compte","privacy-app-use-42":"afin que nous puissions v\xe9rifier votre adresse e-mail et votre \xe2ge pour vous inscrire \xe0 l\'App, interagir avec vous et vous donner acc\xe8s \xe0 nos services.","privacy-app-use-43":"G\xe9rer et ex\xe9cuter la relation contractuelle qui nous unit:","privacy-app-use-44":"nous effectuons diff\xe9rentes \xe9tapes n\xe9cessaires \xe0 l\'ex\xe9cution du contrat sign\xe9 avec vous, afin que, par exemple, nous puissions vous fournir le service, vous contacter pour vous aider \xe0 r\xe9soudre les doutes, v\xe9rifier les informations que vous nous avez fournies. De m\xeame, nous pouvons vous envoyer des communications de nature administrative, concernant des mises \xe0 jour, des modifications de nos conditions de service, des alertes de s\xe9curit\xe9, ainsi que r\xe9pondre \xe0 toute demande ou exigence que vous nous envoyez.","privacy-app-use-45":"Publiez votre contenu.","privacy-app-use-46":"Lorsque vous partagez du contenu ou des informations via l\'App, il appara\xeetra publi\xe9 pour le public que vous avez s\xe9lectionn\xe9 et qui peut voir ce que vous partagez. Pour ajouter certains contenus, tels que des photos et des vid\xe9os, vous devrez nous donner acc\xe8s \xe0 votre appareil photo ou \xe0 votre galerie de photos.","privacy-app-use-47":"Tout utilisateur de notre App peut voir votre nom d\'utilisateur et votre profil public sur l\'App, qui comprend le contenu que vous avez partag\xe9 avec le grand public. Gardez \xe9galement \xe0 l\'esprit que votre contenu publi\xe9 dans l\'App peut \xeatre partag\xe9 par d\'autres utilisateurs \xe0 l\'int\xe9rieur ou \xe0 l\'ext\xe9rieur de l\'App, prenez-en une capture d\'\xe9cran ou t\xe9l\xe9chargez-le.","privacy-app-use-48":"Publiez du contenu sur vous.","privacy-app-use-49":"Les autres utilisateurs de l\'App peuvent cr\xe9er et partager du contenu pr\xe9sentant votre image ou vos donn\xe9es avec un public de leur choix. Si vous ne vous sentez pas \xe0 l\'aise avec le contenu que d\'autres personnes ont partag\xe9 \xe0 votre sujet, veuillez le signaler en utilisant les formulaires de l\'App ou contactez-nous par courrier.","privacy-app-use-50":"Vous proposer du contenu (actualit\xe9s, articles, exp\xe9riences, entre autres)","privacy-app-use-51":"cr\xe9er directement par CRUSH ou en collaboration avec des personnes externes susceptibles de vous int\xe9resser.","privacy-app-use-52":"Envoi de notifications push et d\'alertes dans l\'App.","privacy-app-use-53":"Si vous l\'avez autoris\xe9, vous recevrez nos notifications push dans votre navigateur Web ou sur votre appareil mobile. Les notifications push peuvent inclure des rappels, des communications promotionnelles, des alertes et des mises \xe0 jour concernant l\'App et les services.","privacy-app-use-54":"Si vous activez ces notifications, vous recevrez des notifications personnalis\xe9es, bas\xe9es sur un profil que nous d\xe9veloppons \xe0 votre sujet et sur l\'utilisation que vous faites de l\'App. Pour la personnalisation des notifications, les informations obtenues gr\xe2ce aux donn\xe9es que vous avez saisies dans l\'App et le les donn\xe9es collect\xe9es concernant l\'utilisation de l\'App (contenus visit\xe9s) pour cr\xe9er un profil en rapport avec vos centres d\'int\xe9r\xeat et vous proposer principalement les contenus et informations qui vous conviennent.","privacy-app-use-55":"Vous pouvez d\xe9sactiver les notifications push \xe0 tout moment en ajustant les param\xe8tres de votre appareil mobile, bien que la d\xe9sactivation n\'affecte pas les autres communications que vous pouvez recevoir de CRUSH, telles que les communications par e-mail.","privacy-app-use-56":"Pr\xe9vention, d\xe9tection et poursuite des activit\xe9s ill\xe9gales ou contraires aux conditions de service ou qui mettent en danger la s\xe9curit\xe9 des informations ou de l\'App:","privacy-app-use-57":"CRUSH peut traiter les donn\xe9es pour contr\xf4ler et pr\xe9venir toute forme d\'abus de nos services, tels que les activit\xe9s frauduleuses, les attaques par d\xe9ni de service, l\'envoi de spam, l\'acc\xe8s non autoris\xe9 aux comptes de nos utilisateurs, ainsi que toute autre pratique contraire \xe0 les Conditions G\xe9n\xe9rales et d\'Utilisation de l\'App ou met en danger la s\xe9curit\xe9 des informations ou l\'int\xe9grit\xe9 de l\'App elle-m\xeame, en pouvant supprimer le contenu ou le compte qui est contraire \xe0 la loi, \xe0 nos Conditions G\xe9n\xe9rales ou aux R\xe8gles de la Communaut\xe9.","privacy-app-use-58":"Dans ce but, le traitement des plaintes que vous pr\xe9sentez contre d\'autres utilisateurs ou celles qui sont pr\xe9sent\xe9es contre vous est \xe9galement inclus, avec la possibilit\xe9 de contacter CRUSH pour analyser le cas sp\xe9cifique et garantir qu\'il y aura une intervention humaine pour corriger ou rectifier le probl\xe8me qui se pr\xe9sente \xe0 nous.","privacy-app-use-59":"Nous pouvons \xe9galement utiliser des outils pour d\xe9tecter le contenu inappropri\xe9 (par exemple, contenu pour adultes ou violent) dans le contenu visuel que vous publiez.","privacy-app-use-60":"Afin de vous offrir un meilleur service, vos donn\xe9es seront \xe9galement trait\xe9es dans le but de:","privacy-app-use-61":"Vous aider \xe0 vous connecter avec d\'autres utilisateurs, vous permettant d\'interagir avec eux via des \xe9crans de discussion et d\'autres m\xe9canismes.","privacy-app-use-62":"Vous recommander \xe0 d\'autres utilisateurs qui vous ressemblent.","privacy-app-use-63":"Pour faire des recommandations, nous utilisons les informations que vous nous fournissez, y compris les informations sur votre emplacement si vous donnez votre permission, ainsi que les informations que nous obtenons de votre utilisation de cet espace (par exemple, les caract\xe9ristiques des personnes avec lesquelles vous interagissez r\xe9ellement) pour d\xe9velopper un profil automatis\xe9 sur vous et vous montrer de pr\xe9f\xe9rence les utilisateurs qui correspondent \xe0 votre profil et ce que vous recherchez.","privacy-app-use-64":"En ce sens, les utilisateurs actifs de l\'App vous seront de pr\xe9f\xe9rence pr\xe9sent\xe9s, qui sont proches de vous, qui correspondent aux pr\xe9f\xe9rences indiqu\xe9es et \xe0 votre profil cr\xe9\xe9 \xe0 partir de vos interactions, en veillant \xe9galement \xe0 ce que vos caract\xe9ristiques et votre profil correspondent aux pr\xe9f\xe9rences des utilisateurs recommand\xe9s.","privacy-app-use-65":"\xc0 des fins statistiques et autres r\xe9alis\xe9es avec des donn\xe9es anonymes.","privacy-app-use-66":"Nous pouvons anonymiser toutes les informations personnelles collect\xe9es aupr\xe8s des utilisateurs qui utilisent l\'App \xe0 des fins statistiques et autres, telles que la formation d\'algorithmes, pour mesurer l\'efficacit\xe9 des campagnes publicitaires disponibles sur l\'App, la navigabilit\xe9 et la convivialit\xe9 de l\'App pour pouvoir am\xe9liorer le design, pr\xe9sentation et fonctionnalit\xe9s disponibles ou autres.","privacy-app-use-67":"Pour vous montrer de la publicit\xe9:","privacy-app-use-68":"Notre App peut inclure des publicit\xe9s qui, si vous y consentez, seront personnalis\xe9es en fonction de vos go\xfbts et pr\xe9f\xe9rences.","privacy-app-use-69":"Quelle est la base l\xe9gale qui nous permet de traiter vos donn\xe9es? La fourniture de ces donn\xe9es est-elle obligatoire?","privacy-app-use-70":"Ex\xe9cuter et maintenir la relation contractuelle entre les Parties.","privacy-app-use-71":"La raison pour laquelle nous traitons vos informations aux fins mentionn\xe9es ci-dessus est de remplir le contrat que nous avons avec vous.","privacy-app-use-72":"Consentement.","privacy-app-use-73":"Certaines fonctionnalit\xe9s reposent sur votre consentement expr\xe8s: (i) publication de votre propre contenu, (ii) acc\xe8s \xe0 l\'appareil photo ou \xe0 la galerie photo pour publier certains contenus dans l\'App, (iii) acc\xe8s \xe0 la g\xe9olocalisation de l\'appareil pour recommandation d\'utilisateurs par la proximit\xe9 (iv) la r\xe9ception de notifications push personnalis\xe9es (v) l\'affichage de contenus publicitaires personnalis\xe9s. De plus, si vous d\xe9cidez de nous fournir volontairement des informations suppl\xe9mentaires pour compl\xe9ter votre profil, ces informations seront utilis\xe9es sur la base de votre consentement.","privacy-app-use-74":"N\'oubliez pas que vous pouvez r\xe9voquer votre consentement \xe0 tout moment via les param\xe8tres de votre appareil, en supprimant votre contenu ou via les options disponibles dans l\'App.","privacy-app-use-75":"Int\xe9r\xeat l\xe9gitime.","privacy-app-use-76":"Les donn\xe9es seront trait\xe9es sur la base de notre int\xe9r\xeat l\xe9gitime en ce qui concerne la pr\xe9vention des activit\xe9s ill\xe9gales et autres li\xe9es \xe0 la s\xe9curit\xe9 de l\'App, pour garantir la s\xe9curit\xe9 du r\xe9seau et des informations afin de pr\xe9venir les \xe9v\xe9nements susceptibles de compromettre la disponibilit\xe9, l\'authenticit\xe9, l\'int\xe9grit\xe9 et la confidentialit\xe9 des donn\xe9es personnelles ou de la plateforme elle-m\xeame, ainsi que le respect des normes communautaires.","privacy-app-use-77":"Nous pouvons \xe9galement vous montrer des publicit\xe9s non personnalis\xe9es via l\'App en fonction de notre int\xe9r\xeat l\xe9gitime.","privacy-app-use-78":"Si vous souhaitez obtenir plus d\'informations sur la pond\xe9ration que nous avons effectu\xe9e sur les int\xe9r\xeats l\xe9gitimes de CRUSH par rapport aux finalit\xe9s ci-dessus, vous pouvez en faire la demande en nous \xe9crivant \xe0","privacy-app-use-79":"Traitement de donn\xe9es sp\xe9cialement prot\xe9g\xe9es.","privacy-app-use-80":"Les donn\xe9es relatives \xe0 vos int\xe9r\xeats ou aspects li\xe9s \xe0 l\'orientation sexuelle seront trait\xe9es sur la base de votre consentement explicite.","privacy-app-use-81":"Combien de temps conservons-nous vos informations?","privacy-app-use-82":"Nous conserverons toutes vos informations personnelles aussi longtemps que notre relation contractuelle est en vigueur, c\'est-\xe0-dire jusqu\'\xe0 ce que vous supprimiez votre compte. Une fois la relation contractuelle termin\xe9e ou votre compte r\xe9sili\xe9, CRUSH conservera, bloqu\xe9, toutes les informations pendant les p\xe9riodes pr\xe9vues par la loi pour enqu\xeater sur les comportements ill\xe9gaux ou pr\xe9judiciables, faire face \xe0 d\'\xe9ventuelles responsabilit\xe9s et d\xe9montrer le respect de nos obligations.","privacy-app-use-83":"En ce qui concerne le contenu que vous publiez via notre App, vous devez tenir compte du fait que toute publication ou commentaire que vous avez publi\xe9 dans notre communaut\xe9 restera dans l\'App jusqu\'\xe0 ce que vous le supprimiez ou jusqu\'\xe0 ce que vous supprimiez votre compte. Cependant, tout autre contenu o\xf9 vous apparaissez et qui a \xe9t\xe9 publi\xe9 par d\'autres utilisateurs (par exemple, des photos ou des vid\xe9os) pourrait rester visible jusqu\'\xe0 ce que ledit utilisateur le supprime ou ferme son compte.","privacy-app-use-84":"Cependant, nous nous r\xe9servons le droit d\'utiliser vos informations sous forme agr\xe9g\xe9e apr\xe8s la fermeture de votre compte \xe0 des fins statistiques et pour am\xe9liorer nos services. L\'utilisation de ces informations ne permettra pas de vous identifier personnellement.","privacy-app-use-85":"\xc0 qui transmettons-nous vos informations personnelles?","privacy-app-use-86":"Il n\'y a pas de transferts sp\xe9cifiques de vos donn\xe9es personnelles pour remplir l\'objectif indiqu\xe9 dans cette section. Toutefois, nous pouvons recourir aux services de prestataires, qui auront un acc\xe8s limit\xe9 aux donn\xe9es et seront tenus \xe0 une obligation de confidentialit\xe9 (pour plus d\'informations sur la mani\xe8re dont agissent nos prestataires, voir point","privacy-app-use-87":"4. A qui donnons-nous vos informations personnelles? > Fournisseurs de services","privacy-app-use-88":"Cependant, gardez \xe0 l\'esprit que lorsque vous publiez du contenu sur notre App, vous pouvez partager des informations personnelles avec d\'autres utilisateurs (y compris votre profil public).","privacy-app-use-89":"De plus, si quelqu\'un d\xe9pose un rapport qui vous implique, nous pouvons informer le plaignant des mesures que nous avons prises \xe0 la suite de son rapport, le cas \xe9ch\xe9ant.","privacy-cookies":"3.3. Navigation sur le Site (cookies)","privacy-cookies-1":"Sur notre Site Web, ainsi que dans notre App, nous utilisons des cookies ou d\'autres outils de suivi et de tra\xe7age pour collecter des informations sur l\'utilisation que les utilisateurs font du Site Web et de l\'App.","privacy-cookies-2":"Pour plus d\'informations sur le traitement que nous effectuons via lesdits outils de suivi, visitez notre","privacy-cookies-3":"Politique de Cookies","privacy-social-profiles":"3.4. Profils CRUSH sur les r\xe9seaux sociaux","privacy-social-profiles-1":"CRUSH a un profil sur les principaux r\xe9seaux sociaux, tels que Twitter, Instagram, LinkedIn ou TikTok.","privacy-social-profiles-2":"Lorsque vous devenez un adepte de l\'une de nos pages sur les r\xe9seaux sociaux, le traitement des donn\xe9es sera r\xe9gi par les conditions d\'utilisation, les politiques de confidentialit\xe9 et les r\xe8gles d\'acc\xe8s qui appartiennent au r\xe9seau social correspondant et pr\xe9alablement accept\xe9es par l\'utilisateur.","privacy-social-profiles-3":"CRUSH, en ce sens, traitera vos donn\xe9es dans le but de g\xe9rer correctement sa pr\xe9sence sur le r\xe9seau social, de vous informer des activit\xe9s, produits ou services, ainsi que pour toute autre finalit\xe9 que la r\xe9glementation des r\xe9seaux sociaux autorise.","privacy-social-profiles-4":"Gardez \xe0 l\'esprit que nous n\'avons aucune influence sur les informations que le r\xe9seau social collecte ou sur la mani\xe8re dont il les traite, nous vous recommandons donc de vous tenir inform\xe9 de l\'objet et de l\'\xe9tendue de la collecte d\'informations effectu\xe9e via lesdits r\xe9seaux sociaux.","privacy-transfer":"4. A qui donnons-nous vos informations personnelles?","privacy-transfer-1":"En g\xe9n\xe9ral, de CRUSH nous ne communiquerons pas vos donn\xe9es \xe0 des tiers. Cependant, en plus des transferts que nous indiquons sp\xe9cifiquement dans la section dans laquelle nous expliquons les caract\xe9ristiques des diff\xe9rentes op\xe9rations (point 3), nous vous informons des communications que, en g\xe9n\xe9ral, nous pouvons faire, ainsi que de leur fondement l\xe9gitimant, qui affectent tous les traitements ant\xe9rieurs.","privacy-transfer-2":"Fournisseurs de services essentiels","privacy-transfer-3":"pour ex\xe9cuter le service que nous vous proposons (par exemple, les h\xe9bergeurs informatiques ou les plateformes d\'envoi de communications commerciales). Nonobstant ce qui pr\xe9c\xe8de, ces entit\xe9s ont sign\xe9 les accords de confidentialit\xe9 correspondants et ne traiteront vos donn\xe9es que conform\xe9ment \xe0 nos instructions, ne pouvant les utiliser \xe0 leurs propres fins ou en dehors du service qu\'elles nous fournissent.","privacy-transfer-4":"Organismes publics.","privacy-transfer-5":"Nous pouvons divulguer aux autorit\xe9s publiques comp\xe9tentes les donn\xe9es et toute autre information en notre possession ou accessibles via nos syst\xe8mes lorsqu\'il existe une obligation l\xe9gale de le faire, ainsi que lorsque cela est requis, par exemple lorsque le but est de pr\xe9venir ou poursuivre les abus de services ou les activit\xe9s frauduleuses via notre Site Web ou notre App. Dans ces cas, les donn\xe9es personnelles que vous nous fournissez seront conserv\xe9es et mises \xe0 la disposition des autorit\xe9s administratives ou judiciaires.","privacy-transfer-6":"Dans le cas d\'une transaction d\'entreprise:","privacy-transfer-7":"En cas de fusion, acquisition, vente de tout ou partie de ses actifs, ou de tout autre type de transaction d\'entreprise impliquant un tiers, nous pouvons partager, divulguer ou transf\xe9rer les donn\xe9es des utilisateurs \xe0 l\'entit\xe9 successeur (y compris pendant la p\xe9riode pr\xe9- phase op\xe9ratoire).","privacy-transfer-8":"Aux tiers apr\xe8s agr\xe9gation ou anonymisation:","privacy-transfer-9":"nous pouvons divulguer ou utiliser des donn\xe9es agr\xe9g\xe9es ou anonymis\xe9es (c\'est-\xe0-dire des donn\xe9es qui ne peuvent pas \xeatre li\xe9es \xe0 une personne physique identifi\xe9e ou identifiable) \xe0 quelque fin que ce soit.","privacy-transfer-10":"\xc0 des tiers avec le consentement de l\'utilisateur ou une autre base l\xe9gitime:","privacy-transfer-11":"Dans le cas o\xf9 nous souhaitons partager des donn\xe9es avec des tiers en dehors du champ d\'App de la pr\xe9sente politique de confidentialit\xe9, votre consentement sera demand\xe9, dans tous les cas, ou vous en serez inform\xe9 et sa base l\xe9gitime.","privacy-transfer-12":"De m\xeame, nous vous informons que cette politique de confidentialit\xe9 se r\xe9f\xe8re uniquement \xe0 la collecte, au traitement et \xe0 l\'utilisation d\'informations (relatives aux donn\xe9es personnelles) par nous \xe0 travers l\'interaction que vous effectuez avec notre Site Web ou notre App. L\'acc\xe8s aux pages web de tiers auxquelles vous pouvez acc\xe9der via des liens depuis le Site Web ou l\'App ont leurs propres politiques de confidentialit\xe9 sur lesquelles nous n\'avons aucun contr\xf4le. Par cons\xe9quent, avant de leur fournir des informations personnelles, nous vous recommandons de vous renseigner sur leurs politiques de confidentialit\xe9.","privacy-eea":"5. Vos donn\xe9es personnelles sont-elles transf\xe9r\xe9es vers des pays tiers en dehors de l\'Espace \xe9conomique europ\xe9en?","privacy-eea-1":"Certains de nos prestataires de services sont situ\xe9s dans des pays hors de l\'Espace \xe9conomique europ\xe9en (","privacy-eea-2":"\'EEE\'","privacy-eea-3":"La localisation de ces soci\xe9t\xe9s en dehors de l\'EEE implique l\'existence d\'un transfert international de vos donn\xe9es personnelles, ce qui pourrait impliquer un degr\xe9 de protection inf\xe9rieur \xe0 celui inclus dans la r\xe9glementation europ\xe9enne. Cependant, depuis CRUSH, nous avons appliqu\xe9 des mesures afin que lesdits transferts n\'entra\xeenent pas un degr\xe9 de protection inf\xe9rieur de vos donn\xe9es personnelles.","privacy-eea-4":"En ce sens, les prestataires de services situ\xe9s en dehors de l\'EEE ont sign\xe9 les clauses contractuelles types correspondantes approuv\xe9es par la Commission europ\xe9enne (","privacy-eea-5":"\'CCT\'","privacy-eea-6":"), un accord sign\xe9 entre les deux entit\xe9s par lequel l\'entreprise non communautaire garantit qu\'elle applique les normes europ\xe9ennes de protection des donn\xe9es.","privacy-eea-7":"Par cons\xe9quent, le recours \xe0 ces prestataires n\'entra\xeene pas un degr\xe9 de protection de vos donn\xe9es personnelles inf\xe9rieur au recours \xe0 des prestataires situ\xe9s dans l\'Union europ\xe9enne. Vous pouvez consulter le contenu du CCT dans le lien suivant:","privacy-eea-8":"Ensuite, nous indiquons quels sont les transferts internationaux que nous effectuons depuis CRUSH:","privacy-eea-9":"Nom","privacy-eea-10":"Activit\xe9s affect\xe9es","privacy-eea-11":"Pays","privacy-eea-12":"M\xe9canisme de transfert","privacy-eea-13":"Toutes","privacy-eea-14":"D\xe9tection des visages et recherche de visages similaires","privacy-eea-15":"Notifications push","privacy-eea-16":"Envoyer des emails","privacy-eea-usa":"Etats-Unis","privacy-eea-sccs":"Clauses Contractuelles Types (CCS)","privacy-rights":"6. Quels sont les droits que vous pouvez exercer en tant qu\'int\xe9ress\xe9?","privacy-rights-1":"Vous pouvez exercer les droits que la loi vous garantit concernant le traitement de vos donn\xe9es personnelles en contactant notre d\xe9l\xe9gu\xe9 \xe0 la protection des donn\xe9es par e-mail","privacy-rights-2":"Toute demande de droits que nous recevons sera r\xe9solue dans les meilleurs d\xe9lais et, en tout \xe9tat de cause, dans le d\xe9lai maximum \xe9tabli par la loi, \xe0 compter de la date de r\xe9ception. Dans certains cas, il sera n\xe9cessaire de demander une copie de votre pi\xe8ce d\'identit\xe9 ou autre pi\xe8ce d\'identit\xe9 pour v\xe9rifier votre identit\xe9.","privacy-rights-3":"Les droits qui vous correspondent en tant qu\'int\xe9ress\xe9 sont les suivants:","privacy-rights-4":"Droit de retirer le consentement accord\xe9","privacy-rights-5":"Vous pouvez \xe0 tout moment r\xe9voquer votre consentement pour tout traitement fond\xe9 sur celui-ci. Cependant, le retrait du consentement n\'affectera pas la l\xe9galit\xe9 du traitement fond\xe9 sur le consentement avant son retrait.","privacy-rights-6":"Droit d\'acc\xe8s","privacy-rights-7":"Vous avez le droit de savoir quelles donn\xe9es sont trait\xe9es, le cas \xe9ch\xe9ant et, le cas \xe9ch\xe9ant, d\'en obtenir une copie, ainsi que d\'obtenir des informations concernant:","privacy-rights-8":"l\'origine et les destinataires des donn\xe9es;","privacy-rights-9":"les finalit\xe9s pour lesquelles elles sont trait\xe9es;","privacy-rights-10":"s\'il existe un processus d\xe9cisionnel automatis\xe9, y compris le profilage;","privacy-rights-11":"la dur\xe9e de conservation des donn\xe9es; et","privacy-rights-12":"les droits pr\xe9vus par la r\xe9glementation.","privacy-rights-13":"Droit de rectification","privacy-rights-14":"Vous avez le droit d\'obtenir la rectification de vos donn\xe9es personnelles ou de les compl\xe9ter lorsqu\'elles sont incompl\xe8tes.","privacy-rights-15":"Droit d\'effacement","privacy-rights-16":"Vous avez le droit de demander la suppression de vos donn\xe9es personnelles si elles ne sont plus n\xe9cessaires aux fins pour lesquelles elles ont \xe9t\xe9 collect\xe9es ou, le cas \xe9ch\xe9ant, si nous ne sommes plus autoris\xe9s \xe0 les traiter.","privacy-rights-17":"Droit \xe0 la portabilit\xe9 des donn\xe9es","privacy-rights-18":"Vous avez le droit de demander la portabilit\xe9 de vos donn\xe9es dans le cas de traitements fond\xe9s sur votre consentement ou sur l\'ex\xe9cution d\'un contrat, \xe0 condition que le traitement ait \xe9t\xe9 effectu\xe9 par des moyens automatis\xe9s. En cas d\'exercice de ce droit, vous recevrez vos donn\xe9es personnelles dans un format structur\xe9, couramment utilis\xe9 et lisible par tout appareil \xe9lectronique. Cependant, vous pouvez \xe9galement demander, lorsque cela est possible, que vos donn\xe9es soient transmises directement \xe0 une autre soci\xe9t\xe9.","privacy-rights-19":"Droit de limiter le traitement de vos donn\xe9es personnelles","privacy-rights-20":"Vous avez le droit de limiter le traitement de vos donn\xe9es dans les cas suivants:","privacy-rights-21":"Lorsque vous avez demand\xe9 la rectification de vos donn\xe9es personnelles, pendant la p\xe9riode pendant laquelle nous v\xe9rifions leur exactitude.","privacy-rights-22":"Lorsque vous consid\xe9rez que nous ne sommes pas autoris\xe9s \xe0 traiter vos donn\xe9es. Dans ce cas, vous pouvez nous demander de limiter son utilisation au lieu de demander sa suppression.","privacy-rights-23":"Lorsque vous consid\xe9rez qu\'il n\'est plus n\xe9cessaire pour nous de poursuivre le traitement de vos donn\xe9es et que vous souhaitez que nous les conservions \xe0 des fins d\'exercice ou de d\xe9fense de r\xe9clamations.","privacy-rights-24":"Dans les cas o\xf9 il existe un traitement fond\xe9 sur notre int\xe9r\xeat l\xe9gitime et que vous avez exerc\xe9 votre droit de vous y opposer, vous pouvez nous demander de limiter l\'utilisation de vos donn\xe9es lors de la v\xe9rification de la pr\xe9valence desdits int\xe9r\xeats par rapport au v\xf4tre.","privacy-rights-25":"Droit d\'opposition","privacy-rights-26":"Vous avez le droit de vous opposer \xe0 tout moment au traitement de vos donn\xe9es personnelles sur la base de notre int\xe9r\xeat l\xe9gitime, y compris le profilage.","privacy-rights-27":"Droit de d\xe9poser une plainte aupr\xe8s d\'une Autorit\xe9 de Surveillance","privacy-rights-28":"N\'oubliez pas qu\'\xe0 tout moment et dans le cas o\xf9 vous consid\xe9rez que nous avons viol\xe9 votre droit \xe0 la protection de vos donn\xe9es, vous pouvez adresser votre d\xe9fense \xe0 l\'autorit\xe9 de contr\xf4le correspondante, dans le cas de l\'Espagne, l\'Agence espagnole de Protection des Donn\xe9es (","privacy-confidence":"7. Comment garantissons-nous la confidentialit\xe9 de vos informations?","privacy-confidence-1":"La s\xe9curit\xe9 de vos donn\xe9es personnelles est une priorit\xe9 pour nous. Pour cette raison, CRUSH a mis en place toutes les mesures de s\xe9curit\xe9 n\xe9cessaires pour garantir une utilisation et un traitement efficaces des donn\xe9es personnelles fournies par l\'utilisateur, en pr\xe9servant la vie priv\xe9e, la confidentialit\xe9 et l\'int\xe9grit\xe9 de celles-ci, et utilise les techniques m\xe9diatiques n\xe9cessaires pour \xe9viter l\'alt\xe9ration, perte, acc\xe8s non autoris\xe9 ou traitement de vos donn\xe9es, selon l\'\xe9tat de la technologie \xe0 tout moment.","privacy-confidence-2":"Par cons\xe9quent, nous respectons les normes de s\xe9curit\xe9 recommand\xe9es pour les prot\xe9ger. Cependant, il est impossible de garantir pleinement votre s\xe9curit\xe9 en raison de la nature m\xeame d\'Internet et parce qu\'il peut y avoir des actions malveillantes de la part de tiers ind\xe9pendants de notre volont\xe9.","privacy-confidence-3":"Nous nous engageons \xe0 agir rapidement et avec diligence si la s\xe9curit\xe9 des donn\xe9es est en danger ou compromise, et \xe0 vous en informer si cela est pertinent.","privacy-modifications":"8. Modifications de cette politique","privacy-modifications-1":"De CRUSH, nous pouvons modifier le contenu de cette politique de confidentialit\xe9 \xe0 tout moment, en particulier en cas de modifications l\xe9gislatives, jurisprudentielles ou d\'interpr\xe9tation de l\'Agence espagnole de protection des donn\xe9es qui affectent le traitement des donn\xe9es effectu\xe9 par CRUSH via le Site Web ou l\'App. Toute nouvelle version de cette politique de confidentialit\xe9 entrera en vigueur \xe0 la date d\'entr\xe9e en vigueur publi\xe9e.","privacy-modifications-2":"Si la version r\xe9vis\xe9e inclut un changement substantiel qui affecte le traitement de vos donn\xe9es, nous vous en informerons au moins 30 jours \xe0 l\'avance en publiant un avis sur notre Site Web ou notre App ou en vous informant par e-mail. Dans tous les cas, nous vous recommandons de consulter p\xe9riodiquement cette politique de confidentialit\xe9 pour \xeatre inform\xe9 de la mani\xe8re dont vos donn\xe9es personnelles sont trait\xe9es et prot\xe9g\xe9es, ainsi que de vos droits.","cookies-title":"Crush - Cookies","cookies-date":"Derni\xe8re modification: 8 d\xe9cembre, 2023","cookies-header":"Politique de cookies","cookies-introduction-1":"Les deux sur le site web www.crushsocialnetwork.com (ci-apr\xe8s, le","cookies-introduction-2":"\'Site Web\'","cookies-introduction-3":") ainsi que via l\'application mobile pour Smartphones portant le nom \'Crush\' (ci-apr\xe8s, la","cookies-introduction-4":"\'App\'","cookies-introduction-5":") nous utilisons des cookies ou d\'autres outils de suivi et de tra\xe7age pour collecter des informations sur l\'utilisation que les utilisateurs font du Site Web et de l\'App.","cookies-introduction-6":"Dans ce document, vous d\xe9couvrirez quels cookies nous donnons au Cookie Monster, ainsi que tout autre type d\'informations connexes concernant cette merveilleuse bouch\xe9e.","cookies-definition":"1. Qu\'est-ce qu\'un cookie?","cookies-definition-1":"Un cookie est un fichier qui s\'installe dans le navigateur de votre terminal (ordinateur, mobile, etc.) afin de stocker et de r\xe9cup\xe9rer des donn\xe9es. Les cookies peuvent avoir une multitude de finalit\xe9s, en fonction de ce pour quoi ils ont \xe9t\xe9 configur\xe9s: par exemple, enregistrer les pr\xe9f\xe9rences, collecter des statistiques d\'utilisation, activer des fonctionnalit\xe9s techniques, entre autres.","cookies-responsible":"2. Qui est le responsable?","cookies-responsible-1":"Le responsable du traitement des informations collect\xe9es par le biais des cookies est CRUSH SOCIAL NETWORK, SARL. (CRUSH), avec NIF B-72599830 et adresse Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcie (Espagne).","cookies-responsible-2":"Si vous avez des questions concernant l\'utilisation des cookies, veuillez \xe9crire un e-mail \xe0","cookies-responsible-3":"et nous vous r\xe9pondrons d\xe8s que possible.","cookies-data":"3. Quelles donn\xe9es sont collect\xe9es via les cookies?","cookies-data-1":"Lorsque vous acc\xe9dez au Site Web ou installez et utilisez l\'App, m\xeame si vous n\'\xeates pas inscrit, les informations suivantes sont collect\xe9es par le biais de cookies:","cookies-data-2":"Informations sur l\'appareil: Lors de l\'utilisation du Site Web ou de l\'App, nous collectons des informations sur l\'appareil mobile \xe0 partir duquel vous acc\xe9dez \xe0 la plate-forme. Les informations que nous recueillons sont le mod\xe8le de l\'appareil, le syst\xe8me d\'exploitation et sa version, l\'identifiant unique de l\'appareil et le r\xe9seau.","cookies-data-3":"Informations sur votre emplacement: Nous obtenons \xe9galement l\'adresse IP, le fuseau horaire et le fournisseur de services mobiles, le cas \xe9ch\xe9ant, ce qui nous permet d\'obtenir un emplacement g\xe9n\xe9ral.","cookies-data-4":"Informations de navigation de l\'utilisateur: Nous recueillons des informations sur l\'utilisation que vous faites du Site Web et de l\'App. Plus pr\xe9cis\xe9ment, la fr\xe9quence d\'utilisation, les sections que vous visitez, l\'utilisation de fonctions sp\xe9cifiques, etc.","cookies-types":"4. Quels types de cookies existe-t-il?","cookies-types-1":"Selon son objectif,","cookies-types-2":"nous pouvons classer les cookies parmi les suivants:","cookies-types-3":"Cookies techniques:","cookies-types-4":"Ces cookies sont strictement n\xe9cessaires pour naviguer sur le Site Web ou l\'App et permettent des fonctions de base telles que la navigation d\'une section \xe0 l\'autre. Ils sont en charge des aspects techniques tels que l\'identification des profils ou des sessions et la gestion des pr\xe9f\xe9rences des outils dans l\'utilisation, l\'interaction et la localisation de l\'acc\xe8s au contenu. Appartiennent \xe9galement \xe0 cette cat\xe9gorie, en raison de leur nature technique, les cookies qui permettent la gestion, de la mani\xe8re la plus efficace possible, des espaces publicitaires inclus dans le Site Web et l\'App, sans collecter d\'informations aupr\xe8s des utilisateurs \xe0 des fins diff\xe9rentes, telles que personnaliser les publicit\xe9s ou d\'autres types de contenu.","cookies-types-5":"Cookies statistiques:","cookies-types-6":"Ces cookies mesurent et collectent des informations statistiques concernant l\'utilisation faite par l\'utilisateur du Site Web ou de l\'App, telles que le temps pass\xe9 sur la plateforme, le nombre de visites ou les contenus visit\xe9s. Ces informations nous permettent de comprendre comment les utilisateurs interagissent avec le Site Web et l\'App, d\'\xe9valuer les performances, quelles sections sont les plus ou les moins visit\xe9es, y compris la quantification de l\'impact des publicit\xe9s introduites sur le Site Web et l\'App (le cas \xe9ch\xe9ant). Le fait de disposer de ces informations peut r\xe9soudre des erreurs et am\xe9liorer la conception du syst\xe8me et le contenu qui y est propos\xe9.","cookies-types-7":"Cookies de pr\xe9f\xe9rence ou de personnalisation:","cookies-types-8":"Les cookies de pr\xe9f\xe9rence permettent au Site Web ou \xe0 l\'App de m\xe9moriser des informations sp\xe9cifiques sur l\'utilisateur afin qu\'il puisse acc\xe9der au service avec certaines caract\xe9ristiques qui peuvent diff\xe9rencier son exp\xe9rience de celle des autres utilisateurs. Par exemple, votre langue pr\xe9f\xe9r\xe9e ou la r\xe9gion \xe0 partir de laquelle vous acc\xe9dez, le nombre de r\xe9sultats \xe0 afficher lorsque l\'utilisateur effectue une recherche, l\'apparence ou le contenu du service en fonction du type d\'appareil \xe0 partir duquel l\'utilisateur y acc\xe8de, etc.","cookies-types-9":"Cookies publicitaires comportementaux:","cookies-types-10":"Ces cookies permettent la gestion des espaces publicitaires qui, le cas \xe9ch\xe9ant, ont \xe9t\xe9 int\xe9gr\xe9s au Site Web ou \xe0 l\'App. Toutefois, la gestion des espaces publicitaires se fait en fonction du profil de navigation de l\'utilisateur. Ces cookies stockent les informations de navigation de l\'utilisateur obtenues gr\xe2ce \xe0 l\'observation continue de ses habitudes de navigation, en d\xe9veloppant un profil d\'utilisateur sp\xe9cifique, de sorte que les publicit\xe9s qui apparaissent dans ces espaces seront personnalis\xe9es pour l\'utilisateur en fonction desdites habitudes.","cookies-types-11":"Selon l\'entit\xe9 qui les g\xe8re:","cookies-types-12":"Cookies propres:","cookies-types-13":"sont ceux qui sont envoy\xe9s \xe0 l\'appareil de l\'utilisateur \xe0 partir d\'un ordinateur ou d\'un domaine g\xe9r\xe9 par la personne responsable du Site Web ou de l\'App, dans ce cas, CRUSH, et \xe0 partir duquel le service demand\xe9 par l\'utilisateur est fourni.","cookies-types-14":"Cookies tiers:","cookies-types-15":"sont ceux qui sont envoy\xe9s \xe0 l\'appareil de l\'utilisateur \xe0 partir d\'un ordinateur ou d\'un domaine qui n\'est pas g\xe9r\xe9 par la personne responsable du Site Web ou de l\'App, mais par une autre entit\xe9 qui traite les donn\xe9es obtenues par le biais des cookies.","cookies-types-16":"En fonction du temps qu\'ils restent actifs sur l\'appareil:","cookies-types-17":"Cookies de sessions:","cookies-types-18":"Ils ont pour objet de collecter et de stocker des donn\xe9es pendant la navigation de l\'utilisateur sur le Site ou l\'App, et sont d\xe9sactiv\xe9s \xe0 la fin de la navigation.","cookies-types-19":"Cookies persistants:","cookies-types-20":"Ceux-ci stockent des donn\xe9es qui peuvent \xeatre consult\xe9es et trait\xe9es pendant une dur\xe9e d\xe9finie par le responsable du cookie. Leur dur\xe9e de vie peut varier de quelques minutes \xe0 plusieurs ann\xe9es.","cookies-used":"5. Quels cookies utilisons-nous sp\xe9cifiquement sur notre plateforme?","cookies-used-1":"Sur notre plateforme, nous utilisons les cookies suivants:","cookies-used-2":"Pr\xe9nom","cookies-used-3":"Objectif","cookies-used-4":"Cookies propres/tiers","cookies-used-5":"Expiration","cookies-used-6":"14 mois","cookies-used-7":"Ind\xe9finie","cookies-used-stats":"Statistiques","cookies-used-technical":"Technique","cookies-used-third-party-google":"Tiers (Google LLC.)","cookies-legitimation":"6. Quelle est la base de l\xe9gitimation qui nous permet de traiter vos donn\xe9es par le biais de cookies? Si oui, sont-ils obligatoires?","cookies-legitimation-1":"Les informations que nous collectons via les cookies et autres dispositifs de suivi sont bas\xe9es sur votre consentement, que nous demandons lorsque vous acc\xe9dez au Site Web ou lorsque vous installez l\'App via une fen\xeatre contextuelle informative ou de la mani\xe8re \xe9tablie par Google (en ce qui concerne Android) ou Apple (en ce qui concerne iOS).","cookies-legitimation-2":"En ce sens, vous pouvez \xe0 tout moment retirer votre consentement comme expliqu\xe9 dans la section relative \xe0 la r\xe9vocation du consentement.","cookies-legitimation-3":"Les cookies techniques ne peuvent pas \xeatre d\xe9sactiv\xe9s, sinon le bon fonctionnement du Site Web ou de l\'App serait compromis. En g\xe9n\xe9ral, ils ne sont d\xe9finis qu\'en r\xe9ponse \xe0 des actions entreprises lors de la demande de services de notre part, telles que la d\xe9finition de vos pr\xe9f\xe9rences en ce qui concerne les cookies eux-m\xeames, la connexion ou le remplissage de formulaires. Dans le cas o\xf9 la d\xe9sactivation se produirait, cela pourrait entra\xeener une limitation de l\'utilisation de certains des services du Site Web ou de l\'App en raison de l\'impossibilit\xe9 d\'acc\xe9der \xe0 certaines fonctionnalit\xe9s et, par cons\xe9quent, votre exp\xe9rience serait moins satisfaisante.","cookies-transfer":"7. A qui donnons-nous vos informations personnelles? Y a-t-il des transferts de donn\xe9es internationaux?","cookies-transfer-1":"Nous utilisons des cookies tiers, qui sont les cookies collect\xe9s et g\xe9r\xe9s par un tiers, de sorte que lesdites entit\xe9s recevront vos donn\xe9es personnelles collect\xe9es via les cookies aux fins indiqu\xe9es pour chaque cookie. Ces types de cookies sont indiqu\xe9s dans le tableau de la section 5, en tant que \'Cookies tiers\'. Ce tableau identifie le tiers qui g\xe8re chaque cookie.","cookies-transfer-2":"Vous pouvez vous renseigner sur les transferts vers des pays tiers qui, le cas \xe9ch\xe9ant, sont effectu\xe9s par les tiers identifi\xe9s dans la pr\xe9sente politique de cookies dans leurs politiques correspondantes.","cookies-consent":"8. Quelle est la mani\xe8re d\'accepter, de refuser ou de r\xe9voquer le consentement \xe0 l\'utilisation de cookies sur ce site web?","cookies-consent-1":"Lorsque vous acc\xe9dez pour la premi\xe8re fois \xe0 notre Site Web ou \xe0 notre App, une fen\xeatre s\'affiche dans laquelle vous pouvez indiquer si vous acceptez les cookies ou si vous souhaitez les configurer ou les refuser, sauf ceux qui sont strictement n\xe9cessaires. De m\xeame, vous pouvez retirer \xe0 tout moment le consentement pr\xe9c\xe9demment accord\xe9.","cookies-consent-2":"Si vous souhaitez retirer votre consentement relatif \xe0 la Politique de Cookies \xe0 tout moment, vous disposez de deux possibilit\xe9s: (i) retirer votre consentement via les boutons activ\xe9s \xe0 cet effet dans la pr\xe9sente Politique de Cookies; ou (ii) supprimer les cookies stock\xe9s sur l\'appareil via les param\xe8tres et les configurations de votre navigateur Internet.","cookies-consent-3":"Gardez \xe0 l\'esprit que si vous acceptez les cookies de tiers, vous devez les \xe9liminer des options du navigateur ou du syst\xe8me propos\xe9 par le tiers lui-m\xeame.","cookies-consent-4":"Vous pouvez d\xe9velopper les informations sur la fa\xe7on de d\xe9sactiver les cookies, en fonction de votre navigateur, dans les liens suivants:","cookies-consent-5":"; pour iOS:","cookies-rights":"9. Quels sont les droits que vous pouvez exercer en tant qu\'int\xe9ress\xe9?","cookies-rights-1":"Les droits dont vous disposez en tant qu\'int\xe9ress\xe9 en ce qui concerne la protection de vos donn\xe9es personnelles sont indiqu\xe9s dans la section \'Quels sont les droits que vous pouvez exercer en tant qu\'int\xe9ress\xe9?\' au sein de la","cookies-rights-2":"Politique de Confidentialit\xe9","cookies-modifications":"10. Modifications de cette politique","cookies-modifications-1":"Nous pouvons mettre \xe0 jour la politique en mati\xe8re de cookies de notre plate-forme de temps \xe0 autre. Pour cette raison, nous vous recommandons de consulter cette politique chaque fois que vous acc\xe9dez \xe0 notre Site Web ou \xe0 notre App afin d\'\xeatre correctement inform\xe9 sur comment et pour quoi nous utilisons les cookies."}');

});

parcelRegister("kSrnd", function(module, exports) {
module.exports = JSON.parse('{"404-title":"Crush - Non trovato","404-not-found-1":"Non trovato","404-not-found-2":"Spiacenti, la pagina che stai cercando non \xe8 disponibile.","navbar-mission":"Missione","navbar-download":"Scarica","footer-follow":"Seguici","footer-follow-1":"Instagram","footer-follow-2":"TikTok","footer-follow-3":"Twitter","footer-follow-4":"LinkdIn","footer-docs":"Documenti","footer-docs-1":"Missione","footer-docs-2":"Avviso legale","footer-docs-3":"Privacy","footer-docs-4":"Cookie","footer-docs-5":"Linee guida","footer-contact":"Contattaci","footer-contact-1":"Supporto","footer-contact-2":"Lavora con noi","footer-contact-3":"Investitori","home-title":"Crush - Dove i media incontrano il platonico","home-hero-slogan-1":"Where media","home-hero-slogan-2":"meets platonic \u2122","home-concept-1":"Trova la tua gente","home-concept-2":"Connetti con persone come te nelle diverse fasi della tua vita.","home-concept-3":"Vibes cool","home-concept-4":"Condividi buone vibrazioni e momenti reali. Niente tossicit\xe0 o pretenziosit\xe0.","home-attributes-1":"Aesthetic","home-attributes-2":"Promuoviamo la pubblicazione di contenuti aesthetic e di alta qualit\xe0; il web \xe8 gi\xe0 invaso da foto di gatti.","home-attributes-3":"Stalker","home-attributes-4":"I tuoi amici sono le star. Scatta alcune raffiche di foto quando sono impreparati e pubblica alcuni GIF sui loro account.","home-attributes-5":"Thread","home-attributes-6":"Partecipa a discussioni vivaci che spaziano dagli argomenti pi\xf9 attuali alle tendenze che plasmeranno il domani.","home-attributes-7":"Gemelli","home-attributes-8":"Connetti con individui che condividono tratti del viso simili ai tuoi, ampliando la tua rete sociale in modo completamente nuovo e divertente.","home-attributes-9":"Segmentazione per et\xe0","home-attributes-10":"Raggruppando gli utenti per et\xe0, simile alle classi superiori, le connessioni sono limitate agli individui della stessa generazione per un\'interazione pi\xf9 sicura ed efficiente.","home-attributes-11":"Crush","home-attributes-12":"Non \xe8 un\'app di incontri \u2014 solo amici e relazioni rilassate. Rivivi la nostalgia dei legami delle superiori in un ambiente digitale.","home-partners":"Powered By","mission-title":"Crush - Missione","mission-date":"Ultimo modifica: 8 dicembre, 2023","mission-header":"Missione e valori","mission-introduction":"Nel cuore di Crush batte qualcosa di pi\xf9 di una semplice rete sociale; \xe8 un universo intessuto di valori etici, una filosofia e uno scopo. Questo documento \xe8 il viaggio attraverso i fondamenti della nostra visione, dalla nascita dell\'idea all\'outline meticoloso della creazione che stiamo plasmando.","mission-origin":"L\'origine","mission-origin-1":"L\'origine di Crush risale a un seme piantato molto prima del suo sviluppo concreto nel 2020 e del suo lancio nel 2023. La nostra visione di fondere i social network con il tocco distintivo di Crush \xe8 stata concepita nel 2016, ispirata da \'The Social Network\', il notevole lavoro cinematografico riconosciuto da Quentin Tarantino come un gioiello dell\'ultima decade. Questo film, che racconta la storia dei giovani fondatori di Facebook, in particolare la figura pi\xf9 riconosciuta, Mark Zuckerberg \u2014 il padre dei social network, ci ha fornito una prospettiva illuminante.","mission-origin-2":"Da Crush, crediamo fermamente che il nucleo dei social network odierni risieda nell\'amore platonico. Se hai avuto l\'opportunit\xe0 di vedere questo film, potresti aver colto le critiche di Zuckerberg e Eduardo Saverin nei confronti delle app di appuntamenti. In una scena chiave, intorno al minuto 30:00, durante la causa dei fratelli Winklevoss per presunto furto di idee, Saverin menziona:","mission-origin-3":"\\"It really hadn\'t much to do with the Winklevoss\' dating site\\".","mission-origin-4":"\xc8 curioso perch\xe9 alcuni minuti dopo, intorno al minuto 36:05, vediamo Mark implementare elementi come lo stato della relazione e gli interessi nel suo progetto:","mission-origin-5":"\\"Relationship status, interests... This is what drives life in college. Are you having sex or aren\'t you? That\'s why people take classes, sit where they sit, and do what they do. It\'s the center, you know? That\'s what The Facebook is going to be.\\".","mission-origin-6":"Infine, nell\'ultima scena, assistiamo a un Zuckerberg innamorato che invia una richiesta di amicizia alla sua crush.","mission-origin-7":"Questo film pone una domanda intrigante:","mission-origin-8":"I social media sono in realt\xe0 app di appuntamenti mascherate?","mission-purpose":"Il nostro scopo","mission-purpose-1":"Non esiste una risposta definitiva alla domanda posta nella sezione precedente. Forse s\xec, forse no... alla fine, dipende dai valori etici e culturali, dalle intenzioni e dall\'educazione dell\'utente finale. Quello che sappiamo con certezza \xe8 che questo apre la porta a problemi reali e molto seri che, a differenza del mondo reale, possono essere effettivamente risolti.","mission-purpose-2":"Che sia per gli standard predefiniti dalla societ\xe0 o per l\'anonimato che porta a comportamenti inappropriati online, l\'amore nel mondo digitale, che sia platonico e genuino sui social media o pi\xf9 romantico sulle app di incontri, \xe8 stato sfortunatamente sessualizzato negli ultimi anni. Perch\xe9 qualcosa di cos\xec bello e fondamentale nella nostra vita sta venendo distorto in questo universo parallelo?","mission-purpose-3":"Cerchiamo di essere chiari e completamente trasparenti. In Spagna, il nostro paese d\'origine, secondo dati e statistiche verificabili,","mission-purpose-4":"7 ragazzi su 10 sotto i 15 anni possiedono un dispositivo mobile.","mission-purpose-5":"Ci\xf2 significa che circa il 70% dei minori ha accesso illimitato a un mondo virtuale in cui l\'interazione con adulti non \xe8 stata regolamentata o limitata, esponendoli a rischi come molestie, bullismo o pedofilia, tra gli altri.","mission-purpose-6":"Attualmente, indipendentemente dalla piattaforma di social network a cui ti iscrivi, \xe8 comune trovare persone che vendono contenuti inappropriati o condividono qualsiasi tipo di contenuto non adatto. Pi\xf9 passa il tempo, pi\xf9 la situazione diventa disgustosa.","mission-purpose-7":"Il nostro obiettivo \xe8 eliminare la sessualizzazione e la tossicit\xe0 della rete affrontandone direttamente l\'origine.","mission-purpose-8":"Crush si propone come una ridefinizione dei social network da una prospettiva diversa, concentrata sulle relazioni platoniche.","mission-purpose-9":"Non offriamo un sistema di incontri o la creazione di relazioni romantiche/serie, poich\xe9 ci\xf2 contraddice le","mission-purpose-10":"linee guida della nostra comunit\xe0.","mission-purpose-11":"Invece, offriamo ci\xf2 che \xe8 stato immaginato nel film \'The Social Network\', ma con una soluzione al problema e un approccio pi\xf9 cool.","mission-purpose-12":"La nostra missione va oltre il tipico \\"condividi momenti reali\\" o \\"ti aiutiamo a connetterti\\". Oltre ad accompagnare l\'utente attraverso le varie fasi della sua vita, ci dedichiamo a risolvere i problemi menzionati in precedenza. Sulla nostra piattaforma, al momento della stesura di questo documento, \xe8 gi\xe0 impossibile per un minore interagire con un adulto (e viceversa), non solo per chiudere le porte a queste questioni etiche, ma anche per incoraggiare la creazione di legami tra persone della stessa generazione, con una mentalit\xe0 simile. Prevediamo di introdurre soluzioni pi\xf9 efficaci nella prossima decade di sviluppo; questa \xe8 la nostra promessa.","guidelines-title":"Crush - Linee guida","guidelines-date":"Ultimo modifica: 4 aprile, 2024","guidelines-header":"Linee guida","guidelines-introduction-1":"In Crush, si tratta di stabilire connessioni platoniche, condividere momenti autentici della vita con gli amici, socializzare e creare nuove amicizie che si allineano al tuo modo di pensare. Crediamo fortemente nella libert\xe0 di espressione, ma valorizziamo anche la capacit\xe0 di distinguere tra giusto e sbagliato. Questo documento delinea gli standard del nostro social network, essenziali per realizzare il","guidelines-introduction-2":"nostro scopo principale.","guidelines-introduction-3":"Attendiamo un comportamento appropriato, contenuti accurati, autenticit\xe0, umilt\xe0 e, soprattutto, responsabilit\xe0. Qualsiasi violazione dei nostri principi fondamentali potrebbe comportare la sospensione permanente del tuo account, senza possibilit\xe0 di ri-registrarti nel nostro sistema.","guidelines-introduction-4":"Proprio come nella vita reale, ci sono conseguenze per le azioni. Si prega di rispettare le nostre regole e di non utilizzare il nostro sistema in modi contrari alla legge. Vogliamo sottolineare la nostra seriet\xe0 e rigore; un tono giocoso non \xe8 gradito in questo contesto.","guidelines-dating":"Anti-appuntamenti","guidelines-dating-1":"Crush \xe8 una combinazione di social media adatta a tutte le persone","guidelines-dating-2":"di et\xe0 superiore ai 15 anni,","guidelines-dating-3":"che siano o meno in una relazione romantica. Non confondere amicizie e relazioni platoniche (opzionali) con relazioni romantiche o impegni reali.","guidelines-dating-4":"Di seguito, ti elenchiamo una serie di comportamenti che devi adottare e rispettare per rimanere sulla nostra piattaforma:","guidelines-dating-5":"Non utilizzare il nostro servizio per cercare o richiedere incontri romantici.","guidelines-dating-6":"Se l\'amore deve entrare nella tua vita, che non sia attraverso uno schermo.","guidelines-dating-7":"Non pubblicare cose sporche.","guidelines-dating-8":"Non molestare o infastidire nessun utente.","guidelines-dating-9":"Non mentire sulla tua et\xe0 o informazioni personali, e tanto meno assumere l\'identit\xe0 di un\'altra persona.","guidelines-dating-10":"\xc8 un crimine molto grave che potrebbe comportare azioni legali contro di te.","guidelines-content":"Aesthetic","guidelines-content-1":"Per noi, ogni forma di software \xe8 arte e l\'arte va rispettata. In un social network, la qualit\xe0 della piattaforma si riflette nei contenuti che gli utenti generano. Nel nostro caso, incoraggiamo la creativit\xe0 e l\'ispirazione. Ti chiediamo di pubblicare mantenendo uno standard minimo di qualit\xe0.","guidelines-content-2":"Non pubblicare contenuti visivamente scadenti.","guidelines-content-3":"Fai uno sforzo.","guidelines-content-4":"Lo spam viene rimosso immediatamente.","guidelines-content-5":"Se vuoi promuovere il tuo Instagram, usa gli strumenti che ti forniamo.","guidelines-content-6":"Non condividere contenuti che violano la propriet\xe0 intellettuale altrui.","guidelines-content-7":"Per favore, evita di pubblicare foto di gattini;","guidelines-content-8":"ce ne sono gi\xe0 molte in rete.","guidelines-content-9":"Non fare la figura del ridicolo pubblicando nudit\xe0 non necessarie.","guidelines-content-10":"Siamo stufi delle foto senza maglietta.","guidelines-vibes":"Solo buone vibrazioni","guidelines-vibes-1":"In Crush, non tolleriamo comportamenti inappropriati. Proprio come curi la tua immagine nella vita reale, ti chiediamo di essere responsabile e mantenere questa integrit\xe0 online. Mostra cortesia e rispetto sia verso gli utenti della nostra comunit\xe0 che verso i creatori della piattaforma.","guidelines-vibes-2":"Lo sfruttamento dei minori, la sextorsione o qualsiasi altro tipo di abuso, in qualsiasi forma, sono severamente vietati.","guidelines-vibes-3":"Il nostro impegno contro il suicidio e l\'autolesionismo \xe8 assoluto.","guidelines-vibes-4":"Qualsiasi contenuto che promuova, incoraggi o glorifichi queste azioni comporter\xe0 una sospensione permanente.","guidelines-vibes-5":"Prestiamo grande attenzione alla legalit\xe0.","guidelines-vibes-6":"Evita di condividere contenuti che promuovono attivit\xe0 illegali, cos\xec come qualsiasi contenuto relativo a armi o droghe.","guidelines-vibes-7":"Contenuti offensivi o violenti non hanno posto sulla nostra piattaforma e non sono permessi.","guidelines-vibes-8":"La modalit\xe0 Stalker \xe8 pensata per divertirsi tra amici.","guidelines-vibes-9":"Tuttavia, anche se alla fine il contenuto richiede l\'approvazione dell\'utente (o degli utenti) nel GIF, evita di condividere foto dei tuoi amici senza il loro consenso preventivo.","legal-title":"Crush - Avviso legale","legal-date":"Ultimo modifica: 4 aprile, 2024","legal-header":"Avviso legale","legal-introduction-1":"Ogni applicazione \xe8 un universo, e tutti gli universi sono soggetti a regole. In questo documento, troverai l\'avviso legale e i termini generali d\'uso della nostra piattaforma, che sono integrati da quelli definiti nelle nostre","legal-introduction-2":"linee guida della community.","legal-owner":"1. Identificazione del titolare","legal-owner-1":"Il sito web www.crushsocialnetwork.com (in pio, il","legal-owner-2":"\'Sito Web\'","legal-owner-3":") l\'applicazione mobile per smartphone denominata \'Crush\' (in poi, la","legal-owner-4":"\'App\'","legal-owner-5":") sono di propiet\xe0 di CRUSH SOCIAL NETWORK, S.R.L., fornito con NIF: B-72599830 e iscritta al Registro Mercantile di Valencia con i seguenti dati anagrafici: T. 3606, F.75, I.1, H. MU-108656, e i cui dati di contatto sono:","legal-owner-6":"Sede legale:","legal-owner-7":"Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Spagna)","legal-owner-8":"E-mail di contatto:","legal-area":"2. Campo di applicazione","legal-area-1":"Le presenti Condizioni Generali d\'Uso del Sito Web (in poi, las","legal-area-2":"\'Condizioni d\'uso\'","legal-area-3":") raccogliere i termini e le condizioni che regolano l\'accesso, la navigazione e l\'utilizzo del Sito Web e dell\'App.","legal-area-4":"In questo senso, l\'accesso, l\'uso e la navigazione attraverso il Sito Web e l\'App conferiscono la condizione di utente(s) (in poi, il","legal-area-5":"\'Utente\'","legal-area-6":"o gli","legal-area-7":"\'Utenti\'","legal-area-8":"), e implica l\'accettazione di ognuna delle presenti Condizioni d\'Uso. L\'Utente \xe8 pienamente consapevole che la mera navigazione del Sito Web o dell\'App implica l\'accettazione delle presenti Condizioni d\'Uso e, pertanto, se l\'Utente non \xe8 d\'accordo con esse, non deve utilizzare il Sito Web o questa App.","legal-area-9":"Il Sito Web e l\'App sono rivolti principalmente agli Utenti residenti in Spagna. Crush non garantisce che il Sito Web o l\'App siano conformi alle leggi di altri paesi, in tutto o in parte. Se l\'Utente risiede o ha il suo domicilio in un altro luogo e decide di accedere e/o navigare nel Sito Web o accedere o utilizzare l\'App, lo far\xe0 a proprio rischio e deve garantire che tale accesso, navigazione o utilizzo sia conforme alla legislazione locale a lui applicabile, non assumendo Crush alcuna responsabilit\xe0 che possa derivare da tale accesso o utilizzo.","legal-area-10":"Crush pu\xf2, in qualsiasi momento e senza preavviso, modificare le presenti Condizioni d\'Uso, che saranno pubblicate man mano che tali modifiche si verificano.","legal-conditions":"3. Condizioni di accesso e uso","legal-conditions-1":"L\'accesso al Sito Web o all\'App da parte dell\'Utente, di norma, \xe8 gratuito. Nel caso in cui vi siano funzionalit\xe0 o servizi riservati a determinati Utenti o che sia necessario pagare un prezzo, questi saranno debitamente identificati nel Sito Web o nel App.","legal-conditions-2":"L\'accesso al Sito Web o all\'App avviene sotto la sola responsabilit\xe0 dell\'Utente e non implica alcun tipo di rapporto commerciale tra Crush e l\'Utente. L\'Utente \xe8 responsabile di garantire che le informazioni e i contenuti inclusi nel Sito Web o nell\'App siano conformi ai propri requisiti specifici.","legal-conditions-3":"L\'Utente si impegna a:","legal-conditions-4":"Accedere e utilizzare sia il Sito Web che l\'App in conformit\xe0 con buona fede e in conformit\xe0 con le presenti Condizioni d\'Uso, la legge, la morale e l\'ordine pubblico, con il prerequisito aggiuntivo di raggiungere un\'et\xe0 minima di 15 anni.","legal-conditions-5":"Presso Crush, certifichiamo di rispettare la legislazione applicabile sulla sicurezza dei minori e prendiamo seriamente il materiale di abuso sessuale sui minori. Adottiamo misure adeguate, come la rimozione di tale materiale una volta venuti a conoscenza effettiva della sua esistenza, in conformit\xe0 ai nostri standard e alle leggi pertinenti.","legal-conditions-6":"Fornire informazioni veritiere, aggiornate e lecite nei moduli offerti sia sul Sito Web che nell\'App. In ogni caso, l\'Utente comunicher\xe0 immediatamente a Crush qualsiasi fatto che consenta l\'uso improprio delle informazioni registrate in detti moduli, quali, ma non solo, furto, smarrimento o accesso non autorizzato a identificativi e/o password, al fine di procedere alla sua immediata cancellazione.","legal-conditions-7":"Non intraprendere alcuna azione sul Sito Web o sull\'App che possa causare danni o alterazioni ai contenuti, ai programmi o ai sistemi del Sito Web o dell\'App, inclusa l\'introduzione di virus informatici, l\'installazione di robot o qualsiasi software o file dannoso e difettoso, o in definitiva che possa causare danni ai nostri sistemi informatici.","legal-conditions-8":"L\'Utente sar\xe0 responsabile in ogni caso dei danni che potrebbero essere causati sia a Crush che a terzi e Crush potr\xe0 adottare le misure tecniche, legali e qualsiasi altra misura che ritenga appropriata per prevenire, mitigare o fermare le conseguenze dei precedenti comportamenti vietati e per esigere tutte le responsabilit\xe0 ritenute opportune.","legal-property":"4. Propriet\xe0 intellettuale e industriale","legal-property-1":"Tutti i contenuti sia del Sito Web che dell\'App, inclusi, a titolo esemplificativo, testi, immagini, fotografie, video, grafica, segni distintivi di qualsiasi tipo, icone, interfacce, nonch\xe9 il software, il codice sorgente, i disegni, l\'architettura, presentazione, disposizione e classificazione dei contenuti e di ogni altro elemento presente nel Sito o nell\'App che possa essere oggetto di diritti di propriet\xe0 intellettuale sono di propriet\xe0 esclusiva di Crush o di terzi che ne hanno concesso in licenza, autorizzato o acconsentito al loro utilizzo sul Sito Web o nell\'App.","legal-property-2":"In questo senso, quando l\'Utente accede, naviga e utilizza il Sito Web o accede o utilizza l\'App, non vengono concessi diritti di sfruttamento che esistano o possano esistere su tutti o parte di questi, Crush si riserva tutti questi diritti. L\'Utente pu\xf2 solo visualizzare gli elementi del Sito Web e dell\'App e utilizzarli nella misura strettamente necessaria al loro corretto utilizzo. In particolare, \xe8 vietato utilizzare o vendere a fini commerciali qualsiasi materiale o contenuto presente sul Sito o sull\'App senza la preventiva autorizzazione di Crush.","legal-property-3":"Crush si riserva il diritto di modificare, in qualsiasi momento e senza preavviso, la presentazione e la configurazione del Sito Web o dell\'App e i contenuti e i servizi che possono essere incorporati in essi L\'Utente riconosce e accetta che in qualsiasi momento Crush possa interrompere, disattivare e/o cancellare uno qualsiasi di questi elementi integrati nel Sito Web e nell\'App o l\'accesso ad essi.","legal-property-4":"Se l\'Utente ritiene che uno qualsiasi dei contenuti del Sito Web o dell\'App costituisca una violazione dei diritti di protezione della propriet\xe0 intellettuale, deve informare immediatamente Crush tramite le informazioni di contatto nella sezione 1 (Identificazione del Titolare) delle presenti Condizioni d\'Uso.","legal-disclaimer":"5. Esclusione di garanzie e responsabilit\xe0","legal-disclaimer-1":"Le informazioni pubblicate sul Sito Web o sull\'App potrebbero non essere esaustive o non completamente aggiornate, pertanto Crush non si assume alcuna responsabilit\xe0 derivante dalla mancanza di integrit\xe0, aggiornamento o accuratezza dei dati e delle informazioni contenute nelle diverse pagine che fanno parte del Sito Web o dell\'App.","legal-disclaimer-2":"Crush non garantisce che l\'accesso all\'App o al Sito Web sar\xe0 ininterrotto o privo di errori. Allo stesso modo, Crush non garantisce che il contenuto o il software presente sul Sito Web o sull\'App non causer\xe0 danni al sistema informatico dell\'Utente (software e hardware). Crush non sar\xe0 responsabile per perdite, danni o perdite di qualsiasi tipo derivanti dall\'accesso, dalla navigazione e dall\'uso del Sito Web o dell\'App, inclusi, a titolo esemplificativo ma non esaustivo, quelli causati ai sistemi informatici o quelli causati dall\'introduzione di virus.","legal-disclaimer-3":"Crush, parimenti, \xe8 esonerata da ogni responsabilit\xe0 derivante dall\'uso inappropriato del Sito o dell\'App da parte dell\'Utente.","legal-links":"6. Link","legal-links-1":"Si segnala che sia il Sito Web che l\'App possono trovare, tra gli altri, link, banner, pulsanti, directory e motori di ricerca che consentono agli Utenti di accedere ad altri siti web o app appartenenti a e/o gestiti da terzi e che, pertanto, sono al di fuori del controllo di Crush, che non pu\xf2 assumersi responsabilit\xe0 per il contenuto che appare su dette pagine o app.","legal-links-2":"Nel caso in cui ritieni che tali contenuti siano inappropriati o contrari agli scopi di Crush, ti preghiamo di informarci attraverso i mezzi di contatto sopra indicati, in modo che possiamo intraprendere le azioni appropriate.","legal-jurisdiction":"7. Legge applicabile e giurisdizione","legal-jurisdiction-1":"Le presenti Condizioni d\'Uso e la loro esecuzione sono soggette alla legge spagnola.","legal-jurisdiction-2":"In caso di controversie sull\'interpretazione o l\'applicazione delle presenti Condizioni d\'Uso, le Parti negozieranno in buona fede per tentare di risolvere tale discrepanza o reclamo. Tuttavia, nel caso in cui la discrepanza o il reclamo non venga risolto, le Parti si sottoporranno alle corti o ai tribunali che corrispondono secondo la legge.","privacy-title":"Crush - Privacy","privacy-date":"Ultimo modifica: 8 dicembre, 2023","privacy-header":"Politica sulla riservatezza","privacy-introduction-1":"Presso Crush, ci impegniamo a garantire che i tuoi dati personali siano protetti e non vengano utilizzati per scopi diversi da quelli indicati nella presente Informativa sulla privacy. Per questo motivo, in questa sezione informiamo gli utenti e gli interessati di tutto ci\xf2 che riguarda il trattamento dei loro dati personali, rispettando cos\xec le norme sulla protezione dei dati applicabili nel nostro paese: Regolamento Generale sulla Protezione dei Dati (UE) 2016/679, del 27 aprile relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali, nonch\xe9 alla libera circolazione di tali dati (di seguito,","privacy-introduction-2":"\'RGPD\'","privacy-introduction-3":") e Legge Organica 3/2018, del 5 dicembre, Protezione dei Dati Personali e garanzia dei diritti digitali (in poi,","privacy-introduction-4":"\'LOPDGDD\'","privacy-introduction-5":"La presente politica sulla riservatezza \xe8 applicabile al trattamento dei dati che CRUSH SOCIAL NETWORK, S.R.L., effettuato sia attraverso il sito web: www.crushsocialnetwork.com (in poi, il \'Sito Web\'), sia attraverso l\'applicazione mobile per Smartphone denominata \'Crush\' (di seguito, la \'App\') e/o quelle indicate. Ti consigliamo di leggerlo attentamente prima di utilizzare il Sito Web o l\'App e di fornire i tuoi dati attraverso di essi. Non esitate a farci qualsiasi domanda al riguardo via e-mail:","privacy-index":"Indice dei contenuti","privacy-index-1":"In questa Policy troverai tutte le informazioni relative al trattamento dei tuoi dati personali e i diritti che puoi esercitare per mantenere il controllo su di essi. In questo senso, troverai informazioni su:","privacy-index-2":"Chi \xe8 responsabile del trattamento dei tuoi dati.","privacy-index-3":"Quali requisiti devi soddisfare per fornirci i tuoi dati personali.","privacy-index-4":"Quali trattamenti di dati effettuiamo attraverso l\'App e quali sono le sue principali caratteristiche, spiegando:","privacy-index-5":"Quali dati raccogliamo e quali sono le modalit\xe0 per raccoglierli.","privacy-index-6":"Per quali finalit\xe0 raccogliamo i dati richiesti.","privacy-index-7":"Qual \xe8 la legittimit\xe0 del suo trattamento.","privacy-index-8":"Quanto li conserviamo?","privacy-index-9":"A quali destinatari vengono comunicati i tuoi dati.","privacy-index-10":"Esistenza di trasferimenti internazionali dei tuoi dati.","privacy-index-11":"Quali sono i tuoi diritti e come puoi esercitarli?","privacy-index-12":"Come proteggiamo le tue informazioni personali.","privacy-index-13":"Modifiche a questa politica.","privacy-controller":"1. Chi \xe8 responsabile del trattamento dei tuoi dati personali?","privacy-controller-1":"I tuoi dati personali saranno trattati dalla societ\xe0 CRUSH SOCIAL NETWORK, S.R.L. (","privacy-controller-2":"\'CRUSH\'","privacy-controller-3":"), con NIF B-72599830 e i cui recapiti sono i seguenti:","privacy-controller-4":"Indirizzo:","privacy-controller-5":"Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Spagna)","privacy-controller-6":"Contatto email:","privacy-dpo":"1.1 Il nostro responsabile della protezione dei dati","privacy-dpo-1":"Da CRUSH, mettiamo a tua disposizione i dettagli di contatto del nostro responsabile della protezione dei dati, al quale puoi rivolgere qualsiasi domanda tu possa avere in relazione alla presente Informativa sulla privacy o al trattamento dei tuoi dati personali.","privacy-dpo-2":"E-mail","privacy-requirements":"2. Quali requisiti devi soddisfare per fornirci i tuoi dati personali?","privacy-requirements-1":"2.1. Et\xe0 minima. Per fornirci i tuoi dati personali e utilizzare il nostro Sito Web e la nostra App, devi avere pi\xf9 di 15 anni.","privacy-requirements-2":"2.2. Veracit\xe0. Quando ci fornisci i tuoi dati per utilizzare i nostri servizi, garantisci che i dati e le informazioni fornite sono reali, veritiere, aggiornate e appartengono anche a te e non a terzi.","privacy-requirements-3":"Inoltre, \xe8 necessario che ci comunichiate qualsiasi cambiamento intervenga nei dati forniti, rispondendo in ogni caso della veridicit\xe0 e dell\'esattezza dei dati forniti in ogni momento.","privacy-requirements-4":"2.3. Controllo dell\'et\xe0 e della veridicit\xe0. Da CRUSH ci riserviamo il diritto di verificare la tua et\xe0 e le informazioni identificative, se necessario, anche richiedendo un documento ufficiale o una procedura equivalente e, in caso di rilevamento di frode verificata o sospetta che tu abbia meno dell\'et\xe0 indicata, di eliminare, temporaneamente disattivare e/o cancellare il tuo account.","privacy-processing":"3. Quali trattamenti di dati effettuiamo attraverso il Sito Web e l\'App e quali sono le sue principali caratteristiche?","privacy-processing-1":"Di seguito, ti spieghiamo come trattiamo i tuoi dati personali e ti forniamo, nel dettaglio, tutte le informazioni rilevanti in merito alla tua privacy:","privacy-contact":"3.1. Quando ci contatti attraverso i nostri canali (modulo di contatto, chat, email)","privacy-contact-1":"Quali sono le modalit\xe0 di raccolta dei dati?","privacy-contact-2":"Modulo di Contatto.","privacy-contact-3":"Chat.","privacy-contact-4":"Invio di email a","privacy-contact-5":"o altri indirizzi e-mail CRUSH.","privacy-contact-6":"Quali dati raccogliamo?","privacy-contact-7":"Identificazione e informazioni di contatto.","privacy-contact-8":"Raccogliamo i tuoi dati identificativi (nome e cognome) e indirizzo email, nonch\xe9 ogni altra informazione che includi volontariamente nelle comunicazioni che ci invii.","privacy-contact-9":"Potremmo richiederti ulteriori informazioni se necessario per soddisfare la tua richiesta o esigenza.","privacy-contact-10":"Quali sono le finalit\xe0 del trattamento dei tuoi dati personali?","privacy-contact-11":"Rispondi alle tue richieste.","privacy-contact-12":"Lo scopo principale del trattamento di questi dati sar\xe0 rispondere alle tue richieste, rispondere alle tue domande e/o fornirti le informazioni richieste, nonch\xe9, se del caso, dare seguito alle tue richieste.","privacy-contact-13":"Migliora il servizio clienti.","privacy-contact-14":"Tutte le informazioni derivate da dubbi, domande e consigli offerti alle parti interessate, nonch\xe9 il modo in cui le richieste vengono risolte, ci consentono di sapere come forniamo il nostro servizio clienti, consentendoci di migliorarne la qualit\xe0.","privacy-contact-15":"Allo stesso modo, tutte le informazioni raccolte, trascorso il periodo di conservazione sotto indicato, vengono rese anonime e utilizzate allo scopo di poter analizzare le domande pi\xf9 frequenti attraverso la chat e poter automatizzare quelle pi\xf9 frequenti, preparare FAQ o conservarle a fini statistici per lo sviluppo di strategie aziendali.","privacy-contact-16":"Qual \xe8 la base giuridica che ci consente di trattare i tuoi dati? Il conferimento di questi dati \xe8 obbligatorio?","privacy-contact-17":"Consenso.","privacy-contact-18":"I dati forniti per le finalit\xe0 di cui sopra saranno trattati sulla base del Suo consenso, concesso quando Lei volontariamente ci contatter\xe0 attraverso i mezzi messi a Sua disposizione per richiedere informazioni o effettuare una richiesta.","privacy-contact-19":"Tutte le informazioni raccolte dal servizio clienti saranno elaborate a fini statistici che ci aiuteranno a migliorare la qualit\xe0 del servizio clienti fornito. Tale finalit\xe0 \xe8 ritenuta compatibile con quella iniziale.","privacy-contact-20":"Le informazioni che dovrai fornire saranno indicate con un asterisco o simili. Senza queste informazioni non sarebbe possibile rispondere alle vostre domande o richieste.","privacy-contact-21":"Per quanto tempo conserviamo le tue informazioni?","privacy-contact-22":"Tratteremo tutte le tue informazioni personali durante il tempo in cui le tue richieste vengono elaborate e, se necessario, per dar loro seguito. Trascorso tale periodo, CRUSH conserver\xe0, bloccate, tali informazioni durante i periodi previsti dalla normativa per far fronte ad eventuali responsabilit\xe0 e per dimostrare il rispetto dei nostri obblighi. Da questo momento CRUSH tratter\xe0 le informazioni solo in forma anonima, quindi non sar\xe0 possibile collegare le informazioni statistiche con gli specifici utenti a cui si riferiscono.","privacy-contact-23":"A chi diamo i tuoi dati personali?","privacy-contact-24":"Non effettuiamo alcun trasferimento ulteriore per svolgere questo trattamento rispetto a quelli indicati, in generale, al punto","privacy-contact-25":"4. A chi forniamo i tuoi dati personali?","privacy-contact-26":"In tal senso, alcuni canali attraverso i quali puoi contattarci sono gestiti da fornitori di servizi, che agiscono in qualit\xe0 di Responsabili del trattamento. Troverai maggiori informazioni su come agiscono questi fornitori di servizi al punto 4, menzionato sopra.","privacy-app-use":"3.2. Quando ti registri e utilizzi la nostra App \'Crush\'","privacy-app-use-1":"Quali sono le modalit\xe0 di raccolta dei dati?","privacy-app-use-2":"Modulo di registrazione nella nostra App e utilizzo dei suoi diversi spazi.","privacy-app-use-3":"Quali dati raccogliamo?","privacy-app-use-4":"Dati di base per la registrazione:","privacy-app-use-5":"Per registrarti nella nostra App e utilizzare i servizi, dovrai registrarti nella nostra App e creare un","privacy-app-use-6":"\'profilo\'.","privacy-app-use-7":"Durante il processo di registrazione ti richiediamo, come utente, i seguenti dati:","privacy-app-use-8":"Nome utente.","privacy-app-use-9":"Nome.","privacy-app-use-10":"E-mail.","privacy-app-use-11":"Data di nascita.","privacy-app-use-12":"Dati aggiuntivi:","privacy-app-use-13":"Oltre a quanto sopra, la nostra App ti consente di condividere volontariamente informazioni relative a:","privacy-app-use-14":"Genere.","privacy-app-use-15":"Orientamento sessuale.","privacy-app-use-16":"Interessi.","privacy-app-use-17":"Paese, citt\xe0 o regione.","privacy-app-use-18":"Descrizione su di te.","privacy-app-use-19":"Professione e studi.","privacy-app-use-20":"Gusti musicali.","privacy-app-use-21":"Migliore amico.","privacy-app-use-22":"Se lo autorizzi, la tua precisa geolocalizzazione, che, se lo hai consentito, viene eseguita in background.","privacy-app-use-23":"Dati di utilizzo: possono essere raccolte informazioni sulle tue interazioni con altri utenti (chat con altri utenti, utenti con cui ti connetti e interagisci, tempo, frequenza di interazione o altre caratteristiche delle tue interazioni).","privacy-app-use-24":"Alcuni dei dati che puoi fornire volontariamente sono considerati sensibili, in quanto relativi al tuo orientamento sessuale. Tieni presente che, se decidi di includere tali informazioni, CRUSH le elaborer\xe0 insieme al resto delle informazioni per soddisfare le finalit\xe0 indicate di seguito. Allo stesso modo, queste informazioni possono essere condivise con il resto degli utenti (possono essere rese pubbliche), in modo che l\'uso non autorizzato dell\'App da parte di altri utenti possa causare la fuga di questi dati. CRUSH non \xe8 responsabile per l\'uso inappropriato dei dati da parte di altri utenti.","privacy-app-use-25":"Ti informiamo inoltre che CRUSH utilizza i dati sopra menzionati allo scopo di creare profili al fine di consigliarti contenuti che potrebbero interessarti e con le caratteristiche personali che includi su te stesso, come spiegato di seguito.","privacy-app-use-26":"Inoltre, se lo autorizzi, avremo accesso a:","privacy-app-use-27":"Fotocamera (immagini): la concessione dell\'autorizzazione alla fotocamera consente all\'utente di caricare qualsiasi immagine direttamente sull\'App.","privacy-app-use-28":"Galleria fotografica (immagini): la concessione dell\'accesso alla galleria fotografica consente all\'utente di caricare qualsiasi immagine dalla propria galleria fotografica.","privacy-app-use-29":"Microfono (audio): la concessione dell\'accesso al microfono consente all\'utente di utilizzare il registratore vocale del dispositivo direttamente dall\'App.","privacy-app-use-30":"Contenuto pubblicato da te:","privacy-app-use-31":"Utilizzando la nostra App, hai la possibilit\xe0 di interagire con altri utenti attraverso la nostra community, potendo caricare pubblicazioni con contenuti audiovisivi (foto, audio, ecc., se hai concesso i rispettivi permessi) e aggiungere commenti con le tue opinioni, chiedere domande e risolvere le preoccupazioni di altri utenti.","privacy-app-use-32":"Offriamo anche una modalit\xe0 \'Stalker\' emozionante, in cui i tuoi amici possono catturare GIF di te con il tuo consenso. Tuttavia, la responsabilit\xe0 di catturare e richiedere la pubblicazione di queste GIF sul tuo profilo \xe8 dell\'utente che avvia la richiesta. La GIF non verr\xe0 pubblicata sul tuo profilo finch\xe9 non avrai accettato la richiesta. Inoltre, tutti i collaboratori possono eliminare permanentemente la pubblicazione, sia cancellandola direttamente sia rifiutando la richiesta.","privacy-app-use-33":"CRUSH utilizza la tecnologia di riconoscimento facciale di Amazon Web Services per elaborare i dati biometrici degli utenti di CRUSH in qualit\xe0 di fornitore di servizi (\'Processore\'). Amazon pu\xf2 elaborare e archiviare modelli di volto allo scopo di fornire servizi di verifica e/o identificazione del volto per conto di CRUSH e solo secondo le istruzioni di CRUSH. Amazon memorizzer\xe0 questi dati fino a quando CRUSH lo richieder\xe0, che non sar\xe0 pi\xf9 lungo di un periodo di tolleranza limitato dopo la data in cui (i) CRUSH cesser\xe0 di avere un rapporto con Amazon o (ii) quando CRUSH richieder\xe0 l\'eliminazione.","privacy-app-use-34":"Nel caso in cui pubblichi post nell\'App (che \xe8 meramente facoltativo, non ti obblighiamo a farlo) verr\xe0 utilizzata la tecnologia di riconoscimento facciale di Amazon, che consente di rilevare volti e trovare utenti simili a te (gemelli) all\'interno del nostro sistema. Questo \xe8 l\'unico uso che facciamo di questa tecnologia di riconoscimento.","privacy-app-use-35":"Il nostro processore, Amazon, si impegna a garantire la propria conformit\xe0 al GDPR, nonch\xe9 a fornire una variet\xe0 di prodotti, funzionalit\xe0, documentazione e risorse per aiutare i propri clienti a soddisfare gli obblighi di conformit\xe0 previsti dal GDPR.","privacy-app-use-36":"Dati sull\'utilizzo dell\'App:","privacy-app-use-37":"Raccogliamo inoltre automaticamente dati sull\'utilizzo dell\'App, in particolare dati tecnici e informazioni relative al tuo utilizzo dell\'App, incluso il tipo di dispositivo mobile, l\'ID univoco del tuo dispositivo mobile, l\'indirizzo IP del tuo dispositivo mobile, il sistema operativo mobile, se qualsiasi, il tipo di browser Internet che utilizzi e le informazioni sul modo in cui utilizzi l\'App, come la frequenza e il tempo di utilizzo, gli annunci su cui hai fatto clic, ecc.","privacy-app-use-38":"Dati su di te forniti da terze parti:","privacy-app-use-39":"Altri utenti dell\'App possono fornirci informazioni su di te quando utilizzano i nostri servizi; ad esempio, quando interagiscono con te o se ci inviano una segnalazione che ti coinvolge.","privacy-app-use-40":"Quali sono le finalit\xe0 del trattamento dei tuoi dati personali?","privacy-app-use-41":"Registrati e gestisci il tuo account","privacy-app-use-42":"in modo che possiamo verificare il tuo indirizzo e-mail e l\'et\xe0 per registrarti all\'App, interagire con te e darti accesso ai nostri servizi.","privacy-app-use-43":"Gestire ed eseguire il rapporto contrattuale che ci unisce:","privacy-app-use-44":"svolgiamo diversi passaggi necessari all\'esecuzione del contratto sottoscritto con te, cos\xec che, ad esempio, possiamo fornirti il servizio, contattarti per aiutarti a risolvere dubbi, verificare le informazioni che ci hai fornito. Allo stesso modo, potremmo inviarti comunicazioni di natura amministrativa, su aggiornamenti, modifiche alle nostre condizioni di servizio, avvisi di sicurezza, nonch\xe9 rispondere a qualsiasi richiesta o esigenza che ci invii.","privacy-app-use-45":"Pubblica i tuoi contenuti.","privacy-app-use-46":"Quando condividi contenuti o informazioni tramite l\'App, questi appariranno pubblicati per il pubblico che hai selezionato che pu\xf2 vedere ci\xf2 che condividi. Per aggiungere determinati contenuti, come foto e video, dovrai fornirci l\'accesso alla tua fotocamera o alla tua galleria fotografica.","privacy-app-use-47":"Qualsiasi utente della nostra App pu\xf2 visualizzare il tuo nome utente e il tuo profilo pubblico sull\'App, che include i contenuti che hai condiviso con il pubblico in generale. Inoltre, tieni presente che i tuoi contenuti pubblicati nell\'App possono essere condivisi da altri utenti all\'interno o all\'esterno dell\'App, prendine uno screenshot o scaricalo.","privacy-app-use-48":"Pubblica contenuti su di te.","privacy-app-use-49":"Altri utenti dell\'App possono creare e condividere contenuti con la tua immagine o dati con un pubblico di tua scelta. Se non ti senti a tuo agio con i contenuti che altri hanno condiviso su di te, ti preghiamo di segnalarlo utilizzando i moduli dell\'App o di contattarci via e-mail.","privacy-app-use-50":"Offrirti contenuti (notizie, articoli, esperienze, tra gli altri)","privacy-app-use-51":"creato direttamente da CRUSH o in collaborazione con persone esterne che potrebbero interessarti.","privacy-app-use-52":"Invio di notifiche push e avvisi all\'interno dell\'App.","privacy-app-use-53":"Se hai aderito, riceverai notifiche push da noi nel tuo browser web o sul tuo dispositivo mobile. Le notifiche push possono includere promemoria, comunicazioni promozionali, avvisi e aggiornamenti sull\'App e sui Servizi.","privacy-app-use-54":"Se attivi queste notifiche, riceverai avvisi personalizzati, basati su un profilo che sviluppiamo su di te e sul tuo utilizzo dell\'App. Per la personalizzazione degli avvisi, le informazioni ottenute attraverso i dati da te inseriti nell\'App e i dati raccolti sull\'utilizzo dell\'App (contenuti visitati) per creare un profilo in relazione ai tuoi interessi e offrirti principalmente quei contenuti e informazioni che ti sta bene.","privacy-app-use-55":"Puoi disattivare le notifiche push in qualsiasi momento modificando le impostazioni sul tuo dispositivo mobile, sebbene la disattivazione non influir\xe0 su altre comunicazioni che potresti ricevere da CRUSH, come le comunicazioni e-mail.","privacy-app-use-56":"Prevenzione, rilevamento e perseguimento di attivit\xe0 illegali o contrarie alle condizioni di servizio o che mettono in pericolo la sicurezza delle informazioni o dell\'App:","privacy-app-use-57":"CRUSH pu\xf2 elaborare i dati per controllare e prevenire qualsiasi forma di abuso dei nostri servizi, come attivit\xe0 fraudolente, attacchi denial-of-service, invio di spam, accesso non autorizzato agli account dei nostri utenti, nonch\xe9 qualsiasi altra pratica contraria a le Condizioni Generali e l\'Uso dell\'App o metta in pericolo la sicurezza delle informazioni o l\'integrit\xe0 dell\'App stessa, potendo eliminare il contenuto o l\'account contrari alla legge, alle nostre Condizioni Generali o alle Linee Guida della Community.","privacy-app-use-58":"All\'interno di questa finalit\xe0 \xe8 inclusa anche l\'elaborazione dei reclami che presenti contro altri utenti o quelli che vengono presentati contro di te, con la possibilit\xe0 di contattare CRUSH per analizzare il caso specifico e garantire che ci sar\xe0 un intervento umano per correggere o rettificare il problema che ci sorge.","privacy-app-use-59":"Potremmo anche utilizzare strumenti per rilevare contenuti inappropriati (ad esempio contenuti per adulti o violenti) nei contenuti visivi che pubblichi.","privacy-app-use-60":"Per offrirti un servizio migliore, i tuoi dati saranno inoltre trattati allo scopo di:","privacy-app-use-61":"Aiutarti a connetterti con altri utenti, permettendoti di interagire con loro attraverso schermate di chat e altri meccanismi.","privacy-app-use-62":"Raccomandarti ad altri utenti simili a te.","privacy-app-use-63":"Per formulare raccomandazioni, utilizziamo le informazioni che ci fornisci, comprese le informazioni sulla tua posizione se dai il tuo permesso, nonch\xe9 le informazioni che otteniamo dal tuo utilizzo di questo spazio (ad esempio, le caratteristiche delle persone con cui interagisci effettivamente) per sviluppare un profilo automatizzato su di te e preferibilmente mostrarti quegli utenti che corrispondono al tuo profilo e a ci\xf2 che stai cercando.","privacy-app-use-64":"In tal senso, ti verranno mostrati preferibilmente gli utenti attivi nell\'App, che ti sono vicini, che corrispondono alle preferenze indicate e il tuo profilo creato dalle tue interazioni, assicurandoti altres\xec che le tue caratteristiche e il tuo profilo corrispondano alle preferenze degli utenti consigliati.","privacy-app-use-65":"Finalit\xe0 statistiche ed altre effettuate con dati anonimi.","privacy-app-use-66":"Potremmo rendere anonime tutte le informazioni personali raccolte dagli utenti che utilizzano l\'App per scopi statistici e di altro tipo, come la formazione di algoritmi, per misurare l\'efficacia delle campagne pubblicitarie disponibili sull\'App, la navigabilit\xe0 e l\'usabilit\xe0 dell\'App per poter migliorare la design, presentazione e funzionalit\xe0 disponibili o altro.","privacy-app-use-67":"Per mostrarti pubblicit\xe0:","privacy-app-use-68":"La nostra App pu\xf2 contenere pubblicit\xe0 che, previo tuo consenso, sar\xe0 personalizzata secondo i tuoi gusti e le tue preferenze.","privacy-app-use-69":"Qual \xe8 la base giuridica che ci consente di trattare i tuoi dati? Il conferimento di questi dati \xe8 obbligatorio?","privacy-app-use-70":"Eseguire e mantenere il rapporto contrattuale tra le Parti.","privacy-app-use-71":"Il motivo per cui elaboriamo le tue informazioni per gli scopi sopra menzionati \xe8 per adempiere al contratto che abbiamo con te.","privacy-app-use-72":"Consenso.","privacy-app-use-73":"Alcune funzionalit\xe0 si basano sul tuo espresso consenso: (i) pubblicazione dei tuoi contenuti, (ii) accesso alla fotocamera o alla galleria fotografica per pubblicare determinati contenuti nell\'App, (iii) accesso alla geolocalizzazione del dispositivo per la raccomandazione dell\'utente da parte di prossimit\xe0 (iv) ricezione di notifiche push personalizzate (v) visualizzazione di contenuti pubblicitari personalizzati. Inoltre, se decidi di fornirci ulteriori informazioni volontarie per completare il tuo profilo, tali informazioni verranno utilizzate in base al tuo consenso.","privacy-app-use-74":"Ricorda che puoi revocare il tuo consenso in qualsiasi momento attraverso le impostazioni del tuo dispositivo, cancellando i tuoi contenuti o attraverso le opzioni disponibili nell\'App.","privacy-app-use-75":"Interesse legittimo.","privacy-app-use-76":"I dati saranno trattati in base al nostro legittimo interesse in relazione alla prevenzione di attivit\xe0 illecite e altri connessi alla sicurezza dell\'App, a garantire la sicurezza della rete e delle informazioni per prevenire eventi che possano comprometterne la disponibilit\xe0, l\'autenticit\xe0, integrit\xe0 e riservatezza dei dati personali o della piattaforma stessa, nonch\xe9 rispetto degli standard comunitari.","privacy-app-use-77":"Potremmo anche mostrarti pubblicit\xe0 non personalizzata attraverso l\'App in base al nostro legittimo interesse.","privacy-app-use-78":"Se desideri ottenere maggiori informazioni sulla ponderazione che abbiamo effettuato sui legittimi interessi di CRUSH in relazione alle finalit\xe0 di cui sopra, puoi richiederle scrivendoci a","privacy-app-use-79":"Trattamento di dati particolarmente protetti.","privacy-app-use-80":"I dati relativi ai tuoi interessi o aspetti legati all\'orientamento sessuale saranno trattati sulla base del tuo esplicito consenso.","privacy-app-use-81":"Per quanto tempo conserviamo le tue informazioni?","privacy-app-use-82":"Conserveremo tutte le tue informazioni personali per tutto il tempo in cui il nostro rapporto contrattuale sar\xe0 in vigore, cio\xe8 fino a quando non eliminerai il tuo account. Una volta terminato il rapporto contrattuale o cancellato il tuo account, CRUSH conserver\xe0, bloccate, tutte le informazioni durante i periodi previsti dalla legge per indagare su comportamenti illegali o dannosi, far fronte a eventuali responsabilit\xe0 e dimostrare il rispetto dei nostri obblighi.","privacy-app-use-83":"In relazione ai contenuti da te pubblicati tramite la nostra App, devi tenere presente che qualsiasi pubblicazione o commento che hai pubblicato nella nostra community rimarr\xe0 nell\'App fino a quando non lo elimini o fino a quando non elimini il tuo account. Tuttavia, qualsiasi altro contenuto in cui appari e che \xe8 stato pubblicato da altri utenti (ad esempio foto o video) pu\xf2 rimanere visibile fino a quando tale utente non lo elimina o chiude il proprio account.","privacy-app-use-84":"Tuttavia, ci riserviamo il diritto di utilizzare le tue informazioni in forma aggregata dopo la chiusura del tuo account per fini statistici e per migliorare i nostri servizi. L\'utilizzo di tali informazioni non consentir\xe0 di essere identificati personalmente.","privacy-app-use-85":"A chi diamo i tuoi dati personali?","privacy-app-use-86":"Non sono previsti specifici trasferimenti dei tuoi dati personali per adempiere alla finalit\xe0 indicata in questa sezione. Tuttavia, possiamo utilizzare i servizi dei fornitori di servizi, che avranno un accesso limitato ai dati e saranno vincolati da un obbligo di riservatezza (per ulteriori informazioni su come agiscono i nostri fornitori di servizi, vedere il punto","privacy-app-use-87":"4. A chi forniamo i tuoi dati personali? > Fornitori di servizi","privacy-app-use-88":"Tuttavia, tieni presente che quando pubblichi contenuti sulla nostra App, potresti condividere informazioni personali con altri utenti (incluso il tuo profilo pubblico).","privacy-app-use-89":"Inoltre, se qualcuno presenta una segnalazione che ti coinvolge, potremmo informare il denunciante delle azioni che abbiamo intrapreso a seguito della sua segnalazione, se del caso.","privacy-cookies":"3.3. Navigazione sul Sito Web (cookie)","privacy-cookies-1":"Sul nostro Sito Web, cos\xec come nella nostra App, utilizziamo cookie o altri strumenti di tracciamento e tracciamento per raccogliere informazioni sull\'uso che gli utenti fanno del Sito Web e dell\'App.","privacy-cookies-2":"Per maggiori informazioni sul trattamento che svolgiamo tramite detti strumenti di tracciamento, visita la nostra","privacy-cookies-3":"Politica sui Cookie","privacy-social-profiles":"3.4. Profili CRUSH sui social network","privacy-social-profiles-1":"CRUSH ha un profilo sui principali social network, come Twitter, Instagram, LinkedIn o TikTok.","privacy-social-profiles-2":"Quando diventi un follower di una delle nostre pagine sui social network, il trattamento dei dati sar\xe0 regolato dalle condizioni d\'uso, dalle politiche sulla privacy e dai regolamenti di accesso che appartengono al social network corrispondente e precedentemente accettate dall\'utente.","privacy-social-profiles-3":"CRUSH, in tal senso, tratter\xe0 i tuoi dati allo scopo di gestire correttamente la sua presenza sul social network, informandoti di attivit\xe0, prodotti o servizi, nonch\xe9 per ogni altra finalit\xe0 che le normative dei social network consentono.","privacy-social-profiles-4":"Tieni presente che non abbiamo alcuna influenza sulle informazioni che il social network raccoglie o su come le elabora, quindi ti consigliamo di tenerti informato sullo scopo e sulla portata della raccolta di informazioni che viene effettuata attraverso detti social network.","privacy-transfer":"4. A chi forniamo i tuoi dati personali?","privacy-transfer-1":"In generale, da CRUSH non comunicheremo i tuoi dati a terzi. Tuttavia, oltre ai bonifici che indichiamo specificamente nella sezione in cui spieghiamo le caratteristiche delle diverse operazioni (punto 3), ti informiamo delle comunicazioni che, in generale, possiamo effettuare, nonch\xe9 del loro fondamento legittimante, che influenzano tutti i trattamenti precedenti.","privacy-transfer-2":"Fornitori di servizi essenziali","privacy-transfer-3":"per eseguire il servizio che ti offriamo, (ad esempio, societ\xe0 di hosting informatico o piattaforme per l\'invio di comunicazioni commerciali). Nonostante quanto sopra, queste entit\xe0 hanno firmato i corrispondenti accordi di riservatezza e tratteranno i tuoi dati solo secondo le nostre istruzioni, non potendo utilizzarli per i propri scopi o al di fuori del servizio che ci forniscono.","privacy-transfer-4":"Enti pubblici.","privacy-transfer-5":"Potremmo divulgare alle autorit\xe0 pubbliche competenti i dati e qualsiasi altra informazione in nostro possesso o accessibile attraverso i nostri sistemi quando vi \xe8 un obbligo legale in tal senso, nonch\xe9 quando richiesto, ad esempio, quando lo scopo \xe8 quello di prevenire o perseguire abusi di servizi o attivit\xe0 fraudolente attraverso il nostro Sito Web o App. In questi casi, i dati personali che ci fornisci saranno conservati e messi a disposizione delle autorit\xe0 amministrative o giudiziarie.","privacy-transfer-6":"In caso di operazione societaria:","privacy-transfer-7":"In caso di fusione, acquisizione, vendita di tutto o parte dei suoi beni o qualsiasi altro tipo di transazione aziendale che coinvolga una terza parte, potremmo condividere, divulgare o trasferire i dati dell\'utente all\'entit\xe0 successiva (anche durante il pre- fase operativa).","privacy-transfer-8":"A terzi previa aggregazione o anonimizzazione:","privacy-transfer-9":"potremmo divulgare o utilizzare dati aggregati o resi anonimi (ovvero dati che non sono collegabili a una persona fisica identificata o identificabile) per qualsiasi scopo.","privacy-transfer-10":"A terzi con il consenso dell\'utente o altra base legittima:","privacy-transfer-11":"Nel caso in cui desideriamo condividere i dati con terze parti al di fuori dell\'ambito della presente Informativa sulla privacy, verr\xe0 comunque richiesto il tuo consenso o sarai informato su di esso e sulla sua base legittima.","privacy-transfer-12":"Allo stesso modo, ti informiamo che la presente Informativa sulla privacy si riferisce solo alla raccolta, al trattamento e all\'utilizzo delle informazioni (relative ai dati personali) da parte nostra attraverso l\'interazione che effettui con il nostro Sito Web o App. L\'accesso a pagine Web di terze parti a cui \xe8 possibile accedere tramite collegamenti dal Sito Web o dall\'App dispone di proprie politiche sulla privacy sulle quali non abbiamo alcun controllo. Pertanto, prima di fornire loro qualsiasi informazione personale, ti consigliamo di informarti sulle loro politiche sulla privacy.","privacy-eea":"5. I tuoi dati personali vengono trasferiti in paesi terzi al di fuori dello Spazio Economico Europeo?","privacy-eea-1":"Alcuni dei nostri fornitori di servizi si trovano in paesi al di fuori dello Spazio economico europeo (","privacy-eea-2":"\'SEE\'","privacy-eea-3":"L\'ubicazione di queste societ\xe0 al di fuori del SEE implica l\'esistenza di un trasferimento internazionale dei tuoi dati personali, che potrebbe implicare un grado di protezione inferiore rispetto a quello previsto dalle normative europee. Tuttavia, da CRUSH abbiamo applicato misure affinch\xe9 tali trasferimenti non diano luogo a un grado inferiore di protezione dei dati personali.","privacy-eea-4":"In tal senso, i fornitori di servizi che sono al di fuori del SEE hanno sottoscritto le corrispondenti clausole contrattuali standard approvate dalla Commissione Europea (","privacy-eea-5":"\'CCT\'","privacy-eea-6":"), un accordo firmato tra i due enti con il quale la societ\xe0 extra UE garantisce di applicare gli standard europei di protezione dei dati.","privacy-eea-7":"Pertanto, l\'uso di questi fornitori non comporta un grado di protezione dei dati personali inferiore rispetto all\'uso di fornitori situati nell\'Unione Europea. \xc8 possibile consultare il contenuto del CCT al seguente link:","privacy-eea-8":"Successivamente, indichiamo quali sono i trasferimenti internazionali che effettuiamo da CRUSH:","privacy-eea-9":"Nome","privacy-eea-10":"Attivit\xe0 interessate","privacy-eea-11":"Paese","privacy-eea-12":"Meccanismo di trasferimento","privacy-eea-13":"Tutto","privacy-eea-14":"Rilevamento dei volti e ricerca di volti dall\'aspetto simile","privacy-eea-15":"Le notifiche push","privacy-eea-16":"Inviando e-mail","privacy-eea-usa":"Stati Uniti d\'America","privacy-eea-sccs":"Clausole contrattuali standard (SCC)","privacy-rights":"6. Quali sono i diritti che puoi esercitare in qualit\xe0 di interessato?","privacy-rights-1":"Puoi esercitare i diritti che la legge ti garantisce in relazione al trattamento dei tuoi dati personali contattando via mail il nostro Delegato alla Protezione dei Dati Personali","privacy-rights-2":"Qualsiasi richiesta di diritti che riceviamo sar\xe0 risolta nel pi\xf9 breve tempo possibile e, in ogni caso, entro il termine massimo stabilito dalla legge, dalla data di ricezione. In alcuni casi, sar\xe0 necessario richiedere una copia del proprio documento di identit\xe0 o altro documento di riconoscimento per verificare la propria identit\xe0.","privacy-rights-3":"I diritti che ti spettano in qualit\xe0 di interessato sono i seguenti:","privacy-rights-4":"Diritto di revocare il consenso concesso","privacy-rights-5":"Puoi revocare in qualsiasi momento il tuo consenso in relazione a tutti i trattamenti basati su di esso. Tuttavia, la revoca del consenso non pregiudicher\xe0 la liceit\xe0 del trattamento basata sul consenso prestato prima della revoca.","privacy-rights-6":"Diritto di accesso","privacy-rights-7":"Lei ha il diritto di conoscere, se del caso, quali dati vengono trattati e, in tal caso, di ottenerne copia, nonch\xe9 di ottenere informazioni in merito a:","privacy-rights-8":"l\'origine e i destinatari dei dati;","privacy-rights-9":"le finalit\xe0 per le quali sono trattati;","privacy-rights-10":"se esiste un processo decisionale automatizzato, compresa la profilazione;","privacy-rights-11":"il periodo di conservazione dei dati; e","privacy-rights-12":"i diritti previsti dalla normativa.","privacy-rights-13":"Diritto di rettifica","privacy-rights-14":"Hai il diritto di ottenere la rettifica dei tuoi dati personali o di completarli quando sono incompleti.","privacy-rights-15":"Diritto di cancellazione","privacy-rights-16":"Hai il diritto di richiedere la cancellazione dei tuoi dati personali se non sono pi\xf9 necessari per lo scopo per il quale sono stati raccolti o, se del caso, se non siamo pi\xf9 autorizzati a trattarli.","privacy-rights-17":"Diritto alla portabilit\xe0 dei dati","privacy-rights-18":"Hai il diritto di richiedere la portabilit\xe0 dei tuoi dati nel caso di trattamenti basati sul tuo consenso o sull\'esecuzione di un contratto, purch\xe9 il trattamento sia stato effettuato con mezzi automatizzati. In caso di esercizio di tale diritto, riceverai i tuoi dati personali in un formato strutturato, di uso comune e leggibile da qualsiasi dispositivo elettronico. Tuttavia, puoi anche richiedere, quando possibile, che i tuoi dati siano trasmessi direttamente ad un\'altra societ\xe0.","privacy-rights-19":"Diritto alla limitazione del trattamento dei dati personali","privacy-rights-20":"Hai il diritto di limitare il trattamento dei tuoi dati nei seguenti casi:","privacy-rights-21":"Quando hai richiesto la rettifica dei tuoi dati personali, durante il periodo in cui verifichiamo la loro accuratezza.","privacy-rights-22":"Quando consideri che non siamo autorizzati a trattare i tuoi dati. In tal caso, puoi chiederci di limitarne l\'uso invece di richiederne la cancellazione.","privacy-rights-23":"Quando ritieni che non sia pi\xf9 necessario per noi continuare a elaborare i tuoi dati e desideri che li conserviamo ai fini dell\'esercizio o della difesa dei reclami.","privacy-rights-24":"Nei casi in cui vi sia un trattamento basato sul nostro legittimo interesse e tu abbia esercitato il tuo diritto di opporti, puoi chiederci di limitare l\'utilizzo dei tuoi dati in sede di verifica della prevalenza di detti interessi rispetto ai tuoi.","privacy-rights-25":"Diritto di opposizione","privacy-rights-26":"Hai il diritto di opporti in qualsiasi momento al trattamento dei tuoi dati personali basato sul nostro legittimo interesse, compresa la profilazione.","privacy-rights-27":"Diritto di proporre reclamo a un\'Autorit\xe0 di Controllo","privacy-rights-28":"Ricorda che, in qualsiasi momento, e nel caso in cui ritieni che abbiamo violato il tuo diritto alla protezione dei tuoi dati, puoi rivolgere la tua difesa all\'autorit\xe0 di controllo corrispondente, nel caso della Spagna, l\'Agenzia spagnola per la protezione dei dati (","privacy-confidence":"7. Come garantiamo la riservatezza delle tue informazioni?","privacy-confidence-1":"La sicurezza dei tuoi dati personali \xe8 per noi una priorit\xe0. Per questo motivo, CRUSH ha implementato tutte le misure di sicurezza necessarie per garantire un uso e un trattamento effettivo dei dati personali forniti dall\'utente, salvaguardando l\'intimit\xe0, la privacy, la riservatezza e l\'integrit\xe0 degli stessi, e si avvale dei mezzi tecnici necessari per evitare l\'alterazione, perdita, accesso non autorizzato o trattamento dei tuoi dati, secondo lo stato della tecnologia in ogni momento.","privacy-confidence-2":"Di conseguenza, rispettiamo gli standard di sicurezza raccomandati per proteggerli. Tuttavia, \xe8 impossibile garantire completamente la tua sicurezza a causa della natura stessa di Internet e perch\xe9 potrebbero esserci azioni dannose da parte di terzi al di fuori del nostro controllo.","privacy-confidence-3":"Promettiamo di agire rapidamente e diligentemente nel caso in cui la sicurezza dei dati sia in pericolo o compromessa e di informarti in merito nel caso in cui sia rilevante.","privacy-modifications":"8. Modifiche a questa politica","privacy-modifications-1":"Da CRUSH possiamo modificare il contenuto della presente Informativa sulla privacy in qualsiasi momento, in particolare in caso di modifiche legislative, giurisprudenziali o interpretative dell\'Agenzia spagnola per la protezione dei dati che influiscano sul trattamento dei dati effettuato da CRUSH tramite il Sito Web o l\'App. Qualsiasi nuova versione della presente Informativa sulla privacy entrer\xe0 in vigore alla data di entrata in vigore pubblicata.","privacy-modifications-2":"Se la versione rivista include una modifica sostanziale che influisce sul trattamento dei tuoi dati, ti informeremo con almeno 30 giorni di anticipo pubblicando un avviso sul nostro Sito Web o sulla nostra App o inviandoti una notifica via e-mail. In ogni caso, ti consigliamo di rivedere periodicamente la presente Privacy Policy per essere informato su come vengono trattati e protetti i tuoi dati personali, nonch\xe9 sui tuoi diritti.","cookies-title":"Crush - Cookie","cookies-date":"Ultimo modifica: 8 dicembre, 2023","cookies-header":"Politica sui cookie","cookies-introduction-1":"Entrambi sul sito web www.crushsocialnetwork.com (in poi, il","cookies-introduction-2":"\'Sito Web\'","cookies-introduction-3":") nonch\xe9 attraverso l\'applicazione mobile per smartphone con il nome \'Crush\' (in poi, la","cookies-introduction-4":"\'App\'","cookies-introduction-5":") utilizziamo i cookie o altri strumenti di tracciamento e tracciamento per raccogliere informazioni sull\'uso che gli utenti fanno del Sito Web e dell\'App.","cookies-introduction-6":"In questo documento, scoprirai quali biscotti diamo al Cookie Monster, cos\xec come qualsiasi altra informazione correlata riguardante questo meraviglioso morso.","cookies-definition":"1. Cos\'\xe8 un cookie?","cookies-definition-1":"Un cookie \xe8 un file che viene installato nel browser del tuo terminale (computer, cellulare, ecc.) per memorizzare e recuperare dati. I cookie possono avere una moltitudine di scopi, a seconda di ci\xf2 per cui sono stati impostati: ad esempio, salvare le preferenze, raccogliere statistiche sull\'utilizzo, abilitare funzionalit\xe0 tecniche, tra gli altri.","cookies-responsible":"2. Chi \xe8 il responsabile?","cookies-responsible-1":"I cookie possono avere una moltitudine di scopi, a seconda di ci\xf2 per cui sono stati configurati: ad esempio, salvare le preferenze, raccogliere statistiche sull\'utilizzo, abilitare funzionalit\xe0 tecniche, tra gli altri. Il responsabile del trattamento delle informazioni raccolte attraverso i cookie \xe8 CRUSH SOCIAL NETWORK, S.R.L. (CRUSH), con NIF B-72599830 e indirizzo in Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Spagna).","cookies-responsible-2":"In caso di domande relative all\'uso dei cookie, scrivere una e-mail a","cookies-responsible-3":"e ti risponderemo il prima possibile.","cookies-data":"3. Quali dati vengono raccolti tramite i cookie?","cookies-data-1":"Quando accedi al Sito Web o installi e utilizzi l\'App, anche se non sei registrato, tramite i cookie vengono raccolte le seguenti informazioni:","cookies-data-2":"Informazioni sul dispositivo: durante l\'utilizzo del Sito Web o dell\'App, raccogliamo informazioni sul dispositivo mobile da cui accedi alla piattaforma. Le informazioni che raccogliamo sono il modello del dispositivo, il sistema operativo e la versione, l\'identificatore univoco del dispositivo e la rete.","cookies-data-3":"Informazioni sulla tua posizione: otteniamo anche l\'indirizzo IP, il fuso orario e l\'eventuale provider di servizi mobili, che ci consente di ottenere una posizione generale.","cookies-data-4":"Informazioni sulla navigazione dell\'utente: raccogliamo informazioni sull\'uso che fai del Sito Web e dell\'App. Nello specifico, la frequenza di utilizzo, le sezioni visitate, l\'utilizzo di specifiche funzioni, ecc.","cookies-types":"4. Quali tipi di cookie esistono?","cookies-types-1":"Secondo il loro scopo,","cookies-types-2":"possiamo classificare i cookie tra i seguenti:","cookies-types-3":"Cookie tecnici:","cookies-types-4":"Questi cookie sono strettamente necessari per navigare sul Sito Web o sull\'App e consentono funzioni di base come la navigazione da una sezione all\'altra. Si occupano di aspetti tecnici come l\'identificazione di profili o sessioni e la gestione delle preferenze dello strumento nell\'uso, nell\'interazione e nella posizione di accesso ai contenuti. Appartengono a questa categoria, per la loro natura tecnica, anche quei cookie che consentono la gestione, nel modo pi\xf9 efficiente possibile, degli spazi pubblicitari inseriti nel Sito Web e nell\'App, senza raccogliere informazioni dagli utenti per finalit\xe0 diverse, come ad esempio personalizzare annunci o altri tipi di contenuti.","cookies-types-5":"Cookie statistici:","cookies-types-6":"Questi cookie misurano e raccolgono informazioni statistiche sull\'uso che l\'utente fa del Sito Web o dell\'App, come il tempo trascorso sulla piattaforma, il numero di visite o i contenuti visitati. Tali informazioni ci consentono di capire come gli utenti interagiscono con il Sito Web e l\'App, valutare le performance, quali sezioni sono le pi\xf9 o meno visitate, compresa la quantificazione dell\'impatto delle inserzioni introdotte sul Sito Web e sull\'App (se applicabile). Avere queste informazioni pu\xf2 risolvere errori e migliorare il design del sistema e il contenuto offerto attraverso di esso.","cookies-types-7":"Cookie di preferenza o personalizzazione:","cookies-types-8":"I cookie di preferenza consentono al Sito Web o all\'App di ricordare informazioni specifiche dell\'utente in modo che possa accedere al servizio con determinate caratteristiche che possono differenziare la sua esperienza da quella di altri utenti. Ad esempio, la tua lingua preferita o la regione da cui accedi, il numero di risultati da visualizzare quando l\'utente effettua una ricerca, l\'aspetto o il contenuto del servizio a seconda del tipo di dispositivo da cui l\'utente accede, ecc.","cookies-types-9":"Cookie pubblicitari comportamentali:","cookies-types-10":"Questi cookie consentono la gestione degli spazi pubblicitari che, se del caso, sono stati inseriti nel Sito Web o nell\'App. Tuttavia, la gestione degli spazi pubblicitari avviene in base al profilo di navigazione dell\'utente. Questi cookie memorizzano le informazioni di navigazione dell\'utente ottenute attraverso l\'osservazione continua delle sue abitudini di navigazione, sviluppando un profilo utente specifico, in modo che gli annunci che compaiono in questi spazi saranno personalizzati per l\'utente in base a tali abitudini.","cookies-types-11":"A seconda dell\'ente che li gestisce:","cookies-types-12":"Cookies propri:","cookies-types-13":"sono quelli che vengono inviati al dispositivo dell\'utente da un computer o dominio gestito dal responsabile del Sito Web o dell\'App, in questo caso CRUSH, e dal quale viene erogato il servizio richiesto dall\'utente.","cookies-types-14":"Cookie di terze parti:","cookies-types-15":"sono quelli che vengono inviati al dispositivo dell\'utente da un computer o dominio non gestito dal responsabile del Sito Web o dell\'App, ma da un\'altra entit\xe0 che elabora i dati ottenuti tramite i cookie.","cookies-types-16":"A seconda del tempo in cui rimangono attivi sul dispositivo:","cookies-types-17":"Cookie di sessione:","cookies-types-18":"Sono progettati per raccogliere e conservare dati durante la navigazione dell\'utente sul Sito Web o sull\'App e vengono disattivati al termine della navigazione.","cookies-types-19":"Cookie persistenti:","cookies-types-20":"Questi memorizzano dati a cui \xe8 possibile accedere ed elaborare durante un periodo definito dalla persona responsabile del cookie. La loro vita pu\xf2 variare da minuti ad anni.","cookies-used":"5. Quali cookie utilizziamo specificamente sulla nostra piattaforma?","cookies-used-1":"Sulla nostra piattaforma utilizziamo i seguenti cookie:","cookies-used-2":"Nome","cookies-used-3":"Scopo","cookies-used-4":"Cookie propri/di terze parti","cookies-used-5":"Scadenza","cookies-used-6":"14 mesi","cookies-used-7":"Indefinita","cookies-used-stats":"Statistiche","cookies-used-technical":"Tecnica","cookies-used-third-party-google":"Terza parte (Google LLC.)","cookies-legitimation":"6. Qual \xe8 la base di legittimazione che ci consente di trattare i tuoi dati attraverso i cookie? Se s\xec, sono obbligatori?","cookies-legitimation-1":"Le informazioni che raccogliamo attraverso i cookie e altri dispositivi di tracciamento si basano sul tuo consenso, che ti chiediamo quando accedi al Sito Web o quando installi l\'App attraverso un pop-up informativo o secondo le modalit\xe0 stabilite da Google (quando si tratta di Android) o Apple (quando si tratta di iOS).","cookies-legitimation-2":"In tal senso, in ogni momento lei potr\xe0 revocare il suo consenso come spiegato nella sezione relativa alla revoca del consenso.","cookies-legitimation-3":"I cookie tecnici non possono essere disabilitati, altrimenti il corretto funzionamento del Sito Web o dell\'App sarebbe compromesso. In generale, vengono impostati solo in risposta ad azioni intraprese durante la richiesta di servizi da parte nostra, come l\'impostazione delle preferenze in relazione ai cookie stessi, l\'accesso o la compilazione di moduli. Nel caso in cui la disattivazione avvenga, ci\xf2 potrebbe comportare la limitazione dell\'utilizzo di alcuni servizi del Sito Web o dell\'App a causa dell\'impossibilit\xe0 di accedere a determinate funzionalit\xe0 e pertanto la tua esperienza sarebbe meno soddisfacente.","cookies-transfer":"7. A chi forniamo i tuoi dati personali? Esistono trasferimenti internazionali di dati?","cookies-transfer-1":"Utilizziamo alcuni cookie di terze parti, ovvero quei cookie raccolti e gestiti da una terza parte, pertanto tali entit\xe0 riceveranno i tuoi dati personali raccolti tramite i cookie per le finalit\xe0 indicate per ciascun cookie. Questi tipi di cookie sono indicati nella tabella della sezione 5, come \'Cookie di terze parti\'. Questa tabella identifica la terza parte che gestisce ciascun cookie.","cookies-transfer-2":"Puoi conoscere i trasferimenti verso paesi terzi che, se del caso, vengono effettuati dalle terze parti identificate nella presente Politica sui Cookie nelle loro politiche corrispondenti.","cookies-consent":"8. Come posso accettare, negare o revocare il consenso all\'uso dei cookie su questo sito web?","cookies-consent-1":"Quando accedi per la prima volta al nostro Sito Web o alla nostra App, ti verr\xe0 mostrata una finestra in cui puoi indicare se accetti i cookie o se desideri configurarli o rifiutarli, ad eccezione di quelli strettamente necessari. Allo stesso modo, puoi revocare in qualsiasi momento il consenso precedentemente concesso.","cookies-consent-2":"Se desideri revocare il tuo consenso relativo alla Cookies Policy in qualsiasi momento, hai due possibilit\xe0: (i) revocare il tuo consenso attraverso i pulsanti abilitati a tale scopo nella presente Cookies Policy; o (ii) eliminare i cookie memorizzati sul dispositivo attraverso le impostazioni e le configurazioni del proprio browser Internet.","cookies-consent-3":"Tieni presente che, se accetti i cookie di terze parti, devi eliminarli dalle opzioni del browser o dal sistema offerto dalla terza parte stessa.","cookies-consent-4":"\xc8 possibile espandere le informazioni su come disabilitare i cookie, a seconda del browser, nei seguenti collegamenti:","cookies-consent-5":"; per iOS:","cookies-rights":"9. Quali sono i diritti che puoi esercitare in qualit\xe0 di interessato?","cookies-rights-1":"I diritti che hai in qualit\xe0 di interessato in relazione alla protezione dei tuoi dati personali sono indicati nella sezione \'Quali sono i diritti che puoi esercitare in qualit\xe0 di interessato?\' all\'interno del","cookies-rights-2":"Politica sulla Riservatezza","cookies-modifications":"10. Modifiche a questa politica","cookies-modifications-1":"Di tanto in tanto potremmo aggiornare la Politica sui Cookie della nostra piattaforma. Per questo motivo, ti consigliamo di rivedere questa politica ogni volta che accedi al nostro Sito Web o alla nostra App per essere adeguatamente informato su come e per cosa utilizziamo i cookie."}');

});

parcelRegister("gaKSI", function(module, exports) {
module.exports = JSON.parse('{"404-title":"Crush - N\xe3o encontrado","404-not-found-1":"N\xe3o encontrado","404-not-found-2":"Desculpe, a p\xe1gina que voc\xea est\xe1 procurando n\xe3o est\xe1 dispon\xedvel.","navbar-mission":"Miss\xe3o","navbar-download":"Baixar","footer-follow":"Siga-nos","footer-follow-1":"Instagram","footer-follow-2":"TikTok","footer-follow-3":"Twitter","footer-follow-4":"LinkdIn","footer-docs":"Documentos","footer-docs-1":"Miss\xe3o","footer-docs-2":"Aviso legal","footer-docs-3":"Privacidade","footer-docs-4":"Cookies","footer-docs-5":"Diretrizes","footer-contact":"Contate-nos","footer-contact-1":"Suporte","footer-contact-2":"Trabalhos","footer-contact-3":"Investidores","home-title":"Crush - Onde a m\xeddia encontra o plat\xf4nico","home-hero-slogan-1":"Where media","home-hero-slogan-2":"meets platonic \u2122","home-concept-1":"Encontre suas pessoas","home-concept-2":"Conecte-se com pessoas como voc\xea nas diferentes etapas da sua vida.","home-concept-3":"Vibes legais","home-concept-4":"Compartilhe boas vibra\xe7\xf5es e momentos reais. Nada de toxicidade ou pretens\xe3o.","home-attributes-1":"Aesthetic","home-attributes-2":"Promovemos a publica\xe7\xe3o de conte\xfado aesthetic e de alta qualidade; a web j\xe1 est\xe1 inundada de fotos de gatos.","home-attributes-3":"Stalker","home-attributes-4":"Seus amigos s\xe3o as estrelas. Tire algumas rajadas de fotos quando eles n\xe3o est\xe3o preparados e poste alguns GIFs em suas contas.","home-attributes-5":"T\xf3picos","home-attributes-6":"Participe de discuss\xf5es vibrantes que abrangem desde os t\xf3picos mais urgentes de hoje at\xe9 as tend\xeancias que moldar\xe3o o amanh\xe3.","home-attributes-7":"G\xeameos","home-attributes-8":"Conecte-se com indiv\xedduos que compartilham caracter\xedsticas faciais semelhantes \xe0s suas, ampliando sua rede social de maneira completamente nova e divertida.","home-attributes-9":"Segmentado por idade","home-attributes-10":"Ao agrupar os usu\xe1rios por idade, semelhante \xe0s classes do ensino m\xe9dio, as conex\xf5es s\xe3o limitadas a indiv\xedduos da mesma gera\xe7\xe3o para uma intera\xe7\xe3o mais segura e eficiente.","home-attributes-11":"Crush","home-attributes-12":"N\xe3o \xe9 um aplicativo de namoro \u2014 apenas amigos e relacionamentos relaxados. Reviva a nostalgia das conex\xf5es do ensino m\xe9dio em um ambiente digital.","home-partners":"Powered By","mission-title":"Crush - Miss\xe3o","mission-date":"\xdaltima modifica\xe7\xe3o: 8 dezembro, 2023","mission-header":"Miss\xe3o e valores","mission-introduction":"No cora\xe7\xe3o do Crush pulsa algo mais do que apenas uma simples rede social; \xe9 um universo tecido com valores \xe9ticos, uma filosofia e um prop\xf3sito. Este documento \xe9 a jornada atrav\xe9s dos alicerces da nossa vis\xe3o, desde o nascimento da ideia at\xe9 ao esbo\xe7o meticuloso da cria\xe7\xe3o que estamos a moldar.","mission-origin":"A origem","mission-origin-1":"A origem do Crush remonta a uma semente plantada muito antes de seu desenvolvimento concreto em 2020 e seu lan\xe7amento em 2023. Nossa vis\xe3o de mesclar redes sociais com o toque distintivo do Crush foi concebida em 2016, inspirada em \'A Rede Social\', a not\xe1vel obra cinematogr\xe1fica reconhecida por Quentin Tarantino como uma joia da d\xe9cada passada. Este filme, que conta a hist\xf3ria dos jovens fundadores do Facebook, especialmente sua figura mais reconhecida, Mark Zuckerberg \u2014 o pai das redes sociais, nos proporcionou uma perspectiva esclarecedora.","mission-origin-2":"No Crush, acreditamos fervorosamente que o cerne das redes sociais atuais reside no amor plat\xf4nico. Se voc\xea teve a oportunidade de assistir a este filme, pode ter percebido as cr\xedticas de Zuckerberg e Eduardo Saverin aos aplicativos de encontros. Em uma cena-chave, por volta dos 30 minutos, durante o processo dos irm\xe3os Winklevoss por suposto roubo de ideia, Saverin menciona:","mission-origin-3":"\\"It really hadn\'t much to do with the Winklevoss\' dating site\\".","mission-origin-4":"\xc9 curioso, pois alguns minutos depois, por volta dos 36 minutos e 5 segundos, vemos Mark implementando elementos como estado de relacionamento e interesses em seu projeto:","mission-origin-5":"\\"Relationship status, interests... This is what drives life in college. Are you having sex or aren\'t you? That\'s why people take classes, sit where they sit, and do what they do. It\'s the center, you know? That\'s what The Facebook is going to be.\\".","mission-origin-6":"Finalmente, na cena final, testemunhamos um Zuckerberg apaixonado enviando um pedido de amizade para seu crush.","mission-origin-7":"Este filme nos apresenta uma pergunta intrigante:","mission-origin-8":"As redes sociais s\xe3o na verdade aplicativos de namoro disfar\xe7ados?","mission-purpose":"Nosso prop\xf3sito","mission-purpose-1":"N\xe3o h\xe1 uma resposta definitiva para a pergunta levantada na se\xe7\xe3o anterior. Talvez sim, talvez n\xe3o... no final, isso depende dos valores \xe9ticos e culturais, das inten\xe7\xf5es e da educa\xe7\xe3o do usu\xe1rio final. O que sabemos com certeza \xe9 que isso abre a porta para problemas reais e muito s\xe9rios que, ao contr\xe1rio do mundo real, podem de fato ser resolvidos.","mission-purpose-2":"Seja pelas normas pr\xe9-estabelecidas pela sociedade ou pelo anonimato que leva a comportamentos inadequados online, o amor no mundo digital, seja ele plat\xf4nico e genu\xedno nas redes sociais ou mais rom\xe2ntico nos aplicativos de relacionamento, infelizmente tem sido sexualizado nos \xfaltimos anos. Por que algo t\xe3o bonito e fundamental em nossas vidas est\xe1 sendo distorcido nesse universo paralelo?","mission-purpose-3":"Vamos ser claros e completamente transparentes. Na Espanha, nosso pa\xeds de origem, segundo dados e estat\xedsticas verific\xe1veis,","mission-purpose-4":"7 em cada 10 menores de 15 anos t\xeam um dispositivo m\xf3vel.","mission-purpose-5":"Isso significa que cerca de 70% dos menores t\xeam acesso irrestrito a um mundo virtual onde a intera\xe7\xe3o com adultos n\xe3o foi regulada ou restrita, expondo-os a riscos como ass\xe9dio, bullying ou pedofilia, entre outros.","mission-purpose-6":"Atualmente, independentemente da rede social em que voc\xea se inscreve, \xe9 comum encontrar pessoas vendendo conte\xfado inapropriado ou compartilhando qualquer tipo de conte\xfado inadequado. Quanto mais o tempo passa, mais repugnante \xe9 a situa\xe7\xe3o.","mission-purpose-7":"Nosso objetivo \xe9 eliminar a sexualiza\xe7\xe3o e a toxicidade da rede, abordando diretamente sua origem.","mission-purpose-8":"Crush \xe9 proposto como uma redefini\xe7\xe3o das redes sociais a partir de uma perspectiva diferente, focando em relacionamentos plat\xf4nicos.","mission-purpose-9":"N\xe3o oferecemos um sistema de namoro ou a cria\xe7\xe3o de relacionamentos rom\xe2nticos/s\xe9rios, pois isso contradiz nossas","mission-purpose-10":"diretrizes da comunidade.","mission-purpose-11":"Em vez disso, oferecemos o que foi idealizado no filme \'A Rede Social\', mas com uma solu\xe7\xe3o para o problema e uma abordagem mais descontra\xedda.","mission-purpose-12":"Nossa miss\xe3o vai al\xe9m do t\xedpico \\"compartilhar momentos reais\\" ou \\"ajudamos voc\xea a se conectar\\". Al\xe9m de acompanhar o usu\xe1rio nas v\xe1rias etapas de sua vida, estamos dedicados a resolver os problemas mencionados anteriormente. Em nossa plataforma, no momento da reda\xe7\xe3o deste documento, j\xe1 \xe9 imposs\xedvel que um menor interaja com um adulto (e vice-versa), n\xe3o apenas para fechar as portas para essas quest\xf5es \xe9ticas, mas tamb\xe9m para incentivar a cria\xe7\xe3o de la\xe7os entre pessoas da mesma gera\xe7\xe3o, com uma mentalidade semelhante. Planejamos apresentar solu\xe7\xf5es mais eficazes na pr\xf3xima d\xe9cada de desenvolvimento; esta \xe9 nossa promessa.","guidelines-title":"Crush - Diretrizes","guidelines-date":"\xdaltima modifica\xe7\xe3o: 4 abril, 2024","guidelines-header":"Diretrizes da comunidade","guidelines-introduction-1":"No Crush, trata-se de estabelecer conex\xf5es plat\xf4nicas, compartilhar momentos aut\xeanticos da vida com amigos, socializar e criar novas amizades alinhadas com sua mentalidade. Acreditamos firmemente na liberdade de express\xe3o, mas tamb\xe9m valorizamos a capacidade de distinguir entre o certo e o errado. Este documento detalha os padr\xf5es de nossa rede social, essenciais para cumprir","guidelines-introduction-2":"nosso prop\xf3sito principal.","guidelines-introduction-3":"Esperamos um comportamento adequado, cuidado com o conte\xfado, autenticidade, humildade e, acima de tudo, responsabilidade. Qualquer viola\xe7\xe3o de nossos princ\xedpios fundamentais pode resultar na suspens\xe3o permanente de sua conta, sem possibilidade de se registrar novamente em nosso sistema.","guidelines-introduction-4":"Assim como na vida real, h\xe1 consequ\xeancias para as a\xe7\xf5es. Por favor, respeite nossas regras e n\xe3o use nosso sistema de maneira contr\xe1ria \xe0 lei. Queremos enfatizar nossa seriedade e rigor; um tom brincalh\xe3o n\xe3o \xe9 bem-vindo nesse contexto.","guidelines-dating":"Anti-encontros","guidelines-dating-1":"Crush \xe9 uma combina\xe7\xe3o de redes sociais adequada para todas as pessoas","guidelines-dating-2":"com 15 anos ou mais,","guidelines-dating-3":"estejam ou n\xe3o em um relacionamento rom\xe2ntico. N\xe3o confunda amigos e relacionamentos plat\xf4nicos (opcionais) com relacionamentos rom\xe2nticos ou compromissos reais.","guidelines-dating-4":"A seguir, detalhamos uma s\xe9rie de comportamentos que deves adotar e respeitar para permanecer na nossa plataforma:","guidelines-dating-5":"N\xe3o utilize nosso servi\xe7o para buscar ou solicitar encontros rom\xe2nticos.","guidelines-dating-6":"Se o amor chegar \xe0 tua vida, que n\xe3o seja atrav\xe9s de uma tela.","guidelines-dating-7":"N\xe3o publique coisas sujas.","guidelines-dating-8":"N\xe3o assedies ou incomodes nenhum usu\xe1rio.","guidelines-dating-9":"N\xe3o mintas sobre a tua idade ou informa\xe7\xf5es pessoais, muito menos fa\xe7as-se passar por outra pessoa.","guidelines-dating-10":"\xc9 um crime muito grave que poderia resultar em a\xe7\xf5es legais contra ti.","guidelines-content":"Aesthetic","guidelines-content-1":"Para n\xf3s, qualquer forma de software \xe9 arte e a arte deve ser respeitada. Em uma rede social, a qualidade da plataforma se reflete no conte\xfado gerado pelos usu\xe1rios. No nosso caso, incentivamos a criatividade e a inspira\xe7\xe3o. Pedimos que publique mantendo um padr\xe3o m\xednimo de qualidade.","guidelines-content-2":"N\xe3o poste conte\xfado visualmente ruim.","guidelines-content-3":"Fa\xe7a um esfor\xe7o.","guidelines-content-4":"Spam \xe9 remo\xe7\xe3o imediata.","guidelines-content-5":"Se voc\xea deseja promover o seu Instagram, use as ferramentas que disponibilizamos para isso.","guidelines-content-6":"N\xe3o compartilhe conte\xfado que viole a propriedade intelectual de terceiros.","guidelines-content-7":"Por favor, evite postar fotos de gatinhos;","guidelines-content-8":"a internet j\xe1 est\xe1 cheia delas.","guidelines-content-9":"N\xe3o fa\xe7as papel de rid\xedculo ao publicar nudez desnecess\xe1ria.","guidelines-content-10":"Estamos cansados de fotos sem camisa.","guidelines-vibes":"Apenas boas vibra\xe7\xf5es","guidelines-vibes-1":"Na Crush, n\xe3o toleramos comportamentos inapropriados. Assim como cuida da sua imagem na vida real, pedimos que seja respons\xe1vel e mantenha essa integridade online. Demonstre cortesia e respeito tanto para os usu\xe1rios de nossa comunidade quanto para os criadores da plataforma.","guidelines-vibes-2":"A explora\xe7\xe3o infantil, a extors\xe3o sexual ou qualquer outro tipo de abuso, em qualquer forma, s\xe3o estritamente proibidos.","guidelines-vibes-3":"Nosso compromisso contra o suic\xeddio e a automutila\xe7\xe3o \xe9 absoluto.","guidelines-vibes-4":"Qualquer conte\xfado que promova, encoraje ou glorifique essas a\xe7\xf5es resultar\xe1 em suspens\xe3o permanente.","guidelines-vibes-5":"Levamos a legalidade a s\xe9rio.","guidelines-vibes-6":"Evite compartilhar conte\xfado que promova atividades ilegais, assim como qualquer conte\xfado relacionado a armas ou drogas.","guidelines-vibes-7":"Conte\xfado ofensivo ou violento n\xe3o tem lugar em nossa plataforma e n\xe3o \xe9 permitido.","guidelines-vibes-8":"O modo Stalker destina-se \xe0 divers\xe3o entre amigos.","guidelines-vibes-9":"No entanto, mesmo que o conte\xfado necessite de aprova\xe7\xe3o do usu\xe1rio (ou usu\xe1rios) no GIF, evite compartilhar fotos dos seus amigos sem o consentimento pr\xe9vio deles.","legal-title":"Crush - Aviso legal","legal-date":"\xdaltima modifica\xe7\xe3o: 4 abril, 2024","legal-header":"Aviso legal","legal-introduction-1":"Cada aplicativo \xe9 um universo e todos os universos est\xe3o sujeitos a regras. Neste documento, voc\xea encontrar\xe1 o aviso legal e os termos gerais de uso de nossa plataforma, complementados pelos definidos em nossas","legal-introduction-2":"diretrizes da comunidade.","legal-owner":"1. Identifica\xe7\xe3o do titular","legal-owner-1":"O website www.crushsocialnetwork.com (doravante, o","legal-owner-2":"\'Website\'","legal-owner-3":") e a aplica\xe7\xe3o m\xf3vel para Smartphone com o nome \'Crush\' (doravante, o","legal-owner-4":"\'App\'","legal-owner-5":") s\xe3o propriedade de CRUSH SOCIAL NETWORK, Lda., provida de NIF: B-72599830 e inscrita no Registo Mercantil de Val\xe8ncia com os seguintes dados de registo: T. 3606, F.75, I.1, H. MU-108656, e cujos dados de contato s\xe3o:","legal-owner-6":"Sede social:","legal-owner-7":"Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Espanha)","legal-owner-8":"Email de contato:","legal-area":"2. \xc2mbito de aplica\xe7\xe3o","legal-area-1":"As presentes Condi\xe7\xf5es Gerais de Uso do Website (doravante, as","legal-area-2":"\'Condi\xe7\xf5es de Uso\'","legal-area-3":") recolhem os termos e condi\xe7\xf5es que regulam o acesso, navega\xe7\xe3o e utiliza\xe7\xe3o do Website e da App.","legal-area-4":"Neste sentido, o acesso, utiliza\xe7\xe3o e navega\xe7\xe3o no Website e na App confere a condi\xe7\xe3o de usu\xe1rio(s) (doravante, o","legal-area-5":"\'Usu\xe1rio\'","legal-area-6":"ou os","legal-area-7":"\'Usu\xe1rios\'","legal-area-8":"), e implica a aceita\xe7\xe3o de todas e cada uma das presentes Condi\xe7\xf5es de Uso. O Usu\xe1rio est\xe1 plenamente consciente de que a mera navega\xe7\xe3o atrav\xe9s do Website ou App implica a aceita\xe7ao destas Condi\xe7\xf5es de Utiliza\xe7\xe3o e, portanto, se o Usu\xe1rio n\xe3o concordar com eles, n\xe3o deve utilizar o Website ou esta App.","legal-area-9":"O Webite e a App destinam-se principalmente a Usu\xe1rios residentes em Espanha. Crush n\xe3o garante que o Website ou App cumpram as leis de outros pa\xedses, total ou parcialmente. Se o Usu\xe1rio residir ou tiver o seu domic\xedlio noutro local e decide aceder e/ou navegar no Website ou aceder ou utilizar a App, f\xe1-lo-\xe1 sob a sua pr\xf3pia responsabilidade e dever\xe1 assegurar-se de que tal acesso, navega\xe7\xe3o ou utiliza\xe7\xe3o est\xe1 em conformidade com a legisla\xe7\xe3o local que lhe \xe9 aplic\xe1vel, n\xe3o assumindo a Crush qualquer responsabilidade que possa resultar desse acesso ou uso.","legal-area-10":"Crush pode, a qualquer momento, e sem aviso pr\xe9vio, modificar as presentes Condi\xe7\xf5es de Uso, as quais ser\xe3o publicadas \xe0 medida que essas modifica\xe7\xf5es ocorrerem.","legal-conditions":"3. Condi\xe7\xf5es de acesso e uso","legal-conditions-1":"O acesso ao Website ou \xe0 App pelo Utilizador, em regra, \xe9 gratuito. No caso de existirem funcionalidades ou servi\xe7os reservados a determinados Usu\xe1rios ou que seja necess\xe1rio pagar um pre\xe7o, estes ser\xe3o devidamente identificados na Website ou no App.","legal-conditions-2":"O acesso ao Website ou \xe0 App \xe9 feito sob a exclusiva responsabilidade do Utilizador, e n\xe3o implica qualquer tipo de rela\xe7\xe3o comercial entre a Crush e o Usu\xe1rio. O Utilizador \xe9 respons\xe1vel por garantir que as informa\xe7\xf5es e conte\xfados inclu\xeddos no Website ou App cumprem os seus requisitos espec\xedficos.","legal-conditions-3":"O usu\xe1rio concorda em:","legal-conditions-4":"Acesso e utiliza\xe7\xe3o tanto do Website como da App de acordo com a boa-f\xe9 e de acordo com os presentes Termos de Utiliza\xe7\xe3o, a Lei, a moral e a ordem p\xfablica, com o requisito adicional de atingir a idade m\xednima de 15 anos.","legal-conditions-5":"Na Crush, certificamos que cumprimos a legisla\xe7\xe3o aplic\xe1vel sobre seguran\xe7a infantil e levamos a s\xe9rio o material de abuso sexual infantil. Tomamos medidas adequadas, como a remo\xe7\xe3o desse material ap\xf3s tomarmos conhecimento efetivo de sua exist\xeancia, de acordo com nossos padr\xf5es e as leis relevantes.","legal-conditions-6":"Forne\xe7a informa\xe7\xf5es verdadeiras, atuais e legais nos formul\xe1rios oferecidos tanto no Website como na App. Em qualquer caso, o Utilizador notificar\xe1 imediatamente a Crush sobre qualquer facto que permita o uso indevido das informa\xe7\xf5es registadas nos referidos formul\xe1rios, tais como, mas n\xe3o s\xf3, roubo, perda ou acesso n\xe3o autorizado a identificadores e/ou senhas, a fim de proceder ao seu cancelamento imediato.","legal-conditions-7":"N\xe3o tomar qualquer a\xe7\xe3o no Webste ou na App que possa causar danos ou altera\xe7\xf5es nos conte\xfados, programas ou sistemas do Website ou da App, incluindo a introdu\xe7\xe3o de v\xedrus de computador, a instala\xe7\xe3o de rob\xf4s ou qualquer software ou arquivo nocivo, defeituoso ou, em \xfaltima an\xe1lise, que possa causar danos nos nossos sistemas inform\xe1ticos.","legal-conditions-8":"Em qualquer caso, o Utilizador ser\xe1 respons\xe1vel por danos que possam ser causados tanto \xe0 Crush como a terceiros e a Crush poder\xe1 adotar as medidas t\xe9cnicas, legais e quaisquer outras medidas que considere adequadas para prevenir, mitigar ou parar as consequ\xeancias dos comportamentos anteriores proibidos e exigir o m\xe1ximo de responsabilidades que considere adequadas.","legal-property":"4. Propriedade intelectual e industrial","legal-property-1":"Todos os conte\xfados do Website e da App, incluindo, sem limita\xe7\xe3o, textos, imagens, fotografias, v\xeddeos, gr\xe1ficos, sinais distintivos de qualquer tipo, \xedcones, interfaces, bem como software, c\xf3digo fonte, desenhos, arquitetura, apresenta\xe7\xe3o, arranjo e classifica\xe7\xe3o dos conte\xfados e qualquer outro elemento presente no Website ou na App que possa estar sujeito a direitos de propriedade intelectual s\xe3o propriedade exclusiva da Crush ou terceiros que tenham  licenciado, autorizado ou consentido para a sua utiliza\xe7\xe3o no Website ou na App.","legal-property-2":"Neste sentido, quando o Utilizador acede, navega e utiliza o Website ou acede ou utiliza a App, n\xe3o s\xe3o concedidos direitos de explora\xe7\xe3o que existam ou possam existir sobre todos ou parte destes, a Crush reservando todos estes direitos. O Utilizador s\xf3 pode ver os elementos do Website e da App e us\xe1-los na medida estritamente necess\xe1ria para uma utiliza\xe7\xe3o correta destes. Em particular, \xe9 proibido utilizar ou revender para fins comerciais qualquer material ou conte\xfado presente no Website ou na App sem a autoriza\xe7\xe3o pr\xe9via da Crush.","legal-property-3":"A Crush reserva-se o direito de modificar, a qualquer momento, e sem aviso pr\xe9vio, a apresenta\xe7\xe3o e configura\xe7\xe3o do Website ou da App e os conte\xfados e servi\xe7os que possam ser incorporados nos mesmos. O Usu\xe1rio reconhece e aceita que a qualquer momento a Crush pode interromper, desativar e/ou cancelar qualquer um destes elementos que estejam integrados no Website e na App ou no acesso aos mesmos.","legal-property-4":"Se o Utilizador considerar que algum dos conte\xfados do Website ou da App constitui uma viola\xe7\xe3o dos direitos de prote\xe7\xe3o da propriedade intelectual, deve notificar imediatamente a Crush atrav\xe9s dos dados de contacto da sec\xe7\xe3o 1 (Identifica\xe7\xe3o do titular) das presentes Condi\xe7\xf5es de Utiliza\xe7\xe3o.","legal-disclaimer":"5. Exclus\xe3o de garantias e responsabilidade","legal-disclaimer-1":"As informa\xe7\xf5es publicadas no Website ou na App podem n\xe3o ser exaustivas ou n\xe3o completamente atualizadas, pelo que a Crush n\xe3o assume qualquer responsabilidade derivada da falta de integridade, atualiza\xe7\xe3o ou precis\xe3o dos dados e informa\xe7\xf5es contidas nas diferentes p\xe1ginas que fazem parte do Website ou da App.","legal-disclaimer-2":"A Crush n\xe3o garante que o acesso \xe0 App ou Website seja ininterrupto ou isento de erros. Da mesma forma, a Crush n\xe3o garante que o conte\xfado ou software presente no Website ou na App n\xe3o cause danos no sistema inform\xe1tico do Usu\xe1rio (software e hardware). A Crush n\xe3o ser\xe1 respons\xe1vel por perdas, danos ou perdas de qualquer tipo decorrentes do acesso, navega\xe7\xe3o e utiliza\xe7\xe3o do Website ou da App, incluindo, mas n\xe3o se limitando a, as causadas a sistemas inform\xe1ticos ou as causadas pela introdu\xe7\xe3o de v\xedrus.","legal-disclaimer-3":"A Crush, da mesma forma, fica exonerada de qualquer responsabilidade derivada do uso indevido do Website ou do App pelo Usu\xe1rio.","legal-links":"6. Links","legal-links-1":"Informa-se que tanto o Website quanto o App podem encontrar links, banners, bot\xf5es, diret\xf3rios e buscadores, entre outros, que permitem aos Usu\xe1rios acessar outros sites ou apps pertencentes e/ou administrados por terceiros e que, por isso, eles est\xe3o fora do controle do Crush, que n\xe3o pode assumir qualquer responsabilidade pelo conte\xfado que aparece em tais p\xe1ginas ou aplicativos.","legal-links-2":"Caso considere que o referido conte\xfado \xe9 impr\xf3prio ou contr\xe1rio aos prop\xf3sitos do Crush, por favor comunique-nos atrav\xe9s dos meios de contacto acima referidos, para que possamos adotar as medidas cab\xedveis.","legal-jurisdiction":"7. Lesgila\xe7\xe3o aplic\xe1vel e jurisdi\xe7\xe3o","legal-jurisdiction-1":"Estas Condi\xe7\xf5es de Uso e sua execu\xe7\xe3o est\xe3o sujeitas \xe0 lei espanhola.","legal-jurisdiction-2":"Se surgir qualquer disputa sobre a interpreta\xe7\xe3o ou aplica\xe7\xe3o destes Termos de Uso, as Partes negociar\xe3o de boa f\xe9 para tentar resolver tal discrep\xe2ncia ou reclama\xe7\xe3o. No entanto, caso a discrep\xe2ncia ou reclama\xe7\xe3o n\xe3o seja resolvida, as Partes se submeter\xe3o aos tribunais ou tribunais correspondentes de acordo com a lei.","privacy-title":"Crush - Privacidade","privacy-date":"\xdaltima modifica\xe7\xe3o: 8 dezembro, 2023","privacy-header":"Pol\xedtica de privacidade","privacy-introduction-1":"Na Crush. Estamos empenhados em garantir que os seus dados pessoais est\xe3o protegidos e n\xe3o s\xe3o utilizados para fins diferentes dos indicados nesta Pol\xedtica de Privacidade. Por esta raz\xe3o, nesta sec\xe7\xe3o informamos os utilizadores e interessados de tudo o que se relacione com o tratamento dos seus dados pessoais, cumprindo assim com a normativa de prote\xe7\xe3o de dados aplic\xe1vel no nosso pa\xeds: Regulamento Geral de Prote\xe7\xe3o de Dados (UE) 2016/679, de 27 de abril sobre a prote\xe7\xe3o das pessoas f\xedsicas no que diz respeito ao tratamento de dados pessoais e \xe0 livre circula\xe7\xe3o desses dados (doravante,","privacy-introduction-2":"\'RGPD\'","privacy-introduction-3":") e Lei Org\xe2nica 3/2018, de 5 de dezembro, Prote\xe7\xe3o de Dados Pessoais e garantia de direitos digitais (doravante,","privacy-introduction-4":"\'LOPDGDD\'","privacy-introduction-5":"Esta Pol\xedtica de Privacidade \xe9 aplic\xe1vel ao processamento de dados que CRUSH SOCIAL NETWORK, Lda. realizadas tanto atrav\xe9s do website: www.crushsocialnetwork.com (doravante, o \'Website\'), como atrav\xe9s do aplicativo m\xf3vel para Smartphone com o nome \'Crush\' (doravante, o \'App\') e/ou os indicados. Recomendamos que voc\xea leia atentamente antes de usar o Website ou o App e fornecer seus dados atrav\xe9s deles. N\xe3o hesite em nos fazer qualquer pergunta a esse respeito via e-mail:","privacy-index":"\xcdndice de conte\xfados","privacy-index-1":"Nesta Pol\xedtica encontrar\xe1 toda a informa\xe7\xe3o relacionada com o tratamento dos seus dados pessoais e os direitos que pode exercer para manter o controlo sobre os mesmos. Nesse sentido, voc\xea encontrar\xe1 informa\xe7\xf5es sobre:","privacy-index-2":"Quem \xe9 o respons\xe1vel pelo tratamento dos seus dados.","privacy-index-3":"Quais requisitos voc\xea deve atender para nos fornecer seus dados pessoais.","privacy-index-4":"Que tratamento de dados realizamos atrav\xe9s da Aplica\xe7\xe3o e quais s\xe3o as suas principais caracter\xedsticas, explicando:","privacy-index-5":"Quais dados coletamos e quais s\xe3o as formas de coleta.","privacy-index-6":"Para que finalidades recolhemos os dados que solicitamos.","privacy-index-7":"Qual a legitimidade para o seu tratamento.","privacy-index-8":"Quanto tempo os guardamos?","privacy-index-9":"Para quais destinat\xe1rios seus dados s\xe3o comunicados.","privacy-index-10":"Exist\xeancia de transfer\xeancias internacionais dos seus dados.","privacy-index-11":"Quais s\xe3o os seus direitos e como pode exerc\xea-los?","privacy-index-12":"Como protegemos suas informa\xe7\xf5es pessoais.","privacy-index-13":"Altera\xe7\xf5es a esta pol\xedtica.","privacy-controller":"1. Quem \xe9 o respons\xe1vel pelo tratamento dos seus dados pessoais?","privacy-controller-1":"Os seus dados pessoais ser\xe3o tratados pela empresa CRUSH SOCIAL NETWORK, Lda. (","privacy-controller-2":"\'CRUSH\'","privacy-controller-3":"), com NIF B-72599830 e cujos contactos s\xe3o os seguintes:","privacy-controller-4":"Endere\xe7o:","privacy-controller-5":"Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Espanha)","privacy-controller-6":"Email de contato:","privacy-dpo":"1.1. Nosso Encarregado da Prote\xe7\xe3o de Dados:","privacy-dpo-1":"A partir do CRUSH, colocamos \xe0 sua disposi\xe7\xe3o os dados de contacto do nosso Encarregado da Prote\xe7\xe3o de Dados, a quem poder\xe1 dirigir todas as quest\xf5es que possa ter relativamente a esta Pol\xedtica de Privacidade ou ao tratamento dos seus dados pessoais.","privacy-dpo-2":"Email:","privacy-requirements":"2. Que requisitos deve cumprir para nos fornecer os seus dados pessoais?","privacy-requirements-1":"2.1. Idade minima. Para nos fornecer seus dados pessoais e usar nosso Website e nosso App, voc\xea deve ser maior de 15 anos.","privacy-requirements-2":"2.2. Veracidade. Ao nos fornecer seus dados para utiliza\xe7\xe3o de nossos servi\xe7os, voc\xea garante que os dados e informa\xe7\xf5es fornecidos s\xe3o reais, verdadeiros, atualizados e tamb\xe9m pertencem a voc\xea e n\xe3o a terceiros.","privacy-requirements-3":"Al\xe9m disso, voc\xea deve nos notificar de qualquer altera\xe7\xe3o que ocorra nos dados fornecidos, respondendo em qualquer caso pela veracidade e precis\xe3o dos dados fornecidos em todos os momentos.","privacy-requirements-4":"2.3. Controle de idade e veracidade. A partir do CRUSH reservamo-nos o direito de verificar a sua idade e dados identificativos, se necess\xe1rio, mesmo exigindo documento oficial ou procedimento equivalente e, em caso de dete\xe7\xe3o de fraude que se verifique ou suspeite de ser menor de idade indicado, de eliminar, temporariamente desativar e/ou cancelar sua conta.","privacy-processing":"3. Que tratamento de dados realizamos atrav\xe9s do Website e da App e quais s\xe3o as suas principais caracter\xedsticas?","privacy-processing-1":"Abaixo, explicamos como tratamos suas informa\xe7\xf5es pessoais e fornecemos, detalhadamente, todas as informa\xe7\xf5es relevantes sobre sua privacidade:","privacy-contact":"3.1. Quando voc\xea entra em contato conosco atrav\xe9s de nossos canais (formul\xe1rio de contato, chat, e-mail)","privacy-contact-1":"Quais s\xe3o as formas de coletar os dados?","privacy-contact-2":"Formul\xe1rio de contato.","privacy-contact-3":"Chat.","privacy-contact-4":"Enviando e-mails para","privacy-contact-5":"ou outros endere\xe7os de e-mail do CRUSH.","privacy-contact-6":"Que dados recolhemos?","privacy-contact-7":"Identifica\xe7\xe3o e informa\xe7\xf5es de contato.","privacy-contact-8":"Recolhemos os seus dados de identifica\xe7\xe3o (nome e apelido) e endere\xe7o de correio eletr\xf3nico, bem como qualquer outra informa\xe7\xe3o que inclua voluntariamente nas comunica\xe7\xf5es que nos envia.","privacy-contact-9":"Podemos solicitar informa\xe7\xf5es adicionais de voc\xea, se necess\xe1rio, para atender \xe0 sua solicita\xe7\xe3o ou exig\xeancia.","privacy-contact-10":"Quais s\xe3o as finalidades do tratamento dos seus dados pessoais?","privacy-contact-11":"Responda aos seus pedidos.","privacy-contact-12":"A principal finalidade do tratamento destes dados ser\xe1 responder aos seus pedidos, esclarecer as suas d\xfavidas e/ou fornecer-lhe as informa\xe7\xf5es solicitadas, bem como, se for o caso, dar seguimento aos seus pedidos.","privacy-contact-13":"Melhore o atendimento ao cliente.","privacy-contact-14":"Todas as informa\xe7\xf5es derivadas de d\xfavidas, consultas e conselhos oferecidos \xe0s partes interessadas, bem como a forma como as solicita\xe7\xf5es s\xe3o resolvidas, permitem-nos saber como prestamos o nosso pr\xf3prio servi\xe7o ao cliente, permitindo-nos melhorar a sua qualidade.","privacy-contact-15":"Da mesma forma, toda a informa\xe7\xe3o recolhida, ap\xf3s o per\xedodo de conserva\xe7\xe3o abaixo indicado, \xe9 anonimizada e utilizada com a finalidade de poder analisar as perguntas mais frequentes atrav\xe9s do chat e poder automatizar as mais frequentes, preparar FAQs ou guard\xe1-las para fins estat\xedsticos para desenvolver estrat\xe9gias de neg\xf3cios.","privacy-contact-16":"Qual \xe9 a base legal que nos permite tratar os seus dados? O fornecimento destes dados \xe9 obrigat\xf3rio?","privacy-contact-17":"Consentimento.","privacy-contact-18":"Os dados fornecidos para as finalidades anteriores ser\xe3o tratados com base no seu consentimento, concedido quando nos contacta voluntariamente atrav\xe9s dos meios que lhe s\xe3o disponibilizados para solicitar informa\xe7\xf5es ou efetuar um pedido.","privacy-contact-19":"Toda a informa\xe7\xe3o recolhida pelo departamento de apoio ao cliente ser\xe1 tratada para efeitos estat\xedsticos que nos ajudar\xe3o a melhorar a qualidade do servi\xe7o prestado ao cliente. Esta finalidade \xe9 considerada compat\xedvel com a inicial.","privacy-contact-20":"As informa\xe7\xf5es que voc\xea deve fornecer ser\xe3o indicadas com um asterisco ou similar. Sem esta informa\xe7\xe3o n\xe3o seria poss\xedvel atender \xe0s suas d\xfavidas ou solicita\xe7\xf5es.","privacy-contact-21":"Por quanto tempo mantemos suas informa\xe7\xf5es?","privacy-contact-22":"Processaremos todas as suas informa\xe7\xf5es pessoais durante o tempo em que suas solicita\xe7\xf5es estiverem sendo processadas e, se necess\xe1rio, para acompanh\xe1-las. Findo este prazo, a CRUSH manter\xe1, bloqueada, referidas informa\xe7\xf5es durante os prazos previstos na legisla\xe7\xe3o para atender a eventuais responsabilidades e demonstrar o cumprimento de nossas obriga\xe7\xf5es. A partir deste momento, o CRUSH apenas tratar\xe1 a informa\xe7\xe3o de forma an\xf3nima, pelo que n\xe3o ser\xe1 poss\xedvel relacionar a informa\xe7\xe3o estat\xedstica com os utilizadores espec\xedficos a que se refere.","privacy-contact-23":"A quem damos suas informa\xe7\xf5es pessoais?","privacy-contact-24":"N\xe3o fazemos nenhuma transfer\xeancia adicional para realizar este tratamento al\xe9m dos indicados, em geral, no ponto","privacy-contact-25":"4. A quem damos suas informa\xe7\xf5es pessoais?","privacy-contact-26":"Nesse sentido, alguns canais pelos quais voc\xea pode entrar em contato conosco s\xe3o geridos por prestadores de servi\xe7os, que atuam como Gestores de Tratamento. Voc\xea encontrar\xe1 mais informa\xe7\xf5es sobre como esses prestadores de servi\xe7os atuam no ponto 4, mencionado acima.","privacy-app-use":"3.2. Quando voc\xea se registra e usa nosso App \'Crush\'","privacy-app-use-1":"Quais s\xe3o as formas de coletar os dados?","privacy-app-use-2":"Ficha de inscri\xe7\xe3o na nossa App e utiliza\xe7\xe3o dos seus diferentes espa\xe7os.","privacy-app-use-3":"Que dados recolhemos?","privacy-app-use-4":"Dados b\xe1sicos para cadastro:","privacy-app-use-5":"Para se registrar em nosso App e usar os servi\xe7os, voc\xea precisar\xe1 se registrar em nosso App e criar um","privacy-app-use-6":"\'perfil\'.","privacy-app-use-7":"Durante o processo de registo solicitamos-lhe, enquanto utilizador, os seguintes dados:","privacy-app-use-8":"Nome de usu\xe1rio.","privacy-app-use-9":"Nome completo.","privacy-app-use-10":"E-mail.","privacy-app-use-11":"Data de nascimento.","privacy-app-use-12":"Dados adicionais:","privacy-app-use-13":"Al\xe9m do acima, nosso App permite que voc\xea compartilhe voluntariamente informa\xe7\xf5es relacionadas a:","privacy-app-use-14":"G\xeanero.","privacy-app-use-15":"Orienta\xe7\xe3o sexual.","privacy-app-use-16":"Interesses.","privacy-app-use-17":"Pa\xeds, cidade ou regi\xe3o.","privacy-app-use-18":"Descri\xe7\xe3o sobre voc\xea.","privacy-app-use-19":"Profiss\xe3o e estudos.","privacy-app-use-20":"Gostos musicais.","privacy-app-use-21":"Melhor amigo.","privacy-app-use-22":"Se voc\xea autorizar, sua geolocaliza\xe7\xe3o precisa, que, se voc\xea permitiu, \xe9 realizada em segundo plano.","privacy-app-use-23":"Dados de uso: podem ser coletadas informa\xe7\xf5es sobre suas intera\xe7\xf5es com outros usu\xe1rios (chats com outros usu\xe1rios, usu\xe1rios com os quais voc\xea se conecta e interage, tempo, frequ\xeancia de intera\xe7\xe3o ou outras caracter\xedsticas de suas intera\xe7\xf5es).","privacy-app-use-24":"Alguns dos dados que pode fornecer voluntariamente s\xe3o considerados sens\xedveis, uma vez que est\xe3o relacionados com a sua orienta\xe7\xe3o sexual. Deve ter em conta que, se decidir incluir tal informa\xe7\xe3o, o CRUSH ir\xe1 process\xe1-la juntamente com o resto da informa\xe7\xe3o para cumprir as finalidades indicadas abaixo. Da mesma forma, esta informa\xe7\xe3o pode ser compartilhada com o restante dos usu\xe1rios (pode ser tornada p\xfablica), de modo que o uso n\xe3o autorizado do App por outros usu\xe1rios pode causar o vazamento desses dados. O CRUSH n\xe3o se responsabiliza pelo uso indevido de dados por outros usu\xe1rios.","privacy-app-use-25":"Informamos tamb\xe9m que a CRUSH utiliza os dados acima com o objetivo de criar perfis para recomendar conte\xfado que possa ser do seu interesse e com as caracter\xedsticas pessoais que voc\xea inclui sobre si mesmo, conforme explicado abaixo.","privacy-app-use-26":"Al\xe9m disso, se voc\xea autorizar, teremos acesso a:","privacy-app-use-27":"C\xe2mera (imagens): conceder permiss\xe3o para c\xe2mera permite que o usu\xe1rio carregue qualquer imagem diretamente no App.","privacy-app-use-28":"Galeria de fotos (imagens): conceder acesso \xe0 galeria de fotos permite que o usu\xe1rio carregue qualquer imagem de sua galeria de fotos.","privacy-app-use-29":"Microfone (\xe1udio): A concess\xe3o de acesso ao microfone permite que o usu\xe1rio use o gravador de voz do dispositivo diretamente do App.","privacy-app-use-30":"Conte\xfado postado por voc\xea:","privacy-app-use-31":"Ao utilizar a nossa App, tem a possibilidade de interagir com outros utilizadores atrav\xe9s da nossa comunidade, podendo carregar publica\xe7\xf5es com conte\xfados audiovisuais (fotos, \xe1udios, etc., caso tenha concedido as respetivas permiss\xf5es) e adicionar coment\xe1rios com as suas opini\xf5es, levantar d\xfavidas e resolver preocupa\xe7\xf5es de outros usu\xe1rios.","privacy-app-use-32":"Tamb\xe9m oferecemos um empolgante modo \'Stalker\', onde seus amigos podem capturar GIFs de voc\xea com o seu consentimento. No entanto, a responsabilidade de capturar e solicitar a publica\xe7\xe3o desses GIFs em seu perfil recai sobre o usu\xe1rio que inicia a solicita\xe7\xe3o. O GIF n\xe3o ser\xe1 publicado em seu perfil at\xe9 que voc\xea aceite a solicita\xe7\xe3o. Al\xe9m disso, todos os colaboradores podem remover permanentemente a contribui\xe7\xe3o, seja excluindo-a diretamente ou recusando a solicita\xe7\xe3o.","privacy-app-use-33":"O CRUSH usa a tecnologia de reconhecimento facial da Amazon Web Services para processar os dados biom\xe9tricos dos usu\xe1rios do CRUSH como seu provedor de servi\xe7os (\'Processador\'). A Amazon pode processar e armazenar modelos de rosto com a finalidade de fornecer servi\xe7os de verifica\xe7\xe3o e/ou identifica\xe7\xe3o de rosto em nome do CRUSH e somente sob as instru\xe7\xf5es do CRUSH. A Amazon armazenar\xe1 esses dados pelo tempo que o CRUSH solicitar, o que n\xe3o exceder\xe1 um per\xedodo de car\xeancia limitado ap\xf3s a data em que (i) o CRUSH deixar de ter um relacionamento com a Amazon ou (ii) quando o CRUSH solicitar a exclus\xe3o.","privacy-app-use-34":"Caso voc\xea publique postagens no App (o que \xe9 meramente opcional, n\xe3o o obrigamos), ser\xe1 utilizada a tecnologia de reconhecimento facial da Amazon, que nos permite detectar rostos e encontrar usu\xe1rios semelhantes a voc\xea (g\xeameos) dentro nosso sistema. Este \xe9 o \xfanico uso que fazemos desta tecnologia de reconhecimento.","privacy-app-use-35":"Nosso processador, a Amazon, est\xe1 comprometido com sua pr\xf3pria conformidade com o GDPR, bem como com o fornecimento de uma variedade de produtos, recursos, documenta\xe7\xe3o e recursos para ajudar seus clientes a cumprir suas obriga\xe7\xf5es de conformidade com o GDPR.","privacy-app-use-36":"Dados de uso do App:","privacy-app-use-37":"Tamb\xe9m coletamos automaticamente dados de uso do App, especificamente dados t\xe9cnicos e informa\xe7\xf5es relacionadas ao seu uso do App, incluindo o tipo de dispositivo m\xf3vel, o ID exclusivo do seu dispositivo m\xf3vel, o endere\xe7o IP do seu dispositivo m\xf3vel, o sistema operacional m\xf3vel, se qualquer, o tipo de navegador de Internet que utiliza e informa\xe7\xf5es sobre a forma como utiliza a App, como a frequ\xeancia e o tempo de utiliza\xe7\xe3o, os an\xfancios em que clicou, etc.","privacy-app-use-38":"Dados sobre voc\xea fornecidos por terceiros:","privacy-app-use-39":"Outros usu\xe1rios do App podem nos fornecer informa\xe7\xf5es sobre voc\xea quando usam nossos servi\xe7os; por exemplo, quando interagem com voc\xea ou se nos enviam uma den\xfancia envolvendo voc\xea.","privacy-app-use-40":"Quais s\xe3o as finalidades do tratamento dos seus dados pessoais?","privacy-app-use-41":"Cadastre-se e gerencie sua conta","privacy-app-use-42":"para que possamos verificar seu e-mail e idade para registr\xe1-lo no App, interagir com voc\xea e dar-lhe acesso aos nossos servi\xe7os.","privacy-app-use-43":"Gerir e executar a rela\xe7\xe3o contratual que nos une:","privacy-app-use-44":"realizamos diversas etapas necess\xe1rias para a execu\xe7\xe3o do contrato firmado com voc\xea, para que, por exemplo, possamos lhe prestar o servi\xe7o, entrar em contato para ajud\xe1-lo a tirar d\xfavidas, para verificar as informa\xe7\xf5es que voc\xea nos forneceu. Da mesma forma, podemos enviar-lhe comunica\xe7\xf5es de natureza administrativa, sobre atualiza\xe7\xf5es, altera\xe7\xf5es nas nossas condi\xe7\xf5es de servi\xe7o, alertas de seguran\xe7a, bem como responder a qualquer pedido ou exig\xeancia que nos envie.","privacy-app-use-45":"Publique seu conte\xfado.","privacy-app-use-46":"Quando voc\xea compartilha conte\xfados ou informa\xe7\xf5es atrav\xe9s do App, eles aparecem publicados para o p\xfablico que voc\xea selecionou que pode ver o que voc\xea compartilha. Para adicionar determinados conte\xfados, como fotos e v\xeddeos, voc\xea precisar\xe1 nos dar acesso \xe0 sua c\xe2mera ou galeria de fotos.","privacy-app-use-47":"Qualquer usu\xe1rio de nosso App pode visualizar seu nome de usu\xe1rio e perfil p\xfablico no App, que inclui conte\xfado que voc\xea compartilhou com o p\xfablico em geral. Al\xe9m disso, lembre-se de que seu conte\xfado publicado no App pode ser compartilhado por outros usu\xe1rios dentro ou fora do App, fa\xe7a uma captura de tela ou fa\xe7a o download.","privacy-app-use-48":"Publique conte\xfado sobre voc\xea.","privacy-app-use-49":"Outros usu\xe1rios do App podem criar e compartilhar conte\xfado com sua imagem ou dados com o p\xfablico de sua escolha. Se voc\xea n\xe3o se sentir confort\xe1vel com o conte\xfado que outras pessoas compartilharam sobre voc\xea, denuncie usando os formul\xe1rios do App ou entre em contato conosco por e-mail.","privacy-app-use-50":"Oferecer-lhe conte\xfados (not\xedcias, artigos, experi\xeancias, entre outros)","privacy-app-use-51":"criado diretamente pelo CRUSH ou em colabora\xe7\xe3o com pessoas externas que possam ser do seu interesse.","privacy-app-use-52":"Envio de notifica\xe7\xf5es push e alertas dentro do App.","privacy-app-use-53":"Se voc\xea autorizou, receber\xe1 nossas notifica\xe7\xf5es push em seu navegador da web ou em seu dispositivo m\xf3vel. As notifica\xe7\xf5es push podem incluir lembretes, comunica\xe7\xf5es promocionais, alertas e atualiza\xe7\xf5es sobre o App e os servi\xe7os.","privacy-app-use-54":"Se ativar estas notifica\xe7\xf5es, receber\xe1 avisos personalizados, com base num perfil que desenvolvemos sobre si e na utiliza\xe7\xe3o que faz da App. Para a personaliza\xe7\xe3o dos avisos, a informa\xe7\xe3o obtida atrav\xe9s dos dados por si introduzidos na App e o dados coletados sobre o uso do App (conte\xfado visitado) para criar um perfil em rela\xe7\xe3o aos seus interesses e oferecer a voc\xea principalmente o conte\xfado e a informa\xe7\xe3o que mais lhe conv\xe9m.","privacy-app-use-55":"Voc\xea pode desativar as notifica\xe7\xf5es push a qualquer momento ajustando as configura\xe7\xf5es em seu dispositivo m\xf3vel, embora a desativa\xe7\xe3o n\xe3o afete outras comunica\xe7\xf5es que voc\xea possa receber do CRUSH, como comunica\xe7\xf5es por e-mail.","privacy-app-use-56":"Preven\xe7\xe3o, dete\xe7\xe3o e repress\xe3o de atividades il\xedcitas ou contr\xe1rias \xe0s condi\xe7\xf5es do servi\xe7o ou que ponham em perigo a seguran\xe7a da informa\xe7\xe3o ou da App:","privacy-app-use-57":"O CRUSH poder\xe1 processar os dados para controlar e prevenir qualquer forma de abuso de nossos servi\xe7os, como atividades fraudulentas, ataques de nega\xe7\xe3o de servi\xe7o, envio de spam, acesso n\xe3o autorizado \xe0s contas de nossos usu\xe1rios, bem como qualquer outra pr\xe1tica contr\xe1ria \xe0 as Condi\xe7\xf5es Gerais e de Utiliza\xe7\xe3o da App ou ponha em perigo a seguran\xe7a da informa\xe7\xe3o ou a integridade da pr\xf3pria App, podendo eliminar o conte\xfado ou a conta que seja contr\xe1rio \xe0 lei, \xe0s nossas Condi\xe7\xf5es Gerais ou \xe0s Regras da comunidade.","privacy-app-use-58":"Neste \xe2mbito, inclui-se tamb\xe9m o tratamento de reclama\xe7\xf5es que apresente contra outros utilizadores ou que sejam apresentadas contra si, podendo contactar o CRUSH para an\xe1lise do caso concreto e garantindo que haver\xe1 interven\xe7\xe3o humana para corrigir ou rectificar o problema que nos surja.","privacy-app-use-59":"Tamb\xe9m podemos usar ferramentas para detectar conte\xfado impr\xf3prio (por exemplo, conte\xfado adulto ou violento) no conte\xfado visual que voc\xea publica.","privacy-app-use-60":"Para lhe oferecer um melhor servi\xe7o, os seus dados ser\xe3o tamb\xe9m tratados com a finalidade de:","privacy-app-use-61":"Ajud\xe1-lo a se conectar com outros usu\xe1rios, permitindo que voc\xea interaja com eles por meio de telas de bate-papo e outros mecanismos.","privacy-app-use-62":"Recomende voc\xea a outros usu\xe1rios semelhantes a voc\xea.","privacy-app-use-63":"Para fazer recomenda\xe7\xf5es, usamos as informa\xe7\xf5es que voc\xea nos fornece, incluindo informa\xe7\xf5es sobre sua localiza\xe7\xe3o, se voc\xea der sua permiss\xe3o, bem como informa\xe7\xf5es que obtemos de seu uso deste espa\xe7o (por exemplo, caracter\xedsticas das pessoas com quem voc\xea realmente interage) para desenvolva um perfil automatizado sobre voc\xea e, de prefer\xeancia, mostre os usu\xe1rios que correspondem ao seu perfil e o que voc\xea est\xe1 procurando.","privacy-app-use-64":"Neste sentido, ser\xe3o preferencialmente apresentados utilizadores ativos na App, que est\xe3o pr\xf3ximos de si, que correspondem \xe0s prefer\xeancias indicadas e ao seu perfil criado a partir das suas intera\xe7\xf5es, garantindo tamb\xe9m que as suas caracter\xedsticas e perfil correspondem \xe0s prefer\xeancias dos utilizadores recomendados.","privacy-app-use-65":"Fins estat\xedsticos e outros realizados com dados an\xf4nimos.","privacy-app-use-66":"Podemos anonimizar todas as informa\xe7\xf5es pessoais coletadas dos usu\xe1rios que usam o App para fins estat\xedsticos e outros, como treinamento de algoritmos, para medir a efic\xe1cia das campanhas publicit\xe1rias dispon\xedveis no App, a navegabilidade e usabilidade do App para poder melhorar o design, apresenta\xe7\xe3o e funcionalidades dispon\xedveis ou outros.","privacy-app-use-67":"Para mostrar publicidade:","privacy-app-use-68":"A nossa App poder\xe1 incluir publicidade que, mediante o seu consentimento, ser\xe1 personalizada de acordo com os seus gostos e prefer\xeancias.","privacy-app-use-69":"Qual \xe9 a base legal que nos permite tratar os seus dados? O fornecimento destes dados \xe9 obrigat\xf3rio?","privacy-app-use-70":"Executar e manter a rela\xe7\xe3o contratual entre as Partes.","privacy-app-use-71":"A raz\xe3o pela qual processamos suas informa\xe7\xf5es para os fins mencionados acima \xe9 para cumprir o contrato que temos com voc\xea.","privacy-app-use-72":"Consentimento.","privacy-app-use-73":"Algumas funcionalidades s\xe3o baseadas no seu consentimento expresso: (i) publica\xe7\xe3o de seu pr\xf3prio conte\xfado, (ii) acesso \xe0 c\xe2mera ou galeria de fotos para publicar determinado conte\xfado no App, (iii) acesso \xe0 geolocaliza\xe7\xe3o do dispositivo para recomenda\xe7\xe3o do usu\xe1rio por proximidade (iv) recep\xe7\xe3o de push notifications personalizados (v) apresenta\xe7\xe3o de conte\xfados publicit\xe1rios personalizados. Al\xe9m disso, se voc\xea decidir nos fornecer informa\xe7\xf5es volunt\xe1rias adicionais para completar seu perfil, essas informa\xe7\xf5es ser\xe3o usadas com base em seu consentimento.","privacy-app-use-74":"Lembre-se que pode revogar o seu consentimento a qualquer momento atrav\xe9s das configura\xe7\xf5es do seu dispositivo, apagando o seu conte\xfado ou atrav\xe9s das op\xe7\xf5es dispon\xedveis na App.","privacy-app-use-75":"Interesse leg\xedtimo.","privacy-app-use-76":"Os dados ser\xe3o tratados com base no nosso interesse leg\xedtimo em rela\xe7\xe3o \xe0 preven\xe7\xe3o de atividades il\xedcitas e outras relacionadas com a seguran\xe7a da App, para garantir a seguran\xe7a da rede e da informa\xe7\xe3o para prevenir eventos que possam comprometer a disponibilidade, autenticidade, integridade e confidencialidade dos dados pessoais ou da pr\xf3pria plataforma, bem como o cumprimento das normas da comunidade.","privacy-app-use-77":"Tamb\xe9m podemos mostrar publicidade n\xe3o personalizada por meio do App com base em nosso interesse leg\xedtimo.","privacy-app-use-78":"Caso pretenda obter mais informa\xe7\xf5es sobre a pondera\xe7\xe3o que efetu\xe1mos sobre os interesses leg\xedtimos do CRUSH relativamente \xe0s finalidades acima referidas, pode solicit\xe1-la escrevendo-nos para","privacy-app-use-79":"Tratamento de dados especialmente protegidos:","privacy-app-use-80":"Os dados relacionados com os seus interesses ou aspetos relacionados com a orienta\xe7\xe3o sexual ser\xe3o tratados com base no seu consentimento expl\xedcito.","privacy-app-use-81":"Por quanto tempo mantemos suas informa\xe7\xf5es?","privacy-app-use-82":"Manteremos todas as suas informa\xe7\xf5es pessoais enquanto nossa rela\xe7\xe3o contratual estiver em vigor, ou seja, at\xe9 que voc\xea exclua sua conta. Terminada a rela\xe7\xe3o contratual ou cancelada a sua conta, a CRUSH manter\xe1, bloqueada, toda a informa\xe7\xe3o durante os prazos previstos na lei para apurar condutas il\xedcitas ou lesivas, atender a eventuais responsabilidades e demonstrar o cumprimento das nossas obriga\xe7\xf5es.","privacy-app-use-83":"Em rela\xe7\xe3o ao conte\xfado publicado por voc\xea atrav\xe9s do nosso App, voc\xea deve levar em considera\xe7\xe3o que qualquer publica\xe7\xe3o ou coment\xe1rio que voc\xea tenha publicado em nossa comunidade permanecer\xe1 no App at\xe9 que voc\xea o exclua ou at\xe9 que voc\xea exclua sua conta. No entanto, qualquer outro conte\xfado em que voc\xea apare\xe7a e que tenha sido publicado por outros usu\xe1rios (por exemplo, fotos ou v\xeddeos) pode permanecer vis\xedvel at\xe9 que o referido usu\xe1rio o exclua ou feche sua conta.","privacy-app-use-84":"No entanto, reservamo-nos o direito de usar suas informa\xe7\xf5es de forma agregada ap\xf3s encerrar sua conta para fins estat\xedsticos e para melhorar nossos servi\xe7os. O uso de tais informa\xe7\xf5es n\xe3o permitir\xe1 que voc\xea seja identificado pessoalmente.","privacy-app-use-85":"A quem damos suas informa\xe7\xf5es pessoais?","privacy-app-use-86":"N\xe3o existem transfer\xeancias espec\xedficas dos seus dados pessoais para cumprir a finalidade indicada nesta sec\xe7\xe3o. No entanto, podemos recorrer aos servi\xe7os de prestadores de servi\xe7os, que ter\xe3o um acesso limitado aos dados e estar\xe3o sujeitos a um dever de confidencialidade (para mais informa\xe7\xf5es sobre a atua\xe7\xe3o dos nossos prestadores de servi\xe7os, consulte o ponto","privacy-app-use-87":"4. A quem damos suas informa\xe7\xf5es pessoais? > Prestadores de Servi\xe7os","privacy-app-use-88":"No entanto, lembre-se de que, ao postar conte\xfado em nosso App, voc\xea pode estar compartilhando informa\xe7\xf5es pessoais com outros usu\xe1rios (incluindo seu perfil p\xfablico).","privacy-app-use-89":"Al\xe9m disso, se algu\xe9m fizer uma den\xfancia que implique voc\xea, podemos notificar o reclamante sobre as a\xe7\xf5es que tomamos como resultado da den\xfancia, se houver.","privacy-cookies":"3.3. Navega\xe7\xe3o no Website (cookies)","privacy-cookies-1":"Em nosso Website, bem como em nosso App, usamos cookies ou outras ferramentas de rastreamento para coletar informa\xe7\xf5es sobre o uso que os usu\xe1rios fazem do Website e do App.","privacy-cookies-2":"Para obter mais informa\xe7\xf5es sobre o tratamento que realizamos atrav\xe9s dessas ferramentas de rastreamento, visite nossa","privacy-cookies-3":"Pol\xedtica de Cookies","privacy-social-profiles":"3.4. Perfis CRUSH nas redes sociais","privacy-social-profiles-1":"O CRUSH possui perfil nas principais redes sociais, como Twitter, Instagram, LinkedIn ou TikTok.","privacy-social-profiles-2":"Quando se torna seguidor de uma das nossas p\xe1ginas nas redes sociais, o tratamento dos dados reger-se-\xe1 pelas condi\xe7\xf5es de utiliza\xe7\xe3o, pol\xedticas de privacidade e regulamentos de acesso pertencentes \xe0 respetiva rede social e previamente aceites pelo utilizador.","privacy-social-profiles-3":"A CRUSH, neste sentido, tratar\xe1 os seus dados com a finalidade de gerir corretamente a sua presen\xe7a na rede social, informando-o sobre atividades, produtos ou servi\xe7os, bem como para qualquer outra finalidade que o regulamento das redes sociais o permita.","privacy-social-profiles-4":"Tenha em conta que n\xe3o temos influ\xeancia sobre a informa\xe7\xe3o que a rede social recolhe ou como a processa, pelo que recomendamos que se mantenha informado sobre a finalidade e \xe2mbito da recolha de informa\xe7\xe3o que se realiza atrav\xe9s das referidas redes sociais.","privacy-transfer":"4. A quem damos suas informa\xe7\xf5es pessoais?","privacy-transfer-1":"Em geral, do CRUSH n\xe3o comunicaremos seus dados a terceiros. No entanto, para al\xe9m das transfer\xeancias que expressamente indicamos na sec\xe7\xe3o em que explicamos as caracter\xedsticas das diferentes opera\xe7\xf5es (ponto 3), informamos sobre as comunica\xe7\xf5es que, em geral, podemos efetuar, bem como o seu fundamento legitimador, que afetam todos os tratamentos anteriores.","privacy-transfer-2":"Prestadores de servi\xe7os essenciais","privacy-transfer-3":"indispens\xe1veis \u200B\u200B\xe0 execu\xe7\xe3o do servi\xe7o que lhe oferecemos (por exemplo, empresas de alojamento inform\xe1tico ou plataformas de envio de comunica\xe7\xf5es comerciais). Sem preju\xedzo do anterior, estas entidades subscreveram os respetivos acordos de confidencialidade e apenas tratar\xe3o os seus dados de acordo com as nossas instru\xe7\xf5es, n\xe3o podendo utiliz\xe1-los para fins pr\xf3prios ou alheios ao servi\xe7o que nos prestam.","privacy-transfer-4":"Organismos p\xfablicos.","privacy-transfer-5":"Podemos divulgar \xe0s autoridades p\xfablicas competentes os dados e qualquer outra informa\xe7\xe3o que esteja na nossa posse ou que seja acess\xedvel atrav\xe9s dos nossos sistemas quando exista uma obriga\xe7\xe3o legal para o fazer, bem como quando exigido, por exemplo, quando o objetivo \xe9 prevenir ou processar o abuso de servi\xe7os ou atividades fraudulentas por meio de nosso Website ou App. Nestes casos, os dados pessoais que nos fornecer ser\xe3o conservados e disponibilizados \xe0s autoridades administrativas ou judiciais.","privacy-transfer-6":"No caso de opera\xe7\xe3o societ\xe1ria:","privacy-transfer-7":"No caso de fus\xe3o, aquisi\xe7\xe3o, venda total ou parcial de seus ativos, ou qualquer outro tipo de transa\xe7\xe3o societ\xe1ria envolvendo terceiros, podemos compartilhar, divulgar ou transferir dados do usu\xe1rio para a entidade sucessora (inclusive durante o pr\xe9- fase operat\xf3ria).","privacy-transfer-8":"Para terceiros ap\xf3s agrega\xe7\xe3o ou anonimiza\xe7\xe3o:","privacy-transfer-9":"podemos divulgar ou usar dados agregados ou an\xf4nimos (ou seja, dados que n\xe3o podem ser vinculados a uma pessoa f\xedsica identificada ou identific\xe1vel) para qualquer finalidade.","privacy-transfer-10":"A terceiros com o consentimento do usu\xe1rio ou outra base leg\xedtima:","privacy-transfer-11":"No caso de querermos partilhar dados com terceiros fora do \xe2mbito desta Pol\xedtica de Privacidade, ser\xe1 solicitado o seu consentimento, em qualquer caso, ou ser\xe1 informado sobre o mesmo e os seus fundamentos leg\xedtimos.","privacy-transfer-12":"Da mesma forma, informamos que esta Pol\xedtica de Privacidade se refere apenas \xe0 coleta, tratamento e uso de informa\xe7\xf5es (relativas a dados pessoais) por n\xf3s por meio da intera\xe7\xe3o que voc\xea realiza com nosso Website ou App. O acesso a p\xe1ginas da web de terceiros que voc\xea pode acessar por meio de links do Website ou do App t\xeam suas pr\xf3prias pol\xedticas de privacidade sobre as quais n\xe3o temos controle. Portanto, antes de fornecer qualquer informa\xe7\xe3o pessoal a eles, recomendamos que voc\xea se informe sobre suas Pol\xedticas de Privacidade.","privacy-eea":"5. Os seus dados pessoais s\xe3o transferidos para pa\xedses terceiros fora do Espa\xe7o Econ\xf3mico Europeu?","privacy-eea-1":"Alguns de nossos prestadores de servi\xe7os est\xe3o localizados em pa\xedses fora do Espa\xe7o Econ\xf4mico Europeu (","privacy-eea-2":"\'EEE\'","privacy-eea-3":"A localiza\xe7\xe3o destas empresas fora do EEE implica a exist\xeancia de uma transfer\xeancia internacional dos seus dados pessoais, o que pode significar um grau de prote\xe7\xe3o inferior ao previsto na regulamenta\xe7\xe3o europeia. No entanto, da CRUSH temos aplicado medidas para que as referidas transfer\xeancias n\xe3o originem um menor grau de prote\xe7\xe3o dos seus dados pessoais.","privacy-eea-4":"Neste sentido, os prestadores de servi\xe7os que se encontram fora do EEE assinaram as respetivas cl\xe1usulas contratuais padr\xe3o aprovadas pela Comiss\xe3o Europeia (","privacy-eea-5":"\'CCT\'","privacy-eea-6":") Acordo assinado entre ambas as entidades pelo qual a empresa n\xe3o pertencente \xe0 UE garante que aplica as normas europeias de prote\xe7\xe3o de dados.","privacy-eea-7":"Portanto, o uso desses provedores n\xe3o acarreta um menor grau de prote\xe7\xe3o de seus dados pessoais do que o uso de provedores localizados na Uni\xe3o Europeia. Pode consultar o conte\xfado do CCT no seguinte link:","privacy-eea-8":"A seguir, indicamos quais s\xe3o as transfer\xeancias internacionais que fazemos a partir do CRUSH:","privacy-eea-9":"Nome","privacy-eea-10":"Atividades afetadas","privacy-eea-11":"Pa\xeds","privacy-eea-12":"Mecanismo de transfer\xeancia","privacy-eea-13":"Tudo","privacy-eea-14":"Detec\xe7\xe3o de rosto e busca por rostos parecidos","privacy-eea-15":"Notifica\xe7\xf5es push","privacy-eea-16":"Enviar e-mails","privacy-eea-usa":"EUA","privacy-eea-sccs":"Cl\xe1usulas Contratuais Padr\xe3o (SCCs)","privacy-rights":"6. Quais s\xe3o os direitos que pode exercer como interessado?","privacy-rights-1":"Pode exercer os direitos que a lei lhe garante relativamente ao tratamento dos seus dados pessoais contactando o nosso Delegado de Prote\xe7\xe3o de Dados atrav\xe9s do email","privacy-rights-2":"Qualquer solicita\xe7\xe3o de direitos que recebermos ser\xe1 resolvida o mais r\xe1pido poss\xedvel e, em qualquer caso, dentro do prazo m\xe1ximo estabelecido por lei, a partir da data de recebimento. Em alguns casos, ser\xe1 necess\xe1rio solicitar uma c\xf3pia do seu documento de identidade ou outro documento de identifica\xe7\xe3o para verificar sua identidade.","privacy-rights-3":"Os direitos que lhe correspondem como parte interessada s\xe3o os seguintes:","privacy-rights-4":"Direito de retirar o consentimento concedido","privacy-rights-5":"Voc\xea pode revogar seu consentimento em rela\xe7\xe3o a todo o processamento baseado nele a qualquer momento. No entanto, a retirada do consentimento n\xe3o afetar\xe1 a legalidade do tratamento com base no consentimento anterior \xe0 sua retirada.","privacy-rights-6":"Direito de acesso","privacy-rights-7":"Tem o direito de saber quais os dados que est\xe3o a ser tratados, se aplic\xe1vel e, em caso afirmativo, de obter uma c\xf3pia dos mesmos, bem como de obter informa\xe7\xe3o relativa a:","privacy-rights-8":"a origem e destinat\xe1rios dos dados;","privacy-rights-9":"as finalidades para as quais s\xe3o tratados;","privacy-rights-10":"se existe um processo automatizado de tomada de decis\xe3o, incluindo a cria\xe7\xe3o de perfis;","privacy-rights-11":"o per\xedodo de reten\xe7\xe3o de dados; e","privacy-rights-12":"os direitos previstos nos regulamentos.","privacy-rights-13":"Direito de retifica\xe7\xe3o","privacy-rights-14":"Tem o direito de obter a retifica\xe7\xe3o dos seus dados pessoais ou de os completar quando estiverem incompletos.","privacy-rights-15":"Direito de apagar","privacy-rights-16":"Tem o direito de solicitar a elimina\xe7\xe3o dos seus dados pessoais se j\xe1 n\xe3o forem necess\xe1rios para a finalidade para a qual foram recolhidos ou, se for caso disso, se j\xe1 n\xe3o estivermos autorizados a trat\xe1-los.","privacy-rights-17":"Direito \xe0 portabilidade de dados","privacy-rights-18":"Tem o direito de solicitar a portabilidade dos seus dados no caso de tratamentos que se baseiem no seu consentimento ou na execu\xe7\xe3o de um contrato, desde que o tratamento tenha sido efetuado por meios automatizados. Caso exer\xe7a este direito, receber\xe1 os seus dados pessoais num formato estruturado, de uso corrente e leg\xedvel por qualquer dispositivo eletr\xf3nico. No entanto, pode tamb\xe9m solicitar, sempre que poss\xedvel, que os seus dados sejam transmitidos diretamente a outra empresa.","privacy-rights-19":"Direito de limitar o tratamento dos seus dados pessoais","privacy-rights-20":"Tem o direito de limitar o tratamento dos seus dados nos seguintes casos:","privacy-rights-21":"Quando tiver solicitado a retifica\xe7\xe3o dos seus dados pessoais, durante o per\xedodo em que verificamos a sua exatid\xe3o.","privacy-rights-22":"Quando considera que n\xe3o estamos autorizados a tratar os seus dados. Nesse caso, voc\xea pode nos pedir para limitar seu uso em vez de solicitar sua exclus\xe3o.","privacy-rights-23":"Quando considera que j\xe1 n\xe3o \xe9 necess\xe1rio que continuemos a tratar os seus dados e pretende que os conservemos para efeitos de exerc\xedcio ou defesa de reclama\xe7\xf5es.","privacy-rights-24":"Nos casos em que haja tratamento com base no nosso interesse leg\xedtimo e tenha exercido o seu direito de oposi\xe7\xe3o, pode solicitar-nos a limita\xe7\xe3o da utiliza\xe7\xe3o dos seus dados durante a verifica\xe7\xe3o da preval\xeancia desses interesses relativamente aos seus.","privacy-rights-25":"Direita de oposi\xe7\xe3o","privacy-rights-26":"Voc\xea tem o direito de se opor a qualquer momento ao processamento de seus dados pessoais com base em nosso interesse leg\xedtimo, incluindo a cria\xe7\xe3o de perfis.","privacy-rights-27":"Direito de reclamar junto da Autoridade de Controlo","privacy-rights-28":"Lembre-se de que, a qualquer momento, e no caso de considerar que violamos o seu direito \xe0 prote\xe7\xe3o de seus dados, voc\xea pode entrar em contato com a Autoridade de Controle correspondente em sua defesa, no caso da Espanha, a Ag\xeancia Espanhola de Prote\xe7\xe3o de Dados (","privacy-confidence":"7. Como garantimos a confidencialidade de suas informa\xe7\xf5es?","privacy-confidence-1":"A seguran\xe7a dos seus dados pessoais \xe9 uma prioridade para n\xf3s. Por esta raz\xe3o, a CRUSH implementou todas as medidas de seguran\xe7a necess\xe1rias para garantir a utiliza\xe7\xe3o e tratamento eficaz dos dados pessoais fornecidos pelo utilizador, salvaguardando a privacidade, privacidade, confidencialidade e integridade dos mesmos, e faz uso das t\xe9cnicas medi\xe1ticas necess\xe1rias para evitar a sua altera\xe7\xe3o, perda, acesso n\xe3o autorizado ou tratamento dos seus dados, de acordo com o estado da tecnologia em cada momento.","privacy-confidence-2":"Consequentemente, cumprimos os padr\xf5es de seguran\xe7a recomendados para proteg\xea-los. No entanto, \xe9 imposs\xedvel garantir totalmente a sua seguran\xe7a devido \xe0 pr\xf3pria natureza da Internet e porque pode haver a\xe7\xf5es maliciosas por parte de terceiros fora do nosso controle.","privacy-confidence-3":"Prometemos agir com rapidez e dilig\xeancia caso a seguran\xe7a dos dados esteja em perigo ou comprometida, e inform\xe1-lo sobre isso caso seja relevante.","privacy-modifications":"8. Altera\xe7\xf5es a esta pol\xedtica","privacy-modifications-1":"Desde CRUSH podemos modificar o conte\xfado desta Pol\xedtica de Privacidade a qualquer momento, especialmente quando houver modifica\xe7\xf5es legislativas, jurisprudenciais ou interpretativas da Ag\xeancia Espanhola de Prote\xe7\xe3o de Dados que afetem o tratamento de dados realizado por CRUSH atrav\xe9s do Website ou App. Qualquer novo vers\xe3o desta Pol\xedtica de Privacidade entrar\xe1 em vigor na data efetiva publicada.","privacy-modifications-2":"Se a vers\xe3o revisada incluir uma altera\xe7\xe3o substancial que afete o processamento de seus dados, notificaremos voc\xea com pelo menos 30 dias de anteced\xeancia, publicando um aviso em nosso Website ou App ou notificando voc\xea por e-mail. Em todo o caso, recomendamos que reveja periodicamente esta Pol\xedtica de Privacidade para estar informado sobre a forma como os seus dados pessoais s\xe3o tratados e protegidos, bem como sobre os seus direitos.","cookies-title":"Crush - Cookies","cookies-date":"\xdaltima modifica\xe7\xe3o: 8 dezembro, 2023","cookies-header":"Pol\xedtica de cookies","cookies-introduction-1":"Tanto no website www.crushsocialnetwork.com (doravante, o","cookies-introduction-2":"\'Website\'","cookies-introduction-3":") bem como atrav\xe9s da aplica\xe7\xe3o m\xf3vel para Smartphones com o nome \'Crush\' (doravante, o","cookies-introduction-4":"\'App\'","cookies-introduction-5":") usamos cookies ou outras ferramentas de rastreamento e rastreamento para coletar informa\xe7\xf5es sobre o uso que os usu\xe1rios fazem do Website e do App.","cookies-introduction-6":"Neste documento, voc\xea descobrir\xe1 quais cookies damos ao Cookie Monster, bem como qualquer outro tipo de informa\xe7\xe3o relacionada a esta maravilhosa mordida.","cookies-definition":"1. O que \xe9 um cookie?","cookies-definition-1":"Um cookie \xe9 um arquivo que \xe9 instalado no navegador do seu dispositivo (computador, celular, etc.) para armazenar e recuperar dados. Os cookies podem ter uma multiplicidade de finalidades, consoante para que foram configurados: por exemplo, guardar prefer\xeancias, recolher estat\xedsticas de utiliza\xe7\xe3o, habilitar funcionalidades t\xe9cnicas, entre outras.","cookies-responsible":"2. Quem \xe9 o respons\xe1vel?","cookies-responsible-1":"O respons\xe1vel pelo tratamento da informa\xe7\xe3o recolhida atrav\xe9s de cookies \xe9 a CRUSH SOCIAL NETWORK, Lda. (CRUSH), com NIF B-72599830 e morada em Calle Pintor Vel\xe1zquez, 3, 1, 30530 Cieza, Murcia (Espanha).","cookies-responsible-2":"Se voc\xea tiver alguma d\xfavida relacionada ao uso de cookies, escreva um e-mail para","cookies-responsible-3":"e n\xf3s responderemos a voc\xea o mais breve poss\xedvel.","cookies-data":"3. Que dados s\xe3o recolhidos atrav\xe9s de cookies?","cookies-data-1":"Quando acede ao Website ou instala e utiliza a App, mesmo que n\xe3o se tenha registado, s\xe3o recolhidas atrav\xe9s de cookies as seguintes informa\xe7\xf5es:","cookies-data-2":"Informa\xe7\xf5es do dispositivo: Durante o uso do Website ou do App, coletamos informa\xe7\xf5es sobre o dispositivo m\xf3vel a partir do qual voc\xea acessa a plataforma. As informa\xe7\xf5es que coletamos s\xe3o o modelo do dispositivo, sistema operacional e vers\xe3o, identificador exclusivo do dispositivo e rede.","cookies-data-3":"Informa\xe7\xe3o sobre a sua localiza\xe7\xe3o: Obtemos tamb\xe9m o endere\xe7o IP, fuso hor\xe1rio e qual \xe9 o fornecedor do servi\xe7o m\xf3vel, se for o caso, o que nos permite obter uma localiza\xe7\xe3o geral.","cookies-data-4":"Informa\xe7\xf5es de navega\xe7\xe3o do usu\xe1rio: coletamos informa\xe7\xf5es sobre o uso que voc\xea faz do Website e do App. Especificamente, a frequ\xeancia de uso, as se\xe7\xf5es que voc\xea visita, uso de fun\xe7\xf5es espec\xedficas, etc.","cookies-types":"4. Que tipos de cookies existem?","cookies-types-1":"De acordo com seu prop\xf3sito,","cookies-types-2":"podemos classificar os cookies entre os seguintes:","cookies-types-3":"Cookies t\xe9cnicos:","cookies-types-4":"Esses cookies s\xe3o estritamente necess\xe1rios para navegar no Website ou no App e permitem fun\xe7\xf5es b\xe1sicas, como navegar de uma se\xe7\xe3o para outra. Eles s\xe3o respons\xe1veis por aspectos t\xe9cnicos como a identifica\xe7\xe3o de perfis ou sess\xf5es e gerenciamento de prefer\xeancias de ferramentas no uso, intera\xe7\xe3o e localiza\xe7\xe3o de acesso ao conte\xfado. Pertencem tamb\xe9m a esta categoria, pela sua natureza t\xe9cnica, os cookies que permitem gerir, da forma mais eficiente poss\xedvel, os espa\xe7os publicit\xe1rios inclu\xeddos no Website e na App, sem recolher informa\xe7\xe3o dos utilizadores para diversas finalidades, tais como personalizar an\xfancios ou outros tipos de conte\xfado.","cookies-types-5":"Cookies estat\xedsticos:","cookies-types-6":"Estes cookies medem e recolhem informa\xe7\xe3o estat\xedstica relativa \xe0 utiliza\xe7\xe3o que o utilizador faz do Website ou da App, como o tempo de perman\xeancia na plataforma, o n\xfamero de visitas ou os conte\xfados visitados. A referida informa\xe7\xe3o permite-nos compreender a forma como os utilizadores interagem com o Website e a App, avaliar o desempenho, quais as sec\xe7\xf5es mais ou menos visitadas, incluindo a quantifica\xe7\xe3o do impacto dos an\xfancios introduzidos no Website e na App (se aplic\xe1vel). Ter essas informa\xe7\xf5es pode solucionar erros e melhorar o design do sistema e o conte\xfado oferecido por ele.","cookies-types-7":"Cookies de prefer\xeancia ou personaliza\xe7\xe3o:","cookies-types-8":"Os cookies de prefer\xeancia permitem que o Website ou o App lembrem informa\xe7\xf5es espec\xedficas do usu\xe1rio para que possam acessar o servi\xe7o com determinadas caracter\xedsticas que podem diferenciar sua experi\xeancia da de outros usu\xe1rios. Por exemplo, o seu idioma preferido ou a regi\xe3o a partir da qual acede, o n\xfamero de resultados a apresentar quando o utilizador realiza uma pesquisa, o aspeto ou conte\xfado do servi\xe7o em fun\xe7\xe3o do tipo de dispositivo a partir do qual o utilizador acede, etc.","cookies-types-9":"Cookies de publicidade comportamental:","cookies-types-10":"Estes cookies permitem a gest\xe3o dos espa\xe7os publicit\xe1rios que, conforme o caso, foram inclu\xeddos no Website ou na App. No entanto, a gest\xe3o dos espa\xe7os publicit\xe1rios \xe9 feita com base no perfil de navega\xe7\xe3o do utilizador. Esses cookies armazenam informa\xe7\xf5es de navega\xe7\xe3o do usu\xe1rio obtidas atrav\xe9s da observa\xe7\xe3o cont\xednua de seus h\xe1bitos de navega\xe7\xe3o, desenvolvendo um perfil de usu\xe1rio espec\xedfico, de modo que os an\xfancios que aparecem nesses espa\xe7os ser\xe3o personalizados para o usu\xe1rio de acordo com esses h\xe1bitos.","cookies-types-11":"Consoante a entidade que os gere:","cookies-types-12":"Cookies pr\xf3prios:","cookies-types-13":"s\xe3o aquelas que s\xe3o enviadas ao dispositivo do usu\xe1rio a partir de um computador ou dom\xednio administrado pelo respons\xe1vel pelo Website ou App, neste caso, CRUSH, e a partir do qual \xe9 prestado o servi\xe7o solicitado pelo usu\xe1rio.","cookies-types-14":"Cookies de terceiros:","cookies-types-15":"s\xe3o aqueles que s\xe3o enviados para o dispositivo do utilizador a partir de um computador ou dom\xednio que n\xe3o \xe9 gerido pelo respons\xe1vel do Website ou da App, mas por outra entidade que trata os dados obtidos atrav\xe9s dos cookies.","cookies-types-16":"Dependendo do tempo que permanecem ativos no dispositivo:","cookies-types-17":"Cookies de sess\xe3o:","cookies-types-18":"Eles s\xe3o projetados para coletar e armazenar dados durante o tempo em que o usu\xe1rio est\xe1 navegando no Website ou no App, e s\xe3o desativados no final da navega\xe7\xe3o.","cookies-types-19":"Cookies persistentes:","cookies-types-20":"Estes armazenam dados que podem ser acedidos e tratados durante um per\xedodo definido pelo respons\xe1vel pelo cookie. Suas vidas podem variar de minutos a anos.","cookies-used":"5. Quais cookies usamos especificamente em nossa plataforma?","cookies-used-1":"Na nossa plataforma, utilizamos os seguintes cookies:","cookies-used-2":"Nome","cookies-used-3":"Prop\xf3sito","cookies-used-4":"Cookies Pr\xf3prios/de Terceiros","cookies-used-5":"Expira\xe7\xe3o","cookies-used-6":"14 meses","cookies-used-7":"Indeterminada","cookies-used-stats":"Estatisticas","cookies-used-technical":"T\xe9cnico","cookies-used-third-party-google":"Terceiros (Google LLC.)","cookies-legitimation":"6. Qual \xe9 a base de legitima\xe7\xe3o que nos permite tratar os seus dados atrav\xe9s de cookies? Se sim, s\xe3o obrigat\xf3rios?","cookies-legitimation-1":"As informa\xe7\xf5es que coletamos por meio de cookies e outros dispositivos de rastreamento s\xe3o baseadas no seu consentimento, que solicitamos quando voc\xea acessa o Website ou quando instala o App por meio de um pop-up informativo ou da maneira estabelecida pelo Google (quando se trata de Android) ou Apple (quando se trata de iOS).","cookies-legitimation-2":"Nesse sentido, a qualquer momento voc\xea pode retirar seu consentimento conforme explicado na se\xe7\xe3o relacionada \xe0 revoga\xe7\xe3o do consentimento.","cookies-legitimation-3":"Os cookies t\xe9cnicos n\xe3o podem ser desativados, caso contr\xe1rio, o bom funcionamento do Website ou App seria comprometido. Em geral, eles s\xe3o definidos apenas em resposta a a\xe7\xf5es realizadas ao solicitar nossos servi\xe7os, como definir suas prefer\xeancias em rela\xe7\xe3o aos pr\xf3prios cookies, fazer login ou preencher formul\xe1rios. Caso ocorra a desativa\xe7\xe3o, isso pode fazer com que o uso de alguns dos servi\xe7os do Website ou do App seja limitado por n\xe3o poder acessar determinadas funcionalidades e, portanto, sua experi\xeancia seria menos satisfat\xf3ria.","cookies-transfer":"7. A quem damos suas informa\xe7\xf5es pessoais? Existem transfer\xeancias internacionais de dados?","cookies-transfer-1":"Utilizamos alguns cookies de terceiros, que s\xe3o aqueles cookies recolhidos e geridos por terceiros, pelo que as referidas entidades receber\xe3o os seus dados pessoais recolhidos atrav\xe9s de cookies para as finalidades indicadas para cada cookie. Esses tipos de cookies s\xe3o indicados na tabela da se\xe7\xe3o 5, como \'Cookies de terceiros\'. Esta tabela identifica o terceiro que gerencia cada cookie.","cookies-transfer-2":"Poder\xe1 informar-se sobre as transfer\xeancias para pa\xedses terceiros que, no seu caso, s\xe3o efetuadas pelos terceiros identificados nesta Pol\xedtica de Cookies nas respetivas pol\xedticas.","cookies-consent":"8. Qual \xe9 a forma de aceitar, negar ou revogar o consentimento para a utiliza\xe7\xe3o de cookies neste website?","cookies-consent-1":"Ao aceder pela primeira vez ao nosso Website ou \xe0 nossa App, ser-lhe-\xe1 apresentada uma janela na qual poder\xe1 indicar se aceita cookies ou se deseja configur\xe1-los ou rejeit\xe1-los, exceto os estritamente necess\xe1rios. Da mesma forma, voc\xea pode retirar o consentimento anteriormente concedido a qualquer momento.","cookies-consent-2":"Caso pretenda retirar o seu consentimento relacionado com a Pol\xedtica de Cookies a qualquer momento, tem duas op\xe7\xf5es: (i) retirar o seu consentimento atrav\xe9s dos bot\xf5es habilitados para o efeito nesta Pol\xedtica de Cookies; ou (ii) excluir os cookies armazenados no dispositivo por meio das defini\xe7\xf5es e configura\xe7\xf5es do seu navegador de Internet.","cookies-consent-3":"Tenha em conta que, se aceitar cookies de terceiros, dever\xe1 elimin\xe1-los das op\xe7\xf5es do navegador ou do sistema oferecido pelo pr\xf3prio terceiro.","cookies-consent-4":"Voc\xea pode expandir as informa\xe7\xf5es sobre como desativar os cookies, dependendo do seu navegador, nos seguintes links:","cookies-consent-5":"; para iOS:","cookies-rights":"9. Quais s\xe3o os direitos que pode exercer como interessado?","cookies-rights-1":"Os direitos que voc\xea tem como interessado em rela\xe7\xe3o \xe0 prote\xe7\xe3o de seus dados pessoais s\xe3o indicados na se\xe7\xe3o \'Quais s\xe3o os direitos que voc\xea pode exercer como interessado?\' dentro do","cookies-rights-2":"Pol\xedtica de Privacidade","cookies-modifications":"10. Modifica\xe7\xf5es a esta pol\xedtica","cookies-modifications-1":"Podemos atualizar a Pol\xedtica de Cookies de nossa plataforma de tempos em tempos. Por este motivo, recomendamos que reveja esta pol\xedtica sempre que aceda ao nosso Website ou App de forma a estar devidamente informado sobre como e para que utilizamos os cookies."}');

});

/**
 * @file Translation script.
 * @author Victorio Molina <https://github.com/VictorioMolina>
 * @copyright Crush Social Network 2022.
 * @license MIT
 * @module Scripts/Translation
 * @requires module:i18n.DOMTranslator
 */ /**
 * @file i18n.
 * @author Victorio Molina <https://github.com/VictorioMolina>
 * @copyright Crush Social Network 2022.
 * @license MIT
 * @module i18n
 */ /* eslint-disable no-param-reassign */ /* eslint-disable max-len */ /* eslint-disable global-require */ 
var $f1q41 = parcelRequire("f1q41");
/**
 * @file i18n constants.
 * @author Victorio Molina <https://github.com/VictorioMolina>
 * @copyright Crush Social Network 2022.
 * @license MIT
 * @module i18n/Constants
 */ /**
 * The website supported languages.
 *
 * @constant
 * @type {string[]}
 * @default ["en", "fr", "it", "pt", "es"]
 */ const $b0e477d24bf80d31$export$7c77c3a9bb93870d = [
    "en",
    "fr",
    "it",
    "pt",
    "es"
];
const $b0e477d24bf80d31$export$910b680d1eea6990 = $b0e477d24bf80d31$export$7c77c3a9bb93870d[0];


/**
 * @file i18n utility functions.
 * @author Victorio Molina <https://github.com/VictorioMolina>
 * @copyright Crush Social Network 2022.
 * @license MIT
 * @module i18n/Functions
 */ // eslint-disable-next-line import/prefer-default-export
/**
 * Gets the device's browser language.
 *
 * @memberof module:i18n/Functions
 * @function getNavigatorLanguage
 * @returns {string | undefined} The language of the browser
 */ var $f016eff6c6c0f364$export$2e2bcd8739ae039 = ()=>navigator.language ?? navigator.userLanguage;











/**
 * Translation getters.
 *
 * @memberof module:i18n
 * @namespace TranslationGetters
 * @readonly
 * @example
 * ```js
 * const englishTranslation = translationGetters["en"];
 *
 * console.log(englishTranslation("home.title"));
 * ```
 */ const $ba5960b1582b9f11$var$translationGetters = Object.freeze({
    /**
   * English translation getter.
   *
   * @inner
   * @memberof module:i18n.TranslationGetters
   * @function en
   * @returns {object} English translation.
   */ en: ()=>(parcelRequire("lEx3p")),
    /**
   * Spanish translation getter.
   *
   * @inner
   * @memberof module:i18n.TranslationGetters
   * @function es
   * @returns {object} Spanish translation.
   */ es: ()=>(parcelRequire("gqSMJ")),
    /**
   * French translation getter.
   *
   * @inner
   * @memberof module:i18n.TranslationGetters
   * @function fr
   * @returns {object} French translation.
   */ fr: ()=>(parcelRequire("g9BDX")),
    /**
   * Italian translation getter.
   *
   * @inner
   * @memberof module:i18n.TranslationGetters
   * @function it
   * @returns {object} Italian translation.
   */ it: ()=>(parcelRequire("kSrnd")),
    /**
   * Portuguese translation getter.
   *
   * @inner
   * @memberof module:i18n.TranslationGetters
   * @function pt
   * @returns {object} Portuguese translation.
   */ pt: ()=>(parcelRequire("gaKSI"))
});
const $ba5960b1582b9f11$export$d73ee8ef04f5226a = (scope, language = (0, $f016eff6c6c0f364$export$2e2bcd8739ae039)() ?? (0, $b0e477d24bf80d31$export$910b680d1eea6990), fallbackLanguage = (0, $b0e477d24bf80d31$export$910b680d1eea6990), fallbackText = "")=>{
    const formattedLocale = language.split(/[-_]/)[0]; // Short version: "en", "es", "it"...
    const translation = ($ba5960b1582b9f11$var$translationGetters[formattedLocale] ?? $ba5960b1582b9f11$var$translationGetters[fallbackLanguage])();
    return (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get(translation, scope) ?? (0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).get($ba5960b1582b9f11$var$translationGetters[0, $b0e477d24bf80d31$export$910b680d1eea6990](), scope, fallbackText);
};
const $ba5960b1582b9f11$export$625550452a3fa3ec = $ba5960b1582b9f11$export$d73ee8ef04f5226a;



class $60887fb632b9e853$export$2e2bcd8739ae039 {
    /**
   * Creates a DOM translator.
   *
   * @param {string} attribute
   *   HTML attribute which serves as a selector of the DOM elements
   *   to translate.
   * @param {string} [language]
   *   The locale of the language to which the DOM will be translated.
   * @param {string} [fallbackLanguage] - Fallback language.
   * @param {string} [fallbackText] - Fallback text.
   * @requires module:i18n/Functions.getNavigatorLanguage
   * @requires module:i18n/Constants.DEFAULT_LANGUAGE
   */ constructor(attribute, language = (0, $f016eff6c6c0f364$export$2e2bcd8739ae039)() ?? (0, $b0e477d24bf80d31$export$910b680d1eea6990), fallbackLanguage = (0, $b0e477d24bf80d31$export$910b680d1eea6990), fallbackText = ""){
        /**
     * Common HTML attribute of the translated nodes.
     *
     * @private
     * @type {string}
     */ this.attribute = attribute;
        /**
     * Language of the translation.
     *
     * @private
     * @type {string}
     */ this.language = language;
        /**
     * Fallback language of the translation.
     *
     * @private
     * @type {string}
     */ this.fallbackLanguage = fallbackLanguage;
        /**
     * Fallback text (used if the translation scope is not found).
     *
     * @private
     * @type {string}
     */ this.fallbackText = fallbackText;
    }
    /**
   * Sets the HTML document's language based on the defined properties.
   *
   * @private
   * @function _setHTMLLanguage
   * @returns {void} Nothing.
   * @requires module:i18n/Constants.SUPPORTED_LANGUAGES
   */ _setHTMLLanguage() {
        const language = (0, $b0e477d24bf80d31$export$7c77c3a9bb93870d).find((language)=>language === this.language) ?? this.fallbackLanguage;
        document.documentElement.setAttribute("lang", language);
    }
    /**
   * Parses and translates the DOM, and defines the document's language, based
   * on the defined properties.
   *
   * @function process
   * @returns {void} Nothing.
   * @requires module:i18n.t
   */ process() {
        const self = this;
        // Set the document's language
        self._setHTMLLanguage();
        document.querySelectorAll(`[${self.attribute}]`).forEach((element)=>{
            const scope = element.getAttribute(self.attribute);
            const translatedText = (0, $ba5960b1582b9f11$export$625550452a3fa3ec)(scope, self.language, self.fallbackLanguage, self.fallbackText);
            element.textContent = translatedText;
        });
    }
}





//
// Translate the DOM nodes
//
const $124accf050cf6d7e$var$translator = new (0, $60887fb632b9e853$export$2e2bcd8739ae039)("data-key");
$124accf050cf6d7e$var$translator.process();


//# sourceMappingURL=index.cf72d463.js.map
